<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card elevation="1" class="v-card-bottom-30 hidden-xs-only" >
      <v-card-title style="height: 60px">
        <h4>{{ use_language.connect }}</h4>
      </v-card-title>
    </v-card>

    <!-- ac 2 -->
    <v-card elevation="1" class="v-card-bottom-30" v-if="acBranchId == 686">
      <v-card-title>
        <!-- <v-img
          style="max-width: 30px !important"
          src="https://seeklogo.com/images/S/shopee-logo-DD5CAE562A-seeklogo.com.png"
        /> -->
        <span class="ml-3">{{ use_language.connect }} AC2</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), dialog_ac2=true"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} AC2</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="ac2Lsit.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="ac2Headers"
                :items="ac2Lsit"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.no="{ item }">
                  {{ ac2Lsit.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.isPackByPackhai="{ item }">
                  {{ item.isPackByPackhai == true ? 'Packhai' : 'AC2' }}
                </template>
                <template v-slot:item.edit="{ item }">
                  <a @click="openDialogAc2(item)"
                    ><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a
                  >
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="deleteAc2(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} AC2</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- shopee -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/shopee-logo.png"
        /><span class="ml-3">{{ use_language.connect }} Shopee</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), open_dialog_topup('shopee')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Shopee</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_shopee_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_shopee"
                :items="connect_shopee_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.no="{ item }">
                  {{ connect_shopee_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.isAutoInit="{ item }">
                  <v-row align="center">
                    <v-col align="center">
                      <div class="d-flex">
                        <v-switch
                          @change="update_IsAutoInit(item.id, item.isAutoInit, 'shopee')"
                          width="50px"
                          hide-details
                          v-model="item.isAutoInit"
                        >
                        </v-switch>
                        <v-btn @click="openDialogEdit(item, 'shopee')" v-if="item.isAutoInit == true" text color="warning">{{ use_language.edit }}</v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.shopeeShopName="{ item }">
                  {{  item.shopeeShopName  }}<span style="color:red">  {{  item.remark  }}</span>
                   <span v-if="synnexBranch.includes(BranchID)" style="color:grey;font-size: 10px;" >   
                      <br> 
                      {{ item.ediConnectionInfo? JSON.parse(item.ediConnectionInfo).InvoiceAccount+', '+JSON.parse(item.ediConnectionInfo).InventLocation:'' }}
                    </span>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ set_format_date_time(item.created) }}
                </template>
                <template v-slot:item.expired="{ item }">
                  {{ set_format_date_time(item.refresh_expired) }}
                </template>
                <template v-slot:item.isDelete="{ item }">
                  <a @click="DeleteShopShopee(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
                <template v-slot:item.synnex_IsCheckCost="{ item }">
                  {{ item.synnex_IsCheckCost? use_language.open:use_language.not_open }}
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_shop_connection }} Shopee</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

     <!-- shopee chat -->
    <v-card elevation="1" class="v-card-bottom-30" v-if="ChatFeature">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/shopee-logo.png"
        /><span class="ml-3">{{ use_language.connect }} Shopee Chat</span>
        <v-spacer />
        <v-btn
          outlined
          width="200"
          @click="connect_shopee_chat()"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Shopee Chat</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="item_table_shopee_chat.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_table_shopee_chat"
                :items="item_table_shopee_chat"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.no="{ item }">
                  {{ item_table_shopee_chat.indexOf(item) + 1 }}
                </template>
                 
                <template v-slot:item.shopeeShopName="{ item }">
                  {{  item.shopeeShopName  }}<span style="color:red">  {{  item.remark  }}</span>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ set_format_date_time(item.created) }}
                </template>
                <template v-slot:item.expired="{ item }">
                  {{ set_format_date_time(item.refresh_expired) }}
                </template>
                <template v-slot:item.isDelete="{ item }">
                  <a @click="delete_connect_shopee_chat(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Shopee Chat</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- lazada -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/lazada.png"
        /><span class="ml-3">{{ use_language.connect }} Lazada</span>
        <a
          class="pl-2"
          style="font-size: 12px"
          href="https://docs.google.com/document/d/1kT2y-etBjkfV5i2V3pZ-kOZOfWcJvJEqzUUaLgzibb8/edit?usp=sharing"
          target="_blank"
        >
          <b>{{ use_language.how_to_connect }} Lazada</b></a
        >
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), open_dialog_topup('lazada')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Lazada</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_lazada_data.length > 0"
            >

            <v-data-iterator
              :items="connect_lazada_data"
              :items-per-page="9999999999"
              hide-default-header
              hide-default-footer 
              style="color:black"
            >
              <template v-slot:default="{ items }">
                <v-card  v-for="item in items" :key="item.id"  style="border: 1px solid #d7d7d7;color:black">
                  <v-card-text style="color:black">
                    <v-row style="border-bottom: 1px solid #d7d7d7">
                      <v-col   cols="1" align="left">
                        <b>{{ use_language.number }}</b>
                      </v-col>
                      <v-col cols="2" align="left">
                        <b>ID {{ use_language.menu_manageshop }}</b>
                      </v-col>
                      <v-col cols="3" align="left">
                        <b>{{ use_language.shop_name_label }}</b>
                      </v-col>
                      <v-col cols="2" align="left">
                        <b>{{ use_language.creation_date }}</b>
                      </v-col>
                      <v-col cols="2" align="left">
                        <b>{{ use_language.expire }}</b>
                      </v-col>
                     
                      <v-col cols="1" align="left">
                        <b>{{ use_language.auto_pickup }}</b>
                      </v-col>
                      <v-col cols="1" align="center">
                        <b>{{ use_language.delete }}</b> 
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="1" align="left">
                        {{ connect_lazada_data.indexOf(item) + 1 }}
                      </v-col>
                      <v-col cols="2" align="left">
                        {{item.lazadaSellerId  }} <span  v-if="jaspalShop.includes(ShopID)"> {{'('+item.ap21_sale_code+')'}} </span>
                         <span v-if="synnexBranch.includes(BranchID)" style="color:grey;font-size: 10px;" >   
                          <br> 
                          {{  (item.synnex_IsCheckCost? use_language.enable_cost_check:use_language.no_cost_check)  }}
                        </span>
                      </v-col>
                      <v-col cols="3" align="left">
                        {{item.lazadaShopName  }} <span style="color:red" v-if="item.remark!=null && item.remark!=''">  {{  item.remark  }}</span>
                        <span v-if="synnexBranch.includes(BranchID)" style="color:grey;font-size: 10px;" >   
                          <br> 
                          {{ item.ediConnectionInfo? JSON.parse(item.ediConnectionInfo).InvoiceAccount+', '+JSON.parse(item.ediConnectionInfo).InventLocation:'' }}
                        </span>
                      
                      </v-col>
                      <v-col cols="2" align="left">
                        {{set_format_date_time(item.createDateTime)  }} 
                      </v-col>
                      <v-col cols="2" align="left">
                        {{set_format_date_time(item.refreshExpiresIn)  }} 
                      </v-col>
 
                      <v-col cols="1" align="left">
                        <v-switch
                          @change="update_IsAutoInit(item.id, item.isAutoInit, 'lazada')"
                          width="50px"
                          hide-details
                          v-model="item.isAutoInit"
                        ></v-switch>
                        <v-btn @click="openDialogEdit(item, 'lazada')" v-if="item.isAutoInit == true" text color="warning">{{ use_language.edit }}</v-btn>
                      </v-col>
                      <v-col cols="1" align="center">
                        <a @click="DeleteShopLazada(item)" ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a>
                      </v-col>
                    </v-row>
                 
                  </v-card-text>

                  <v-card-text> 
                    <v-card-text> 
                      <v-row>
                        <v-col cols="6">
                          {{ use_language.connected_warehouse }}
                        </v-col>
                        <v-col cols="6" align="right">
                        <a @click="GetShopLazadaWarehouseForAdd(item)">+ {{ use_language.add_warehouse_btn }}</a> 
                        </v-col >
                      </v-row>
                      <v-data-table
                        :headers="headers_lazada_warehouse"
                        :items="item.warehouseList"
                        class="elevation-0 packhai-border-table"
                        hide-default-footer
                        :items-per-page="10000"
                        mobile-breakpoint="0"
                      > 
                      <template v-slot:item.isDelete="{ item }">
                        <a @click="DeleteShopLazadaWarehouse(item)" >
                          <v-icon size="16" color="red darken-3">fa-trash-alt</v-icon>
                        </a>
                      </template>
                    </v-data-table>

                    </v-card-text>
                  </v-card-text>
                </v-card>
               
              </template>
            </v-data-iterator>
 
              <!-- <v-data-table
                :headers="headers_lazada"
                :items="connect_lazada_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.no="{ item }">
                  {{ connect_lazada_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.isAutoInit="{ item }">
                  <v-row align="center">
                    <v-col align="center"
                      ><v-switch
                        @change="update_IsAutoInit(item.id, item.isAutoInit, 'lazada')"
                        width="50px"
                        hide-details
                        v-model="item.isAutoInit"
                      ></v-switch
                    ></v-col>
                  </v-row>
                </template>
                <template v-slot:item.lazadaShopName="{ item }">
                  {{  item.lazadaShopName  }} <span style="color:red">  {{  item.remark  }}</span>
                </template>
                <template v-slot:item.createDateTime="{ item }">
                  {{ set_format_date_time(item.createDateTime) }}
                </template>
                <template v-slot:item.expired="{ item }">
                  {{ set_format_date_time(item.refreshExpiresIn) }}
                </template>
                <template v-slot:item.isDelete="{ item }">
                  <a @click="DeleteShopLazada(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table> -->
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_shop_connection }} Lazada</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

       <!-- lazada chat -->
    <v-card elevation="1" class="v-card-bottom-30" v-if="ChatFeature">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/lazada.png"
        /><span class="ml-3">{{ use_language.connect }} Lazada Chat</span>
        <v-spacer />
        <v-btn
          outlined
          width="200"
          @click="connect_lazada_chat()"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Lazada Chat</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="item_table_lazada_chat.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_table_lazada_chat"
                :items="item_table_lazada_chat"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.no="{ item }">
                  {{ item_table_lazada_chat.indexOf(item) + 1 }}
                </template>
                 
                <template v-slot:item.lazadaShopName="{ item }">
                  {{  item.lazadaShopName  }}<span style="color:red">  {{  item.remark  }}</span>
                </template>
                <template v-slot:item.createDateTime="{ item }">
                  {{ set_format_date_time(item.createDateTime) }}
                </template>
                <template v-slot:item.refresh_expires_in="{ item }">
                  {{ set_format_date_time(item.refresh_expires_in) }}
                </template>
                <template v-slot:item.isDelete="{ item }">
                  <a @click="delete_connect_lazada_chat(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Lazada Chat</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
 
    <!-- tiktok -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/TikTok-Logo-1.png"
        /><span class="ml-3">{{ use_language.connect }} Tiktok</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), open_dialog_topup('tiktok')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Tiktok</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_tiktok_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_tiktok"
                :items="connect_tiktok_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
              
                <template v-slot:item.No="{ item }">
                  {{ connect_tiktok_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.tiktok_shop_id="{ item }">
                  <!-- <div :style="'max-width:'+(window.width/2)+'px'">{{ item.access_token }} <a @click="copyTokenVrich(item.access_token)"><v-icon size="18" left>mdi-content-copy</v-icon></a> </div> -->
                  {{ item.tiktok_shop_id }}
                </template>
                <template v-slot:item.shop_name="{ item }">
                {{  item.shop_name  }}  <span style="color:red">  {{  item.remark  }}</span>
                 <span v-if="synnexBranch.includes(BranchID)" style="color:grey;font-size: 10px;" >   
                    <br> 
                    {{ item.ediConnectionInfo? JSON.parse(item.ediConnectionInfo).InvoiceAccount+', '+JSON.parse(item.ediConnectionInfo).InventLocation :''}}
                  </span>
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteApiauthen(item, 'tiktok')"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
                <template v-slot:item.createDateTime="{ item }">
                  {{ set_format_date_time(item.createDateTime) }}
                </template>
                <template v-slot:item.expired="{ item }">
                  {{ set_format_date_time(item.refresh_expires_in) }}
                </template>
                <template v-slot:item.isAutoInit="{ item }">
                  <v-row align="center">
                    <v-col align="center">
                      <div class="d-flex">
                        <v-switch
                          @change="update_IsAutoInit(item.id, item.isAutoInit, 'tiktok')"
                          width="50px"
                          hide-details
                          v-model="item.isAutoInit"
                        >
                        </v-switch>
                        <v-btn @click="openDialogEdit(item, 'tiktok')" v-if="item.isAutoInit == true" text color="warning">{{ use_language.edit }}</v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                 <template v-slot:item.synnex_IsCheckCost="{ item }">
                  {{ item.synnex_IsCheckCost? use_language.open:use_language.not_open }}
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_shop_connection }} tiktok</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

     <!-- line my shop -->
    <v-card elevation="1" class="v-card-margin-bottom-30">
      <v-card-title class="height-57">
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/linemyshop.png"
        /><span class="ml-3">{{ use_language.connect }} Line MyShop</span>
        <a
          class="pl-2"
          style="font-size: 12px"
          href="https://docs.google.com/document/d/1NkJGRPvti0kXgr-uBAZUwhvkVMSqk_ywOaloG8d4SAQ/edit?usp=sharing"
          target="_blank"
        >
          <b>{{ use_language.how_to_connect }} Line MyShop</b></a
        >
        <v-spacer />
        <v-btn width="160" @click="open_dialog_line_my_shop(null, 'add')" color="primary" outlined
          ><v-icon left>fa-plus</v-icon> Line MyShop</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <input
          id="token-line-my-shop"
          style="width: 100%"
          type="hidden"
          v-model="token_line"
        />
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="line_my_shop_data_list.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_line_my_shop"
                :items="line_my_shop_data_list"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ line_my_shop_data_list.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.token="{ item }">
                  <div :style="'max-width:' + window.width / 2 + 'px'">
                    {{ item.token }}
                    <a @click="copyTokenLineMyshop(item.token)"
                      ><v-icon size="18" left>mdi-content-copy</v-icon></a
                    >
                  </div>
                </template>
                <template v-slot:item.callBackUrl="{ item }">
                  <div :style="'max-width:' + window.width / 2 + 'px'">
                    {{ item.callBackUrl }}
                    <a @click="copyTokenLineMyshop(item.callBackUrl)"
                      ><v-icon size="18" left>mdi-content-copy</v-icon></a
                    >
                  </div>
                </template>
                <template v-slot:item.edit="{ item }">
                  <a @click="open_dialog_line_my_shop(item, 'edit')"
                    ><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a
                  >
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteApiauthen(item, 'lineMyShop')"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Line MyShop</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- woo -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/woo.png"
        /><span class="ml-3">{{ use_language.connect }} Woo Commerce</span>
        <a
          class="pl-2"
          style="font-size: 12px"
          href="https://docs.google.com/document/d/18Sszoy_pS9sKHQFul_P7n_38v8i_yN6WA2_jUg6jVMo/edit?usp=sharing"
          target="_blank"
        >
          <b>{{ use_language.how_to_connect }} Woo Commerce</b></a
        >
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="SetShopWoo(null), (editVrich = false), open_dialog_topup('woo')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Woo</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_woo_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_woo"
                :items="connect_woo_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_woo_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.edit="{ item }">
                  <a
                    @click="
                      SetShopWoo(item), (editVrich = false), open_dialog_topup('woo')
                    "
                    ><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a
                  >
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteWoo(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} woo</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

   <!-- shopify -->
   <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/Screenshot+2024-03-09+004759.png"
        /><span class="ml-3">{{ use_language.connect }} Shopify</span>
        <a
          class="pl-2"
          style="font-size: 12px"
          href="https://docs.google.com/document/d/1DAxak509gDZw-5ULROYo6iMrstGoC7HHfdzH3p3O2Cs/edit?usp=sharing"
          target="_blank"
        >
          <b>{{ use_language.how_to_connect }} Shopify</b></a
        >
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="SetShopShopify(null), (editVrich = false), open_dialog_topup('shopify')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Shopify</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_shopify_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_shopify"
                :items="connect_shopify_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_shopify_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.edit="{ item }">
                  <a
                    @click="
                      SetShopShopify(item), (editVrich = false), open_dialog_topup('shopify')
                    "
                    ><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a
                  >
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteShopify(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} shopify</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <!-- vrich -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://dewteerapat.vrich619.com/img/logo.png"
        /><span class="ml-3">{{ use_language.connect }} Vrich</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), open_dialog_topup('vrich')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Vrich</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <input id="token-vrich" style="width: 100%" type="hidden" v-model="token" />
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_vrich_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_vrich"
                :items="connect_vrich_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_vrich_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.token="{ item }">
                  <div :style="'max-width:' + window.width / 2 + 'px'">
                    {{ item.token }}
                    <a @click="copyTokenVrich(item.token)"
                      ><v-icon size="18" left>mdi-content-copy</v-icon></a
                    >
                  </div>
                </template>
                <template v-slot:item.edit="{ item }">
                  <a @click="Edit_Vrich(item), open_dialog_topup('vrich')"
                    ><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a
                  >
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteApiauthen(item, 'vrich')"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_shop_connection }} Vrich</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- zwiz -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/zwizlogo.jpg"
        /><span class="ml-3">{{ use_language.connect }} zwiz</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), open_dialog_topup('zwiz')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} zwiz</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_zwiz_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_zwiz"
                :items="connect_zwiz_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_zwiz_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.token="{ item }">
                  <div :style="'max-width:' + window.width / 2 + 'px'">
                    {{ item.token }}
                    <a @click="copyTokenVrich(item.token)"
                      ><v-icon size="18" left>mdi-content-copy</v-icon></a
                    >
                  </div>
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteApiauthen(item, 'zwiz')"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} zwiz</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- telegram bot -->
    <v-card elevation="1" class="v-card-bottom-30">
      <div id="telegram-login-container" style="display:none;"></div>
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="@/assets/Telegram-logo.webp" 
        /><span class="ml-3">{{ use_language.connect }} Telegram</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), open_dialog_topup('telegram bot')"
          color="primary"
          ><v-icon left>fa-plus</v-icon>Telegram</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
       
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_telegram_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_telegram"
                :items="connect_telegram_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_telegram_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.chatID="{ item }">
                  {{ item.chatID }}
                </template>
                <template v-slot:item.typeName="{ item }">
                  {{ item.typeName + " " + (item.time != null ? item.time : "") }}
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteTelegram(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Telegram</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- line notify -->
    <!-- <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/line.png"
        /><span class="ml-3">เชื่อมต่อ Line Notify</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), open_dialog_topup('line notify')"
          color="primary"
          ><v-icon left>fa-plus</v-icon>Line Notify</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
       
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_line_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_line"
                :items="connect_line_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_line_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.token="{ item }">
                  {{ item.token }}
                </template>
                <template v-slot:item.typeName="{ item }">
                  {{ item.typeName + " " + (item.time != null ? item.time : "") }}
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteApiauthen(item, 'linenotify')"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>ไม่มีการเชื่อมต่อ Line Notify</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card> -->

    <!-- line oa -->
    <v-card elevation="1" class="v-card-bottom-30" v-if="ChatFeature">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/lineoa.png"
        /><span class="ml-3">{{ use_language.connect }} Line OA</span>
        <a
          class="pl-2"
          style="font-size: 12px"
          href="https://docs.google.com/document/d/1Ofu4uoEFsc4xaH0vIISqdQLkYkNDXpGOSH2UOoO2Qzw/edit?usp=sharing"
          target="_blank"
        >
          <b>{{ use_language.how_to_connect }} Line Official Account</b></a
        >
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="(editVrich = false), open_dialog_topup('lineOa')"
          color="primary"
          ><v-icon left>fa-plus</v-icon>Line OA</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_lineoa_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_lineoa"
                :items="connect_lineoa_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_lineoa_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.webhookUrl="{ item }">
                  <div>
                    {{ item.webhookUrl }}
                     
                  </div>
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteLineOA(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Line OA</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- fackbook-->
    <v-card elevation="1" class="v-card-bottom-30" v-if="ChatFeature">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://rtms3.s3.ap-southeast-1.amazonaws.com/packhai/packhai_shop/logo-facebook.png"
        /><span class="ml-3">{{ use_language.connect }} Facebook</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="loginFacebookPage"
          color="primary"
          ><v-icon left>fa-plus</v-icon>Fackbook</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_fackbook_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_fackbook"
                :items="connect_fackbook_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_fackbook_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.pagePictureURL="{ item }">
                  <img style="width: 30px;border-radius:100px !important" :src="item.pagePictureURL" @click="image_click(item.pagePictureURL)"/>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ set_format_date_time(item.created) }}
                </template>
                <template v-slot:item.isDelete="{ item }">
                  <a @click="deleteFacebook(item)">
                    <v-icon size="16" color="red darken-3">fa-trash-alt</v-icon>
                  </a>
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Fackbook</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- plugo-->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/plugo.png"
        /><span class="ml-3">{{ use_language.connect }} Plugo</span>
        <!-- <a
          class="pl-2"
          style="font-size: 12px"
          href="https://docs.google.com/document/d/18Sszoy_pS9sKHQFul_P7n_38v8i_yN6WA2_jUg6jVMo/edit?usp=sharing"
          target="_blank"
        >
          <b>วิธีการเชื่อมต่อ Plugo</b></a
        > -->
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="SetShopPlugo(null), (editVrich = false), open_dialog_topup('plugo')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Plugo</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_plugo_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_plugo"
                :items="connect_plugo_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_plugo_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.edit="{ item }">
                  <a
                    @click="
                      SetShopPlugo(item), (editVrich = false), open_dialog_topup('plugo')
                    "
                    ><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a
                  >
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeletePlugo(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Plugo</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <!-- Amaze -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3-ap-southeast-1.amazonaws.com/Shop/2025-07/202507041151SSd81938c0"
        /><span class="ml-3">{{ use_language.connect }} Amaze</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="SetShopAmaze(null), (editVrich = false), open_dialog_topup('amaze')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Amaze</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_amaze_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_amaze"
                :items="connect_amaze_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_amaze_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteAmaze(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Amaze</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Makro -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/maknet_logo.jpg"
        /><span class="ml-3">{{ use_language.connect }} Makro</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="SetShopMakro(null), (editVrich = false), open_dialog_topup('makro')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} Makro</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_makro_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_Makro"
                :items="connect_makro_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_makro_data.indexOf(item) + 1 }}
                </template>
                 <template v-slot:item.created="{ item }">
                  {{ set_format_date_time(item.created) }}
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteMakro(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} Makro</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Nexgen -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/nexgen.png"
        /><span class="ml-3">{{ use_language.connect }} NexGen</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="SetShopNexgen(null), (editVrich = false), open_dialog_topup('nexgen')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} NexGen</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_nexgen_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_nexgen"
                :items="connect_nexgen_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_nexgen_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteNexgen(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} NexGen</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <!-- bento -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/bentoweb.png"
        /><span class="ml-3">{{ use_language.connect }} BentoWeb</span>
        <v-spacer />
        <v-btn
          outlined
          width="160"
          @click="SetShopBentoWeb(null), (editVrich = false), open_dialog_topup('bentoweb')"
          color="primary"
          ><v-icon left>fa-plus</v-icon> {{ use_language.connect }} BentoWeb</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_bentoweb_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_bentoweb"
                :items="connect_bentoweb_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_bentoweb_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteBentoWeb(item)"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }} BentoWeb</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- fackbook 2-->
    <!-- <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <v-img
          style="max-width: 30px !important"
          src="https://rtms3.s3.ap-southeast-1.amazonaws.com/packhai/packhai_shop/logo-facebook.png"
        /><span class="ml-3">เชื่อมต่อ Facebook</span>
        <v-spacer />
          <v-btn
            outlined
            width="160"
            @click="(editVrich = false), open_dialog_topup('fackbook')"
            color="primary"
          ><v-icon left>fa-plus</v-icon>Fackbook</v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_fackbook_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_fackbook"
                :items="connect_fackbook_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_fackbook_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.pagePictureURL="{ item }">
                  <img style="width: 60px" :src="item.pagePictureURL"/>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ set_format_date_time(item.created) }}
                </template>
                <template v-slot:item.isDelete="{ item }">
                  <a @click="deleteFacebook(item)">
                    <v-icon size="16" color="red darken-3">fa-trash-alt</v-icon>
                  </a>
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>ไม่มีการเชื่อมต่อ Fackbook</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card> -->

    <!-- callbacl url -->
    <!-- <v-card v-if="shop.is_Active" elevation="1" class="v-card-margin-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="40" color="info">mdi-transfer</v-icon><span class="ml-2">ตั้งค่า url callback</span>
        <v-btn @click="delete_shop_call_back_url()" icon><v-icon size="20" color="danger">mdi-delete</v-icon></v-btn>
        <v-spacer/>
        <v-switch v-model="data_callback.isActive" @change="add_update_shop_call_back_url()" label="สถานะ" color="success" class="px-3" hide-details></v-switch>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2" lg="1" class="pt-5">
            <span> <b>Call Back Url</b> : </span>
          </v-col>
          <v-col align="left" cols="12" md="4" lg="4">
            <v-text-field
              v-model="data_callback.urlCallback"
              ref="refUrlCallback"
              autocomplete="off"
              :disabled="!data_callback.isActive"
              hide-details
              dense
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-divider/>


        <v-row>
          <v-col class="pb-4" align="left" cols="6" md="10">
            <b>สถานะ</b>
          </v-col>
          <v-col class="pb-4" align="left" cols="6" md="2">
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-1" align="left" cols="6" md="10">
            <b>รอแพ็ค</b>
          </v-col>
          <v-col class="py-1" align="center" cols="6" md="2">
            <v-switch
              v-model="data_callback.statusWaitPack"
              :disabled="!data_callback.isActive"
              @change="add_update_shop_call_back_url()"
            ></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-1" align="left" cols="6" md="10">
            <b>แพ็คเรียบร้อย</b>
          </v-col>
          <v-col class="py-1" align="center" cols="6" md="2">
            <v-switch
              v-model="data_callback.statusPacked"
              :disabled="!data_callback.isActive"
              @change="add_update_shop_call_back_url()"
            ></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-1" align="left" cols="6" md="10">
            <b>ขนส่งเข้ารับ</b>
          </v-col>
          <v-col class="py-1" align="center" cols="6" md="2">
            <v-switch
              v-model="data_callback.statusReady"
              :disabled="!data_callback.isActive"
              @change="add_update_shop_call_back_url()"
            ></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-1" align="left" cols="6" md="10">
            <b>จัดส่งสำเร็จ</b>
          </v-col>
          <v-col class="py-1" align="center" cols="6" md="2">
            <v-switch
              v-model="data_callback.statusSent"
              :disabled="!data_callback.isActive"
              @change="add_update_shop_call_back_url()"
            ></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-1" align="left" cols="6" md="10">
            <b>ยกเลิก</b>
          </v-col>
          <v-col class="py-1" align="center" cols="6" md="2">
            <v-switch
              v-model="data_callback.statusCancel"
              :disabled="!data_callback.isActive"
              @change="add_update_shop_call_back_url()"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1" align="right" cols="12">
            <v-btn :disabled="!data_callback.isActive" @click="add_update_shop_call_back_url()" color="primary"> บันทึก </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card> -->

    <!-- token -->
    <v-card elevation="1" class="v-card-margin-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="30" color="warning">mdi-link</v-icon
        ><span class="ml-2">{{ use_language.create_external_token }}</span>
         <a
          class="pl-2"
          style="font-size: 12px"
          href="https://docs.google.com/document/d/1H57V_9_D0SuJ3diWG45HMuDejyPY8qgXE3r0VBQWrug/edit?usp=sharing"
          target="_blank"
        >
          <b>API Document</b></a
        >
        <v-spacer />
        <v-btn width="160" @click="open_dialog_token()" color="primary" outlined
          ><v-icon left>fa-plus</v-icon> {{ use_language.create }} Token</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row row>
          <v-col class="pb-0" cols="12" md="12">
            <div
              v-if="connect_token_data.length > 0"
              style="max-height: 500px; min-height: 150px"
              class="overflow-y-auto"
            >
              <v-data-table
                :headers="headers_token"
                :items="connect_token_data"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.No="{ item }">
                  {{ connect_token_data.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.token="{ item }">
                  <div :style="'max-width:' + window.width / 4 + 'px'">
                    {{ item.token }}
                    <a @click="copyTokenVrich(item.token)"
                      ><v-icon size="18" left>mdi-content-copy</v-icon></a
                    >
                  </div>
                </template>
                <template v-slot:item.webhookSetting="{ item }">
                  <a @click="open_dialog_update_webhook(item, 'token')"
                    > {{ use_language.menu_settings }}</a
                  >
                </template>
                <template v-slot:item.delete="{ item }">
                  <a @click="DeleteApiauthen(item, 'token')"
                    ><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a
                  >
                </template>
              </v-data-table>
            </div>
            <div v-else align="center">
              <h3>{{ use_language.no_connection }}</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- peak -->
    <v-card elevation="1" class="v-card-margin-bottom-30" v-show="peak.FirstTimeCheck">
        <v-card-title class="height-70">
            <img src="https://www.uob.co.th/bizsmart/assets/img/logos/peak-logo.png" height="70%"/>
        <span class="ml-2">{{ use_language.connect }} PEAK</span>
        <v-spacer />
        <v-switch
          v-model="peak.IsDelete"
          :label="StockMarketplaceActive(peak.IsDelete)"
          color="success"
          class="px-3"
          hide-details
        ></v-switch>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="2" class="py-5">
            <h3 class="fn-14 mb-3">Token {{ use_language.from_system }} PEAK</h3>
          </v-col>
          <v-col cols="4">
            <v-text-field
                    v-model="peak.Token"
                    autocomplete = "off"
                    outlined
                    required
                    danse hide-details
                    ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn
              :elevation="1"
              color="primary"
              @click="handleCheckTokenAuthenClick()"
            >
              <!-- <v-icon size="20" class="mr-1">mdi-content-save</v-icon> -->
              <span class="fn-14"><b> {{ use_language.save_token }} </b></span>
            </v-btn>
          </v-col>
          <v-col class="py-4" align="left"> 
            <v-icon v-if="peak.PaymentMethodCheck === 1" size="18" left color="green">mdi-check-bold </v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" class="py-5">
            <h3 class="fn-14 mb-3">{{ use_language.sending_data_to_system }} PEAK</h3>
          </v-col>
          <v-col cols="10">
            <v-radio-group
                                row
                                required
                                class="mb-3 is-cod-selector"
                                dense hide-details
                                :disabled="!peak.nextStepAuthen"
                                v-model="peak.sendOrder"
                            >
                                <v-radio :label="use_language.send_all_orders_to_system + ' PEAK'" :value="true"> 
                                    <template v-slot:label> <span>{{ use_language.send_all_orders_to_system }} PEAK</span></template>
                                </v-radio>
            </v-radio-group>
          <v-row v-if="peak.sendOrder">
                  <span class="pl-5 pr-4 pt-3"> {{ use_language.contact_code }} </span>
                  <v-text-field
                    :value="peak.contact"
                    @change="(value) => (peak.contact = Trim_value(value))"
                    outlined
                    dense
                    hide-details
                    autocomplete="off"
                    class="maxwidth-150"
                  ></v-text-field>
                  <!-- <v-icon v-if=".contacValidate == 1" size="18" left color="green">mdi-check-bold </v-icon>
                  <v-icon v-else-if="j.contacValidate == 2" size="18" left color="red">mdi-close</v-icon> -->
                    
                  <span class="pl-5 pr-4 pt-3"> {{ use_language.finance_channel }} </span>
                  <v-text-field
                    :value="peak.MethodCode"
                    @change="(value) => (peak.MethodCode = Trim_value(value))"
                    outlined
                    dense
                    hide-details
                    autocomplete="off"
                    class="maxwidth-150"
                  ></v-text-field>
                  <!-- <v-icon v-if="j.productIDValidate === 1" size="18" left color="green">mdi-check-bold </v-icon>
                  <v-icon v-else-if="j.productIDValidate === 2" size="18" left color="red">mdi-close</v-icon> -->
          </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" class="py-5">
          </v-col>
          <v-col cols="10">
            <v-radio-group
                                row
                                required
                                class="mb-2 is-cod-selector"
                                dense hide-details
                                :disabled="!peak.nextStepAuthen"
                                v-model="peak.sendOrder"
                            >
                            <v-radio :label="use_language.send_daily_summary_to_peak + '(เวลา 24.00 น.)'" :value="false">
                                  <template v-slot:label> <span>{{ use_language.send_daily_summary_to_peak }}(เวลา 24.00 น.)</span> </template>
                            </v-radio>
            </v-radio-group>
          <v-row v-if="!peak.sendOrder">
          <v-col cols="12">
            <span v-for="(j, indexj) in peak.marketplaceList" :key="indexj">
              <span v-if="j.isActive" class="v-list-item">
                <v-checkbox
                  v-model="j.select"
                  color="info"
                  hide-details
                  :disabled="!peak.nextStepAuthen"
                  @click="handleSelectCheckboxMarketplace(j)"
                ></v-checkbox>
                <v-avatar
                  v-if="j.photoLink != '' && j.photoLink != null"
                  size="25"
                  tile
                  style="padding: 1px"
                >
                  <img :src="j.photoLink" />
                </v-avatar>
                <span class="pl-5 pr-4"> {{ use_language.contact_code }} </span>
                <v-text-field
                  :value="j.contac"
                  @change="(value) => (j.contac = Trim_value(value))"
                  outlined
                  dense
                  hide-details
                  :disabled='!j.select'
                  autocomplete="off"
                  class="maxwidth-150"
                  @blur="onChangeCheckContact(j,peak.marketplaceList.indexOf(j))"
                ></v-text-field>
                <v-icon v-if="j.contacValidate == 1" size="18" left color="green">mdi-check-bold </v-icon>
                <v-icon v-else-if="j.contacValidate == 2" size="18" left color="red">mdi-close</v-icon>
                <span class="pl-5 pr-4"> {{ use_language.product_number }} </span>
                <v-text-field
                  :value="j.productID"
                  @change="(value) => (j.productID = Trim_value(value))"
                  outlined
                  dense
                  hide-details
                  :disabled='!j.select'
                  autocomplete="off"
                  class="maxwidth-150"
                  @blur="onChangeCheckProduct(j,peak.marketplaceList.indexOf(j))"
                ></v-text-field>
                <v-icon v-if="j.productIDValidate === 1" size="18" left color="green">mdi-check-bold </v-icon>
                <v-icon v-else-if="j.productIDValidate === 2" size="18" left color="red">mdi-close</v-icon>
                <span class="pl-5 pr-4"> {{ use_language.finance_channel }} </span>
                <v-text-field
                  :value="j.MethodCode"
                  @change="(value) => (j.MethodCode = Trim_value(value))"
                  outlined
                  dense
                  hide-details
                  :disabled='!j.select'
                  autocomplete="off"
                  class="maxwidth-150"
                ></v-text-field>
                <!-- <v-icon v-if="j.productIDValidate === 1" size="18" left color="green">mdi-check-bold </v-icon>
                <v-icon v-else-if="j.productIDValidate === 2" size="18" left color="red">mdi-close</v-icon> -->
              </span>
              
            </span>
          </v-col>
        </v-row>
          </v-col>
        </v-row>


        <v-row class="py-0">
          <v-col cols="12" md="12" class="py-0" align="right">
            <v-btn
              :elevation="1"
              color="primary"
              class="px-5"
              @click="handleUpdatePeakClick()"
              :disabled="!peak.nextStepAuthen"
            >
              <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
              <span class="fn-14"><b> {{ use_language.button_save }} </b></span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- marketplace -->
    <v-card   elevation="1" class="v-card-margin-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="30" color="orange darken-3">mdi-cog</v-icon
        ><span class="ml-2">{{ use_language.configure_the }} Sync Stock</span>
        
        <v-spacer />
      
      </v-card-title>
      <v-divider />
      <v-card-text> 
        <v-data-table
                :headers="headers_syncStock"
                :items="syncStockInfoList"
                class="elevation-0 packhai-border-table"
                hide-default-footer
                :items-per-page="10000"
                mobile-breakpoint="0"
              >
                <template v-slot:item.edit="{ item }">
                  <a @click="handleEditSyncStockDialog(item)">{{ use_language.edit }}</a>
                </template>
                <template v-slot:item.platformLogo="{ item }">
                  <v-avatar size="25px"  >
                      <img :src="item.platformLogo"/>
                    </v-avatar>
                </template>
               
                <template v-slot:item.isUpdateStock="{ item }">
                   <span  v-if="item.isUpdateStock" class="color-green text-center">
                    {{ use_language.active }}
                   </span>
                   <span v-else class="color-red text-center">
                    {{ use_language.disable_use }}
                  </span>
                </template>
                <template v-slot:item.updateStockPercent="{ item }">
                   <span v-if="item.updateStockPercent!=null" class="text-right" align="right" >
                     {{ formatMoney(item.updateStockPercent) }}%
                   </span>
                 </template>
           
                <template v-slot:item.remark="{ item }">
                  <span v-if="item.staticQuantityWhenLowStock!=null" class="text-right" align="right" >
                     {{ use_language.when_stock_lte }} {{item.quantityLowStock}} {{ use_language.update_to_value }} {{  item.staticQuantityWhenLowStock  }} 
                   </span>
                  
                </template>
                
        </v-data-table>
           
      </v-card-text>
    </v-card>
    <v-card v-if="shop.is_Active" elevation="1" class="v-card-margin-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="30" color="orange darken-3">mdi-refresh</v-icon
        ><span class="ml-2">sync stock {{ use_language.all_new }}</span>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-btn v-if="!IsShowCancelSyncButton"   @click="ReSyncStock()" color="primary"><v-icon left>fa-rocket</v-icon> {{ use_language.carry_out }}</v-btn>
        <v-btn v-else   @click="cancel_resync_stock()" outlined color="primary"><v-icon left>fa-ban</v-icon>{{ use_language.cancel_the }} sync</v-btn>
        <span class="ml-2" v-if="IsShowPercentSyncProgress">{{PercentUpdateStock}}% ({{CurrentUpdateStock}}/{{ TotalUpdateStock }})</span>
        <span class="ml-2 color-green"  v-if="IsShowSyncSuccess">Sync Stock {{ use_language.succeed }}</span>
      </v-card-text>
    </v-card>


    <!-- dialog -->
   <v-dialog v-model="sync_stock_dialog" scrollable persistent>
    <v-card>
      <v-card-title>
        {{ use_language.edit_the }} Sync Stock
        <v-avatar size="25px" class="ml-4" >
          <img :src="currentsyncStockInfo.platformLogo"/>
        </v-avatar>
        <span class="ml-4">{{ currentsyncStockInfo.platformShopName }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="sync_stock_dialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="2" md="3">
            <b>{{ use_language.action_word }} Sync : </b>
          </v-col>
          <v-col cols="10" md="9">
            <v-radio-group v-model="sync_stock_radio" @change="sync_stock_radio_changed()"  row>
              <v-radio :label="use_language.active" color="green" value="1"></v-radio>
              <v-radio :label="use_language.disable_use" color="red" value="0"></v-radio> 
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" md="3">
            <b> % {{ use_language.action_word }} Sync : </b>
          </v-col>
          <v-col cols="10" md="9">
            <table>
              <tr>
                <td>
                  <v-text-field style="width:100px"
                    v-model="sync_stock_percent"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                    type="number"
                  ></v-text-field>
                </td>
                <td class="pl-1">
                  %
                </td>
              </tr>
            </table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" md="3">
            <b> {{ use_language.when_stock_lte }} : </b>
          </v-col>
          <v-col cols="10" md="9">
            <table>
              <tr>
                <td>
                  <v-text-field style="width:100px"
                    v-model="sync_stock_minimum"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                    type="number"
                  ></v-text-field>
                </td>
                <td class="pl-1">
                  {{ use_language.item }}
                </td>
              </tr>
            </table>
           
       
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" md="3"  >
           <b> {{ use_language.update_to }} : </b>
          </v-col>
          <v-col cols="10" md="9">
            <table>
              <tr>
                <td>
                  <v-text-field style="width:100px"
                    v-model="sync_stock_static_quantity"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                    type="number"
                  ></v-text-field>
                </td>
                <td class="pl-1">
                  {{ use_language.item }}
                </td>
              </tr>
            </table>
          </v-col>
        </v-row>
        
      </v-card-text>
      <v-divider />
      <v-card-actions >
        <v-checkbox v-model="sync_stock_updateall" :label="use_language.update_settings_all_products"></v-checkbox>
        <v-spacer></v-spacer>
        <div >
          <v-btn   @click="save_edit_sync_stock()" color="primary"><v-icon left>fa-save</v-icon> {{ use_language.button_save }}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
   </v-dialog>

    <v-dialog v-model="connect_dialog" scrollable  persistent  >
      <v-card class="my-0">
        <v-card-title>
          <span>{{ dialog_title }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="connect_dialog = false, fb_selected=[], fb_page_lists =[],closedialog(dialog_type)"
            ><v-icon color="danger">mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <div v-if="token != null && !editVrich" align="center" class="my-2">
            <span> <b>{{ use_language.token_created_success }}</b> </span><br /><br /><br />
            <v-textarea outlined :value="token" readonly></v-textarea>
            <input style="width: 100%" type="hidden" id="token-code" v-model="token" />
            <div>
              <v-btn color="primary" @click="copyToken()">{{ use_language.copied }} TOKEN</v-btn>
            </div>
          </div>

          <div v-else>
            <!-- dialog shopee -->
            <div align="center" class="my-10" v-show="dialog_type == 'shopee'">
              <v-row>
                <v-col cols="6"  lg="6" align="right">
                  <v-img
                    class="elevation-3"
                    :src = "logoConnect"
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                  <!-- src="https://rtms3.s3-ap-southeast-1.amazonaws.com/packhai/packhai_shop/image_2020_11_20T03_28_17_235Z.png" -->
                </v-col>
                <v-divider vertical ></v-divider>
                <v-col cols="6"  lg="6" align="left">                  
                  <v-img
                    class="elevation-3"
                    src="@/assets/shopee-logo-connect.png" 
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                </v-col>
              </v-row>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="this.IsDev == 'dev' && dialog_type == 'shopee'"
              >
              <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} shopee</v-btn>
            </div>
            <div v-else-if="dialog_type == 'shopee'" align="center" class="my-10">
              <v-row v-if="jaspalShop.includes(ShopID)">
                <v-col cols="12" md="3" lg="2" align="left">
                  Store Code :
                </v-col>
                <v-col cols="12" md="9" lg="10" align="left">
                  <v-text-field
                    :value="shopeeStoreCode"
                    @change="(value) => (shopeeStoreCode = Trim_value(value))"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">
                  Invoice Account :
                </v-col>
                <v-col cols="12" md="9" lg="10" align="left">
                  <v-text-field
                    :value="invoiceAccount"
                    @change="(value) => (invoiceAccount = Trim_value(value))"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">
                  Invent Location:
                </v-col>
                <v-col cols="12" md="9" lg="10" align="left">
                  <v-text-field
                    :value="inventLocation"
                    @change="(value) => (inventLocation = Trim_value(value))"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">{{ use_language.check_cost }} :</v-col>
                <v-col cols="12" md="9" lg="10" align="left" class="font-weight-bold" style="font-size: 12px !important">
                  <v-checkbox
                    v-model="synnex_ischeckcost"
                    :label="use_language.check_cost"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" lg="2"   align="left">{{ use_language.warehouse }} : </v-col>
                <v-col
                  cols="12" md="9" lg="10"

                  align="left"
                  class="py-1 font-weight-bold"
                  style="font-size: 12px !important"
                >
                  <v-select
                      v-model="ShopeeWarehouse_Selected"
                      :items="Shopee_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>

                </v-col>
              </v-row>
              <v-row class="pb-1">
                <v-col cols="12" md="3" lg="2"   align="left">{{ use_language.auto_pickup }} :</v-col>
                <v-col
                cols="12" md="9" lg="10" 
                 
                  align="left"
                  class="font-weight-bold"
                  style="font-size: 12px !important"
                >
                  <v-checkbox
                    v-model="check_init_shopee"
                    :label="use_language.auto_schedule_pickup_desc"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>

              <div v-if="check_init_shopee == true">
               <v-row class="pb-1">
                  <v-col cols="12" md="3" lg="2"   align="left">{{ use_language.set_pickup_appointment }} :</v-col>
                  <v-col   cols="12" md="9" lg="10" align="left">
                    <table> 
                    <tr>
                        <td>{{ use_language.active }}</td>
                         <td>{{ use_language.format }}</td>
                          <td>{{ use_language.start_end_time }}</td>
                    </tr>
                      <tr
                        v-for="(item, index) in dayListShopee" :key="index"
                        class="font-weight-bold"
                        style="font-size: 12px !important"
                      >
                        <td >
                          <v-switch v-model="item.isActive" :label="daysLoop[index].text" @change="daysLoopActiveChanged(item)"/>
                        </td>
                        <td >
                          <v-radio-group row v-model="item.initType" :value="null"  >
                            <v-radio label="Pickup" :value="1"></v-radio>
                            <v-radio label="Drop-off" :value="2"></v-radio>
                          </v-radio-group>
                        </td>
                        <td >
                          <tr>
                            <td>
                              <v-select
                                v-model="item.startTime"
                                :items="items_time"
                                item-text="name"
                                item-value="value"
                                persistent-hint
                                dense hide-details
                                outlined
                                single-line
                                style="width:90px"
                                 
                              ></v-select>
                            </td>
                            <td class="pl-1 pr-1">-</td>
                            <td>
                              <v-select
                                v-model="item.endTime"
                                :items="items_time"
                                item-text="name"
                                item-value="value"
                                persistent-hint
                                dense hide-details
                                outlined
                                single-line
                                  style="width:90px"
                                
                              ></v-select>
                            </td>
                          </tr>
                        </td>
                      </tr>
                    </table> 
                  </v-col>
                </v-row>
              </div>

              <v-row>
                <v-col cols="12" md="4" lg="3"   align="left"> </v-col>
                <v-col cols="12" md="8" lg="9"  align="left" style="font-size: 12px !important">
                  {{ use_language.auto_pickup_on_payment }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">  
                  <v-btn @click="shopee_connection()" color="success"
                    ><v-icon left>fa-link</v-icon> {{ use_language.connect }} shopee</v-btn
                  >
                </v-col>  
              </v-row>
            </div>

            <!-- lazada -->
            <div align="center" class="my-10" v-show="dialog_type == 'lazada'">
              <v-row>
                <!-- <v-col cols="12" md="12" lg="8" align="left">
                  <v-img
                    class="elevation-3"
                    src="https://rtms3.s3-ap-southeast-1.amazonaws.com/packhai/packhai_shop/image_2020_12_03T09_01_56_704Z.png"
                  />
                </v-col> -->
                <v-col cols="6"  lg="6" align="right">
                  <v-img
                    class="elevation-3"
                    :src = "logoConnect"
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                </v-col>
                <v-divider vertical ></v-divider>
                <v-col cols="6"  lg="6" align="left">
                  <v-img
                    class="elevation-3"
                    src="@/assets/lazada-logo-connect.png" 
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                </v-col>
              </v-row>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="this.IsDev == 'dev' && dialog_type == 'lazada'"
              >
              <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} shopee</v-btn>
            </div>
            <div v-else-if="dialog_type == 'lazada'" align="center" class="my-10">
              <v-row v-if="jaspalShop.includes(ShopID)">
                  <v-col cols="12" md="3" lg="2" align="left">
                     Store Code :  
                  </v-col>
                  <v-col cols="12" md="9" lg="10" align="left">
                    <v-text-field
                      :value="lazadaStoreCode"
                      @change="(value) => (lazadaStoreCode = Trim_value(value))"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                   <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">
                  Invoice Account :
                </v-col>
                <v-col cols="12" md="9" lg="10" align="left">
                  <v-text-field
                    :value="invoiceAccount"
                    @change="(value) => (invoiceAccount = Trim_value(value))"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">
                  Invent Location:
                </v-col>
                <v-col cols="12" md="9" lg="10" align="left">
                  <v-text-field
                    :value="inventLocation"
                    @change="(value) => (inventLocation = Trim_value(value))"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">{{ use_language.check_cost }} :</v-col>
                <v-col cols="12" md="9" lg="10" align="left" class="font-weight-bold" style="font-size: 12px !important">
                  <v-checkbox
                    v-model="synnex_ischeckcost"
                    :label="use_language.check_cost"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" lg="2"   align="left">{{ use_language.warehouse }} : </v-col>
                <v-col
                  cols="12" md="9" lg="10"

                  align="left"
                  class="font-weight-bold"
                  style="font-size: 12px !important"
                >
                  <v-select
                      v-model="LazadaWarehouse_Selected"
                      :items="Lazada_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>

                </v-col>
              </v-row>
              <v-row>
                <v-col  cols="12" md="3" lg="2"   align="left">{{ use_language.auto_pickup }} :</v-col>
                <v-col
                   cols="12" md="9" lg="10" 
                  align="left"
                  class="font-weight-bold"
                  style="font-size: 12px !important"
                >
                  <v-checkbox
                    v-model="check_init_lazada"
                    :label="use_language.auto_schedule_pickup_desc"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>

              <div v-if="check_init_lazada == true">
               <v-row class="pb-1">
                  <v-col cols="12" md="3" lg="2"   align="left">{{ use_language.set_pickup_appointment }} :</v-col>
                  <v-col   cols="12" md="9" lg="10" align="left">
                    <table> 
                    <tr>
                        <td>{{ use_language.active }}</td>
                         <td>{{ use_language.format }}</td>
                          <td>{{ use_language.start_end_time }}</td>
                    </tr>
                      <tr
                        v-for="(item, index) in dayListLazada" :key="index"
                        class="font-weight-bold"
                        style="font-size: 12px !important"
                      >
                        <td  >
                          <v-switch v-model="item.isActive" :label="daysLoop[index].text" @change="daysLoopActiveChanged(item)"/>
                        </td>
                        <td  >
                          <v-radio-group row v-model="item.initType" :value="null" >
                            <v-radio label="Pickup" :value="1"></v-radio>
                            <v-radio label="Drop-off" :value="2"></v-radio>
                          </v-radio-group>
                        </td>
                        <td  >
                          <tr>
                            <td>
                              <v-select
                                v-model="item.startTime"
                                :items="items_time"
                                item-text="name"
                                item-value="value"
                                persistent-hint
                                dense hide-details
                                outlined
                                single-line
                                  style="width:90px"
                                
                              ></v-select>
                            </td>
                            <td class="pl-1 pr-1">-</td>
                            <td>
                              <v-select
                                v-model="item.endTime"
                                :items="items_time"
                                item-text="name"
                                item-value="value"
                                persistent-hint
                                dense hide-details
                                outlined
                                single-line
                                  style="width:90px"
                                 
                              ></v-select>
                            </td>
                          </tr>
                        </td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </div>

              <v-btn @click="lazada_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} lazada</v-btn
              >
            </div>

            <!-- ChannelSource -->
            <div align="center" v-show="dialog_type == 'vrich' || dialog_type == 'zwiz'">
              <v-form ref="formChannelSource" lazy-validation>
                <div v-if="!editVrich">
                  <v-row>
                    <v-col cols="12" md="4" lg="4" align="left">
                      <b> ChannelSource : </b>
                    </v-col>
                    <v-col cols="12" md="8" lg="8" align="left">
                      <v-select
                        v-model="channelSource"
                        :items="channelSourceList"
                        item-text="channelName"
                        item-value="id"
                        ref="refchannelSource"
                        :rules="ruleschannelSource"
                        persistent-hint
                        return-object
                        dense
                        hide-details
                        outlined
                        single-line
                      >
                        <template slot="selection" slot-scope="data">
                          <v-avatar
                            v-if="data.item.logoPic != null"
                            size="25px"
                            class="mr-2"
                            ><img :src="data.item.logoPic"
                          /></v-avatar>
                          {{ data.item.channelName }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <v-avatar
                            v-if="data.item.logoPic != null"
                            size="25px"
                            class="mr-2"
                            ><img :src="data.item.logoPic"
                          /></v-avatar>
                          {{ data.item.channelName }}
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <v-row>
                    <v-col cols="12" md="4" lg="4" align="left">
                      <b> PushURL : </b>
                    </v-col>
                    <v-col cols="12" md="8" lg="8" align="left">
                      <v-text-field
                        :value="pushURL"
                        @change="(value) => (pushURL = Trim_value(value))"
                        ref="refpushURL"
                        :rules="rulespushURL"
                        @keyup.enter="$refs.refpushToken.focus()"
                        autocomplete="off"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4" lg="4" align="left">
                      <b> PushToken : </b>
                    </v-col>
                    <v-col cols="12" md="8" lg="8" align="left">
                      <v-text-field
                        :value="pushToken"
                        @change="(value) => (pushToken = Trim_value(value))"
                        ref="refpushToken"
                        :rules="rulespushTokent"
                        @keyup.enter="EditVrich()"
                        autocomplete="off"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="
                this.IsDev == 'dev' && (dialog_type == 'vrich' || dialog_type == 'zwiz')
              "
              >
              <v-btn dark
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} {{ dialog_type }}</v-btn
              >
            </div>
            <div
              v-else-if="dialog_type == 'vrich' || dialog_type == 'zwiz'"
              align="center"
              class="my-10"
              >
              <v-btn v-if="!editVrich" @click="ChannelSource_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} {{ dialog_type }}</v-btn
              >
              <v-btn v-else @click="EditVrich()" color="success"
                ><v-icon left>mdi-content-save</v-icon> {{ use_language.button_save }}
              </v-btn>
            </div>

            <!-- woo -->
            <div align="center" v-show="dialog_type == 'woo'">
              <v-form ref="formShopWoo" lazy-validation>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>url {{ use_language.shop_in }} woo Commerce : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopWoo.baseURL"
                      @change="(value) => (shopWoo.baseURL = Trim_value(value))"
                      ref="shopWoobaseURL"
                      :rules="shopWoo.rulesBaseURL"
                      @keyup.enter="$refs.shopWooappKey.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="เช่น https://www.abc.com"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left"> <b>App Key : </b> </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopWoo.appKey"
                      @change="(value) => (shopWoo.appKey = Trim_value(value))"
                      ref="shopWooappKey"
                      :rules="shopWoo.rulesAppKey"
                      @keyup.enter="$refs.shopWooappSecret.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>App Secret : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopWoo.appSecret"
                      @change="(value) => (shopWoo.appSecret = Trim_value(value))"
                      ref="shopWooappSecret"
                      :rules="shopWoo.rulesAppSecret"
                      @keyup.enter="$refs.shopWooWarehouseSelect.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.connected_warehouse }} : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-select 
                      v-model="WooWarehouse_Selected"
                      ref="shopWooWarehouseSelect"
                      :items="Woo_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="this.IsDev == 'dev' && dialog_type == 'woo'"
              >
              <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} woo</v-btn>
            </div>
            <div v-else-if="dialog_type == 'woo'" align="center" class="my-10">
              <v-btn @click="woo_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} woo</v-btn
              >
            </div>

            <!-- shopify -->
            <div align="center" v-show="dialog_type == 'shopify'">
              <v-form ref="formShopShopify" lazy-validation>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>url {{ use_language.shop_in }} Shopify : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shop_shopify.baseUrl"
                      @change="(value) => (shop_shopify.baseUrl = Trim_value(value))"
                      ref="shopifybaseURL"
                      :rules="shop_shopify.rulesBaseURL"
                      @keyup.enter="$refs.shopifyAdminAPI.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="เช่น https://www.abc.com"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left"> <b>Client ID : </b> </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shop_shopify.clientID"
                      @change="(value) => (shop_shopify.clientID = Trim_value(value))"
                      ref="shopifyAdminAPI"
                      :rules="shop_shopify.rulesAdminAPI"
                      @keyup.enter="$refs.shopifyStorefrontAPI.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>Client Secret : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shop_shopify.clientSecret"
                      @change="(value) => (shop_shopify.clientSecret = Trim_value(value))"
                      ref="shopifyStorefrontAPI"
                      :rules="shop_shopify.rulesStorefrontAPI"
                      @keyup.enter="$refs.shopifyWarehouseSelect.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.connected_warehouse }} : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-select 
                      v-model="ShopifyWarehouse_Selected"
                      ref="shopifyWarehouseSelect"
                      :items="Shopify_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="jaspalShop.includes(ShopID)">
                  <v-col cols="12" md="4" lg="4" align="left">
                    Store Code :
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shop_shopify.storeCode"
                      @change="(value) => (shop_shopify.storeCode = Trim_value(value))"
                      ref="shopifyAdminAPI" 
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                 <v-row v-if="jaspalShop.includes(ShopID)">
                  <v-col cols="12" md="4" lg="4" align="left">
                    Integration :
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-radio-group v-model="shop_shopify.aP21_Integration_Type">
                      <v-radio value="1" label="Normal Integration"> </v-radio>
                       <v-radio value="2" label="SO Integration">  </v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <div v-if="dialog_type == 'shopify'" align="right"  >
              <v-btn @click="shopify_connection()" color="primary"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} Shopify</v-btn
              >
            </div>


            <!-- token -->
            <div align="center" v-show="dialog_type == 'token'">
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left">
                  <b>{{ use_language.sales_channel }} : </b>
                </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                  <v-autocomplete
                    v-model="dialog_token_chanal"
                    ref="dialog_token_chanal"
                    :items="chanal_list"
                    item-text="channelName"
                    item-value="id"
                    dense
                    hide-details
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left"> <b>{{ use_language.connected_warehouse }} : </b> </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                  <v-autocomplete
                    v-model="dialog_token_warehouse"
                    ref="dialog_token_warehouse"
                    :items="warehouse_list"
                    item-text="name"
                    item-value="id"
                    dense
                    hide-details
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left"> <b>{{ use_language.salesperson }} : </b> </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                  <v-autocomplete
                    v-model="dialog_token_staff"
                    ref="dialog_token_staff"
                    :items="staff_list"
                    item-text="name"
                    item-value="id"
                    dense
                    hide-details
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row  >
                <v-col align="right" cols="12"   >
                 
                <v-btn @click="connect_token()" color="success"
                  ><v-icon left>fa-link</v-icon> {{ use_language.create }} Token</v-btn
                >
                 </v-col>
              </v-row>
            </div>

            <div align="center" v-show="dialog_type == 'updatewebhook'">
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left">
                  <b>Webhook URL: </b>
                </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field 
                      v-model="webhookUrl"
                      
                      autocomplete="off"
                      outlined
                      dense
                      hide-details 
                    ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left">
                  <b>{{ use_language.webhook_bearer }}): </b>
                </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field 
                      v-model="webhookBearer"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details 
                    ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left">
                
                </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                   <v-btn @click="test_webhook()" color="info" outlined>  {{ use_language.test }} Webhook url</v-btn >
                   <span  class="green--text ml-2" v-if="isWebhookTested!=null&& isWebhookTested">{{ use_language.succeed }}</span>
                   <span class="red--text ml-2" v-else-if="isWebhookTested!=null && !isWebhookTested ">{{ use_language.test_failed }}</span>
                </v-col>
              </v-row>
               
              <v-row>
                <v-col class="text-right">
                  <v-btn @click="save_webhook()" color="primary"
                    ><v-icon left>fa-save</v-icon> {{ use_language.button_save }}</v-btn >
                </v-col>
              </v-row>
            </div>

            <!-- line my shop -->
            <div align="center" v-show="dialog_type == 'lineMyShop'">
              <!-- <v-row>
                <v-col cols="12" align="left">
                  <a href="https://docs.google.com/document/d/1NkJGRPvti0kXgr-uBAZUwhvkVMSqk_ywOaloG8d4SAQ/edit?usp=sharing" target="_blank"> <b>วิธีการเชื่อมต่อ line my shop</b></a>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left"> <b>API KEY : </b> </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                  <v-text-field
                    v-model="dialog_line_my_shop.token"
                    ref="line_token"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left"> <b>{{ use_language.menu_manageshop }} : </b> </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                  <v-text-field
                    v-model="dialog_line_my_shop.shopName"
                    ref="line_shopName"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left"> <b>{{ use_language.salesperson }} : </b> </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                  <v-autocomplete
                    v-model="dialog_line_my_shop.salemanID"
                    ref="line_salemanID"
                    :items="staff_list"
                    item-text="name"
                    item-value="id"
                    dense
                    hide-details
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" lg="4" align="left"> <b>{{ use_language.connected_warehouse }} : </b> </v-col>
                <v-col cols="12" md="8" lg="8" align="left">
                  <v-select 
                      v-model="LineMyShopWarehouse_Selected "
                      ref="shopWooWarehouseSelect"
                      :items="LineMyShop_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-btn @click="connect_line_my_shop()" color="success"
                  ><v-icon left>fa-link</v-icon> {{ use_language.connect }} line my shop</v-btn
                >
              </v-row>
            </div>

            <!-- telegram -->
            <div align="center" class="my-10" v-show="dialog_type == 'telegram bot'">
              
              <v-row>
                <v-col cols="6"  lg="6" align="right">
                  <v-img
                    class="elevation-3"
                    :src = "logoConnect"
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                  <!-- src="https://rtms3.s3-ap-southeast-1.amazonaws.com/packhai/packhai_shop/image_2020_11_20T03_28_17_235Z.png" -->
                </v-col>
                <v-divider vertical ></v-divider>
                <v-col cols="6"  lg="6" align="left">                  
                  <v-img
                    class="elevation-3"
                    src="@/assets/Telegram-logo.webp" 
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                </v-col>
              </v-row>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="this.IsDev == 'dev' && dialog_type == 'telegram bot'"
              >
              <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} telegram</v-btn>
            </div>
            <div v-else-if="dialog_type == 'telegram bot'" align="center" class="my-10">
              <v-row class="pb-5">
                <v-col cols="0" md="0" lg="2" class="pa-0 ma-0" align="left"></v-col>
                <v-col
                  cols="12"
                  md="12"
                  lg="10"
                  align="left"
                  class="py-1 font-weight-bold"
                  style="font-size: 12px !important"
                >
                  <div v-for="(item, index) in telegramTypeList" :key="index">
                    <v-checkbox
                      v-model="item.active"
                      :disabled="item.disabled"
                      color="info"
                    >
                      <template v-slot:label>                     
                        {{item.name}}
                      </template>
                    </v-checkbox>

                    <v-row class="pl-5" v-if="item.id == 2 && item.active">
                      <v-col class="packhai-showtime" cols="12">
                        {{ use_language.notify_at_time }}
                        <div class="ml-3">
                          <v-select
                            v-model="hour"
                            :items="hourList"
                            item-text="data"
                            item-value="data"
                            persistent-hint
                            return-object
                            dense
                            hide-details
                            outlined
                            single-line
                          ></v-select>
                        </div>
                        <b class="ma-3"> : </b>
                        <div>
                          <v-select
                            v-model="minute"
                            :items="minuteList"
                            item-text="data"
                            item-value="data"
                            persistent-hint
                            return-object
                            dense
                            hide-details
                            outlined
                            single-line
                          ></v-select>
                        </div>
                      </v-col>
                    </v-row>

                  </div>
                </v-col>
              </v-row>
              <div class="text-center">
                <div id="telegram-login-button"></div>
              </div>
            </div>

            <!-- line -->
            <div align="center" class="my-10" v-show="dialog_type == 'line notify'">
              
              <v-row>
                <v-col cols="6"  lg="6" align="right">
                  <v-img
                    class="elevation-3"
                    :src = "logoConnect"
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                  <!-- src="https://rtms3.s3-ap-southeast-1.amazonaws.com/packhai/packhai_shop/image_2020_11_20T03_28_17_235Z.png" -->
                </v-col>
                <v-divider vertical ></v-divider>
                <v-col cols="6"  lg="6" align="left">                  
                  <v-img
                    class="elevation-3"
                    src="@/assets/linenotify_logo.png" 
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                </v-col>
              </v-row>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="this.IsDev == 'dev' && dialog_type == 'line notify'"
              >
              <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} line</v-btn>
            </div>
            <div v-else-if="dialog_type == 'line notify'" align="center" class="my-10">
              <v-row class="pb-5">
                <v-col cols="0" md="0" lg="2" class="pa-0 ma-0" align="left"></v-col>
                <v-col
                  cols="12"
                  md="12"
                  lg="10"
                  align="left"
                  class="py-1 font-weight-bold"
                  style="font-size: 12px !important"
                >
                  <v-radio-group v-model="lineType" class="pt-3">
                    <v-radio
                      v-for="(i, indexi) in lineTypeList"
                      :disabled="i.disabled"
                      color="info"
                      :key="indexi"
                      :label="i.name"
                      :value="i.id"
                    >
                    </v-radio>
                  </v-radio-group>
                  <v-row class="pl-5" v-if="lineType == 2">
                    <v-col class="packhai-showtime" cols="12">
                      {{ use_language.notify_at_time }}
                      <div class="ml-3">
                        <v-select
                          v-model="hour"
                          :items="hourList"
                          item-text="data"
                          item-value="data"
                          persistent-hint
                          return-object
                          dense
                          hide-details
                          outlined
                          single-line
                        ></v-select>
                      </div>
                      <b class="ma-3"> : </b>
                      <div>
                        <v-select
                          v-model="minute"
                          :items="minuteList"
                          item-text="data"
                          item-value="data"
                          persistent-hint
                          return-object
                          dense
                          hide-details
                          outlined
                          single-line
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-btn @click="line_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} line</v-btn
              >
            </div>
            <input
              id="token-line-oa"
              style="width: 100%"
              type="hidden"
              v-model="token_line_oa"
            />
            <!-- line oa -->
            <div align="center" v-show="dialog_type == 'lineOa'">
              <v-row>
                <v-col cols="12" md="3" lg="3" align="left"> <b>Channel ID : </b> </v-col>
                <v-col cols="12" md="9" lg="9" align="left">
                  <v-text-field
                    v-model="LineMessageConnection.lineChannelID"
                    ref="lineoa_channel_id"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" lg="3" align="left"> <b>Channel Secret : </b> </v-col>
                <v-col cols="12" md="9" lg="9" align="left">
                  <v-text-field
                    v-model="LineMessageConnection.lineChannelSecret"
                    ref="lineoa_channel_secret"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" lg="3" align="left"> <b>Token : </b> </v-col>
                <v-col cols="12" md="9" lg="9" align="left">
                  <v-text-field
                    v-model="LineMessageConnection.lineToken"
                    ref="lineoa_token"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" lg="3" align="left"> <b>Webhook : </b> </v-col>
                <v-col cols="12" md="9" lg="9" align="left">
                  {{ LineMessageConnection.webhookUrl }}
                  <a @click="copyTokenLineOA(LineMessageConnection.webhookUrl)"><v-icon size="18" left>mdi-content-copy</v-icon></a>
                </v-col>
              </v-row>
                  
              
              <div class="pt-6" align='center'>
                <v-btn @click="connect_line_oa()" color="success">
                  <v-icon left>fa-link</v-icon> {{ use_language.connect }} line oa
                </v-btn>
              </div>
            </div>

            <!-- plugo -->
            <div align="center" v-show="dialog_type == 'plugo'">
              <v-form ref="formShopPlugo" lazy-validation>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.shop_name }} </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopPlugo.shopName"
                      ref="shopPlugshopName"
                      :rules="shopPlugo.rulesShopName"
                      @keyup.enter="$refs.shopPlugoVendorID.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="Cat Shop"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>VendorID </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopPlugo.vendorID"
                      @change="(value) => (shopPlugo.vendorID = Trim_value(value))"
                      ref="shopPlugovendorID"
                      :rules="shopPlugo.rulesVendorID"
                      @keyup.enter="$refs.shopPlugoApiKey.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      :placeholder="use_language.example_10310"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left"> <b>ApiKey : </b> </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopPlugo.apiKey"
                      @change="(value) => (shopPlugo.apiKey = Trim_value(value))"
                      ref="shopPlugoapiKey"
                      :rules="shopPlugo.rulesApiKey"
                      @keyup.enter="$refs.shopWooWarehouseSelect.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.connected_warehouse }} : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-select 
                      v-model="PlugoWarehouse_Selected"
                      ref="plugoWarehouseSelect"
                      :items="Plugo_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="this.IsDev == 'dev' && dialog_type == 'plugo'"
              >
              <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} Plugo</v-btn>
            </div>
            <div v-else-if="dialog_type == 'plugo'" align="center" class="my-10">
              <v-btn @click="plugo_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} Plugo</v-btn
              >
            </div>

            <!-- Amaze -->
            <div align="center" v-show="dialog_type == 'amaze'">
              <v-form ref="formShopAmaze" lazy-validation>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>UserID </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopAmaze.userID"
                      ref="shopAmazeuserID"
                      :rules="shopAmaze.rulesUserID"
                      @keyup.enter="$refs.shopAmazePassword.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="UserId"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>Password </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopAmaze.password"
                      @change="(value) => (shopAmaze.password = Trim_value(value))"
                      ref="shopAmazepassword"
                      :rules="shopAmaze.rulesPassword"
                      :type="'password'"
                      @keyup.enter="$refs.shopAmazeStoreID.focus()"
                      autocomplete="new-password"
                      outlined
                      dense
                      hide-details
                      placeholder="Password"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>StoreID </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopAmaze.StoreID"
                      @change="(value) => (shopAmaze.StoreID = Trim_value(value))"
                      ref="shopAmazeStoreID"
                      :rules="shopAmaze.rulesStoreID"
                      @keyup.enter="$refs.shopAmazeWarehouseSelect.focus()"

                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="StoreID"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.connected_warehouse }} : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-select 
                      v-model="AmazeWarehouse_Selected"
                      ref="amazeWarehouseSelect"
                      :items="Amaze_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="this.IsDev == 'dev' && dialog_type == 'amaze'"
              >
              <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} Amaze</v-btn>
            </div>
            
            <div v-else-if="dialog_type == 'amaze'" align="center" class="my-10">
              <v-btn @click="amaze_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} Amaze</v-btn
              >
            </div>

             <!-- Makro -->
            <div align="center" v-show="dialog_type == 'makro'">
              <v-form ref="formShopMakro" lazy-validation>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.shop_name }} </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopMakro.name"
                      ref="shopMakroShopName"
                      :rules="shopMakro.rulesName"
                      @keyup.enter="$refs.shopMakroUrl.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      :placeholder="use_language.shop_name"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>URL </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopMakro.url"
                      @change="(value) => (shopMakro.url = Trim_value(value))"
                      ref="shopMakroUrl"
                      :rules="shopMakro.rulesURL"
                      :type="'text'"
                      @keyup.enter="$refs.makroWarehouseSelect.focus()" 
                       autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="URL"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>Token </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopMakro.token"
                      @change="(value) => (shopMakro.token = Trim_value(value))"
                      ref="shopMakroToken"
                      :rules="shopMakro.rulesToken" 
                      @keyup.enter="$refs.makroWarehouseSelect.focus()" 
                       autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="Token"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.connected_warehouse }} : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-select 
                      v-model="MakroWarehouse_Selected"
                      ref="makroWarehouseSelect"
                      :items="Makro_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </div>
         
            <div   align="center" class="my-10" v-if="dialog_type == 'makro'">
              <v-btn @click="makro_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} Makro</v-btn
              >
            </div>
            
            <!-- Nexgen -->
            <div align="center" v-show="dialog_type == 'nexgen'">
              <v-form ref="formShopNexgen" lazy-validation>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.shop_name }} </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopNexgen.name"
                      ref="shopNexgenShopName"
                      :rules="shopNexgen.rulesName"
                      @keyup.enter="$refs.shopNexgenShopID.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      :placeholder="use_language.shop_name"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>ShopNexgenID </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopNexgen.nexgenShopID"
                      ref="shopNexgenShopID"
                      :rules="shopNexgen.rulesNexgenShopID"
                      :type="'text'"
                      @keyup.enter="$refs.shopNexgenTexID.focus()" 
                       autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="ShopNexgenID"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>TexID </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopNexgen.texID"
                      ref="shopNexgenTexID"
                      :rules="shopNexgen.rulesTexID"
                      :type="'text'"
                      @keyup.enter="$refs.shopNexgenApiKey.focus()" 
                       autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="TexID"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>ApiKey </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopNexgen.apiKey"
                      ref="shopNexgenApiKey"
                      :rules="shopNexgen.rulesApiKey"
                      :type="'text'"
                      @keyup.enter="$refs.shopNexgenApiSecret.focus()" 
                       autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="ApiKey"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>ApiSecret</b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopNexgen.apiSecret"
                      ref="shopNexgenApiSecret"
                      :rules="shopNexgen.rulesApiSecret"
                      :type="'text'"
                      @keyup.enter="$refs.shopNexgenToken.focus()" 
                       autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="ApiSecret"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>Token</b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopNexgen.token"
                      ref="shopNexgenToken"
                      :rules="shopNexgen.rulesToken"
                      :type="'text'"
                      @keyup.enter="$refs.nexgenWarehouseSelect.focus()" 
                       autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="Token"
                    ></v-text-field>
                  </v-col>
                </v-row>    

                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.connected_warehouse }} : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-select 
                      v-model="NexgenWarehouse_Selected"
                      ref="nexgenWarehouseSelect"
                      :items="Nexgen_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </div>
         
            <div   align="center" class="my-10" v-if="dialog_type == 'nexgen'">
              <v-btn @click="nexgen_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} Nexgen</v-btn
              >
            </div>

            
            <!-- bentoweb -->
            <div align="center" v-show="dialog_type == 'bentoweb'">
              <v-form ref="formShopBentoWeb" lazy-validation>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.shop_name }} </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopBentoWeb.shopName"
                      ref="shopBentoWebShopName"
                      :rules="shopBentoWeb.rulesShopName"
                      @keyup.enter="$refs.shopBentoWebUserID.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      :placeholder="use_language.shop_name"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>UserID </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopBentoWeb.userID"
                      ref="shopBentoWebUserID"
                      :rules="shopBentoWeb.rulesUserID"
                      @keyup.enter="$refs.shopBentoWebPassword.focus()"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="UserId"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>Password </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      :value="shopBentoWeb.password"
                      @change="(value) => (shopBentoWeb.password = Trim_value(value))"
                      ref="shopBentoWebPassword"
                      :rules="shopBentoWeb.rulesPassword"
                      :type="'password'"
                      @keyup.enter="$refs.shopBentoWebStoreID.focus()"
                      autocomplete="new-password"
                      outlined
                      dense
                      hide-details
                      placeholder="Password"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>StoreID </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopBentoWeb.storeID"
                      ref="shopBentoWebStoreID"
                      :rules="shopBentoWeb.rulesStoreID"
                      @keyup.enter="$refs.shopBentoWebClientID.focus()"

                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="StoreID"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>ClientID </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopBentoWeb.clientID"
                      ref="shopBentoWebClientID"
                      :rules="shopBentoWeb.rulesClientID"
                      @keyup.enter="$refs.shopBentoWebClientSecret.focus()"

                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="ClientID"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>ClientSecret </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-text-field
                      v-model="shopBentoWeb.clientSecret"
                      ref="shopBentoWebClientSecret"
                      :rules="shopBentoWeb.rulesClientSecret"
                      @keyup.enter="$refs.shopBentoWebWarehouseSelect.focus()"

                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                      placeholder="ClientSecret"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" lg="4" align="left">
                    <b>{{ use_language.connected_warehouse }} : </b>
                  </v-col>
                  <v-col cols="12" md="8" lg="8" align="left">
                    <v-select 
                      v-model="BentoWebWarehouse_Selected"
                      ref="shopBentoWebWarehouseSelect"
                      :items="BentoWeb_Warehouse"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      return-object
                      dense hide-details
                      outlined
                      single-line 
                  ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <div   align="center" class="my-10" v-if="dialog_type == 'bentoweb'">
              <v-btn @click="bentoweb_connection()" color="success"
                ><v-icon left>fa-link</v-icon> {{ use_language.connect }} BentoWeb</v-btn
              >
            </div>
          </div>

          <div align="center" class="my-10" v-show="dialog_type == 'tiktok'">
            <v-row>
              <!-- <v-col cols="0" md="0" lg="2" class="pa-0 ma-0" align="left"></v-col>
              <v-col cols="12" md="12" lg="8" align="left">
                <v-img
                  class="elevation-3"
                  src="https://rtms3.s3.ap-southeast-1.amazonaws.com/packhai/packhai_shop/packhai_tiktok.png"
                />
              </v-col> -->
              <v-col cols="6"  lg="6" align="right">
                  <v-img
                    class="elevation-3"
                    :src = "logoConnect"
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;"
                  />
                </v-col>
                <v-divider vertical ></v-divider>
                <v-col cols="6"  lg="6" align="left">                  
                  <v-img
                    class="elevation-3"
                    src="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/tiktok-shop-logo-png-transparent.png" 
                    width="190px"
                    height="190px"
                    style="border: 4px solid #fff; padding: 10px;background-size: contain;"
                  />
                </v-col>
            </v-row>
          </div>
          <div
            align="center"
            class="my-10"
            v-if="this.IsDev == 'dev' && dialog_type == 'tiktok'"
            >
            <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} tiktok</v-btn>
          </div>
          <div v-else-if="dialog_type == 'tiktok'" align="center" class="my-10">
            <v-row v-if="jaspalShop.includes(ShopID)">
                  <v-col cols="12" md="3" lg="2" align="left">
                    Store Code :
                  </v-col>
                  <v-col cols="12" md="9" lg="10" align="left">
                    <v-text-field
                      :value="tiktokStoreCode"
                      @change="(value) => (tiktokStoreCode = Trim_value(value))"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                   <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">
                  Invoice Account :
                </v-col>
                <v-col cols="12" md="9" lg="10" align="left">
                  <v-text-field
                    :value="invoiceAccount"
                    @change="(value) => (invoiceAccount = Trim_value(value))"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">
                  Invent Location:
                </v-col>
                <v-col cols="12" md="9" lg="10" align="left">
                  <v-text-field
                    :value="inventLocation"
                    @change="(value) => (inventLocation = Trim_value(value))"
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="synnexBranch.includes(BranchID)">
                <v-col cols="12" md="3" lg="2" align="left">{{ use_language.check_cost }} :</v-col>
                <v-col cols="12" md="9" lg="10" align="left" class="font-weight-bold" style="font-size: 12px !important">
                  <v-checkbox
                    v-model="synnex_ischeckcost"
                    :label="use_language.check_cost"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
             <v-row>
               <v-col cols="12" md="3" lg="2"   align="left">{{ use_language.warehouse }} : </v-col>
               <v-col
                 cols="12" md="9" lg="10"
                 align="left"
                 class="py-1 font-weight-bold"
                 style="font-size: 12px !important"
               >
                 <v-select
                     v-model="TiktokWarehouse_Selected"
                     :items="Tiktok_Warehouse"
                     item-text="name"
                     item-value="id"
                     persistent-hint
                     return-object
                     dense hide-details
                     outlined
                     single-line 
                 ></v-select>

               </v-col>
             </v-row>
             <v-row>
               <v-col cols="12" md="3" lg="2"   align="left">{{ use_language.auto_pickup }} :</v-col>
               <v-col
               cols="12" md="9" lg="10" 
                
                 align="left"
                 class="font-weight-bold"
                 style="font-size: 12px !important"
               >
                 <v-checkbox
                   v-model="check_init_tiktok"
                   :label="use_language.auto_schedule_pickup_desc"
                   hide-details
                 ></v-checkbox>
               </v-col>
             </v-row>

             <div v-if="check_init_tiktok == true">
              <v-row class="pb-1">
                  <v-col cols="12" md="3" lg="2"   align="left">{{ use_language.set_pickup_appointment }} :</v-col>
                  <v-col   cols="12" md="9" lg="10" align="left">
                    <table > 
                      <tr>
                        <td>{{ use_language.active }}</td>
                         <td>{{ use_language.format }}</td>
                          <td>{{ use_language.start_end_time }}</td>
                      </tr>
                      <tr
                        v-for="(item, index) in dayListTiktok" :key="index"
                        class="font-weight-bold"
                        style="font-size: 12px !important"
                      >
                        <td  >
                          <v-switch v-model="item.isActive" :label="daysLoop[index].text"  @change="daysLoopActiveChanged(item)"/>
                        </td>
                        <td  >
                          <v-radio-group row v-model="item.initType" :value="null"  >
                            <v-radio label="Pickup" :value="1"></v-radio>
                            <v-radio label="Drop-off" :value="2"></v-radio>
                          </v-radio-group>
                        </td>
                        <td >
                          <tr>
                            <td>
                              <v-select
                                v-model="item.startTime"
                                :items="items_time"
                                item-text="name"
                                item-value="value"
                                persistent-hint
                                dense hide-details
                                outlined
                                single-line
                                  style="width:90px"
                                
                              ></v-select>
                            </td>
                            <td class="pl-1 pr-1">-</td>
                            <td>
                              <v-select
                                v-model="item.endTime"
                                :items="items_time"
                                item-text="name"
                                item-value="value"
                                persistent-hint
                                dense hide-details
                                outlined
                                single-line
                                  style="width:90px"
                               
                              ></v-select>
                            </td>
                          </tr>
                        </td>
                      </tr>
                    </table> 
                  </v-col>
                 </v-row>
              </div>

             <v-row>
               <v-col cols="12" md="4" lg="3"   align="left"> </v-col>
               <v-col cols="12" md="8" lg="9"  align="left" style="font-size: 12px !important">
                 {{ use_language.auto_pickup_on_payment }}
               </v-col>
             </v-row>
             <v-row>
               <v-col cols="12">  
                <v-btn @click="tiktok_connection()" color="success"
                  ><v-icon left>fa-link</v-icon> {{ use_language.connect }} tiktok</v-btn
                >
               </v-col>  
             </v-row>
           </div>

          <!-- facebook -->
          <div v-if="fb_page_lists.length == 0">
            <div align="center" class="my-10" v-show="dialog_type == 'fackbook'">
              <v-row>
                <v-col cols="0" md="0" lg="2" class="pa-0 ma-0" align="left"></v-col>
                <v-col cols="12" md="12" lg="8" align="left">
                  <v-img
                    class="elevation-3"
                    src="https://rtms3.s3.ap-southeast-1.amazonaws.com/packhai/packhai_shop/packhai_fackbook.png"
                  />
                </v-col>
              </v-row>
            </div>
            <div
              align="center"
              class="my-10"
              v-if="this.IsDev == 'dev' && dialog_type == 'fackbook'"
              >
              <v-btn dark><v-icon left>fa-link</v-icon> {{ use_language.connect }} fackbook</v-btn>
            </div>
            <div v-else-if="dialog_type == 'fackbook'" align="center" class="my-10">
              <!-- <v-btn class="rounded-lg fontcss px-0 py-0 my-1">
                <fb-signin-button
                  :params="fbSignInParams"
                  @success="onSignInSuccess"
                  @error="onSignInError"
                >
                    Sign in with Facebook
                </fb-signin-button>
              </v-btn> -->
              <v-btn class="white--text fontcss" color="#4166b1" @click="loginFacebookPage">
                Sign in with facebook page
              </v-btn>
            </div>
          </div>
          <div v-else>
            <v-data-table
              v-model="fb_selected"
              :headers="headers_fackbook_for_select"
              :items="fb_page_lists"
              :single-select="false"
              item-key="id"
              show-select
              hide-default-footer
              :items-per-page="10000"
              mobile-breakpoint="0"
              class="elevation-1"
              >
            <template v-slot:item.No="{ item }">
              {{ fb_page_lists.indexOf(item) + 1 }}
            </template>
            <template v-slot:item.facebook_PagePictureURL="{ item }">
              <img style="width: 30px;border-radius: 100px !important;" :src="item.facebook_PagePictureURL" />
            </template>
            </v-data-table>
            <div class="my-5" align="center">
              <v-btn :disabled="fb_selected.length == 0" @click="fackbook_savepage()" color="success"><v-icon left>fa-link</v-icon> {{ use_language.submit }}</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="lazada_warehouse_dialog" scrollable :max-width="popupSize1" persistent>
      <v-card class="my-0">
        <v-card-title>
          <span>{{ use_language.connect_warehouse_with }} Lazada</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="lazada_warehouse_dialog = false, fb_selected=[], fb_page_lists =[]"
            ><v-icon color="danger">mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4" lg="3"   align="left">{{ use_language.warehouse_in }} Lazada : </v-col>
            <v-col
              cols="12" md="8" lg="9"
              align="left"
              class="py-1 font-weight-bold"
              style="font-size: 12px !important"
            >
              <v-select 
                  v-model="Add_LazadaWarehouse_Selected"
                  :items="Add_Lazada_Warehouse"
                  item-text="fullname"
                  item-value="id"
                  persistent-hint
                  return-object
                  dense hide-details
                  outlined
                  single-line 
              ></v-select>

            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" lg="3"   align="left">{{ use_language.system_warehouse }} : </v-col>
            <v-col
              cols="12" md="8" lg="9" 
              align="left"
              class="py-1 font-weight-bold"
              style="font-size: 12px !important"
            >
              <v-select 
                  v-model="Add_SystemWarehouse_Selected"
                  :items="Add_System_Warehouse"
                  item-text="name"
                  item-value="id"
                  persistent-hint
                  return-object
                  dense hide-details
                  outlined
                  single-line 
              ></v-select>

            </v-col>
          </v-row>
          <v-row>
               <v-col cols="12" align="right">  
                <v-btn @click="add_lazada_warehouse()" color="success"
                  ><v-icon left>fa-plus</v-icon> {{ use_language.add_warehouse_typo }}</v-btn
                >
               </v-col>  
             </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- dialog edit init time -->
    <v-dialog v-model="dialogEdit" scrollable  persistent  >
      <v-card class="my-0">
        <v-card-title>
          <span>{{ use_language.edit_pickup_settings }}: {{dialogEditType}}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogEdit">
            <v-icon color="danger">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>

          <!-- shopee -->
          <div align="center" class="my-5" v-show="dialogEditType == 'shopee'">
            <table>
              <tr>
                <td>{{ use_language.active }}</td>
                <td>{{ use_language.format }}</td>
                <td>{{ use_language.start_end_time }}</td>
              </tr>
              <tr
                v-for="(item, index) in dayListEditShopee" :key="index"
                class="font-weight-bold"
                style="font-size: 12px !important"
              >
                <td >
                  <v-switch v-model="item.isActive" :label="daysLoop[index].text" @change="daysLoopActiveChanged(item)"/>
                </td>
                <td >
                  <v-radio-group row v-model="item.initType" :value="null"  >
                    <v-radio label="Pickup" :value="1"></v-radio>
                    <v-radio label="Drop-off" :value="2"></v-radio>
                  </v-radio-group>
                </td>
                <td >
                  <tr>
                    <td>
                      <v-select
                        v-model="item.startTime"
                        :items="items_time"
                        item-text="name"
                        item-value="value"
                        persistent-hint
                        dense hide-details
                        outlined
                        single-line
                        style="width:100px"
                      ></v-select>
                    </td>
                    <td class="pl-1 pr-1">-</td>
                    <td>
                      <v-select
                        v-model="item.endTime"
                        :items="items_time"
                        item-text="name"
                        item-value="value"
                        persistent-hint
                        dense hide-details
                        outlined
                        single-line
                        style="width:100px"
                      ></v-select>
                    </td>
                  </tr>
                </td>
              </tr>
            </table>
            <div class="pt-10">
              <v-btn color="success" @click="updateInitTimeSetting()">{{ use_language.button_save }}</v-btn>
            </div>
          </div>

          <!-- lazada -->
          <div align="center" class="my-5" v-show="dialogEditType == 'lazada'">
            <table>
              <tr>
                <td>{{ use_language.active }}</td>
                <td>{{ use_language.format }}</td>
                <td>{{ use_language.start_end_time }}</td>
              </tr>
              <tr
                v-for="(item, index) in dayListEditLazada" :key="index"
                class="font-weight-bold"
                style="font-size: 12px !important"
              >
                <td >
                  <v-switch v-model="item.isActive" :label="daysLoop[index].text" @change="daysLoopActiveChanged(item)"/>
                </td>
                <td >
                  <v-radio-group row v-model="item.initType" :value="null"  >
                    <v-radio label="Pickup" :value="1"></v-radio>
                    <v-radio label="Drop-off" :value="2"></v-radio>
                  </v-radio-group>
                </td>
                <td >
                  <tr>
                    <td>
                      <v-select
                        v-model="item.startTime"
                        :items="items_time"
                        item-text="name"
                        item-value="value"
                        persistent-hint
                        dense hide-details
                        outlined
                        single-line
                        style="width:100px"
                      ></v-select>
                    </td>
                    <td class="pl-1 pr-1">-</td>
                    <td>
                      <v-select
                        v-model="item.endTime"
                        :items="items_time"
                        item-text="name"
                        item-value="value"
                        persistent-hint
                        dense hide-details
                        outlined
                        single-line
                        style="width:100px"
                      ></v-select>
                    </td>
                  </tr>
                </td>
              </tr>
            </table>
            <div class="pt-10">
              <v-btn color="success" @click="updateInitTimeSetting()">{{ use_language.button_save }}</v-btn>
            </div>
          </div>

          <!-- tiktok -->
          <div align="center" class="my-5" v-show="dialogEditType == 'tiktok'">
            <table>
              <tr>
                <td>{{ use_language.active }}</td>
                <td>{{ use_language.format }}</td>
                <td>{{ use_language.start_end_time }}</td>
              </tr>
              <tr
                v-for="(item, index) in dayListEditTiktok" :key="index"
                class="font-weight-bold"
                style="font-size: 12px !important"
              >
                <td >
                  <v-switch v-model="item.isActive" :label="daysLoop[index].text" @change="daysLoopActiveChanged(item)"/>
                </td>
                <td >
                  <v-radio-group row v-model="item.initType" :value="null"  >
                    <v-radio label="Pickup" :value="1"></v-radio>
                    <v-radio label="Drop-off" :value="2"></v-radio>
                  </v-radio-group>
                </td>
                <td >
                  <tr>
                    <td>
                      <v-select
                        v-model="item.startTime"
                        :items="items_time"
                        item-text="name"
                        item-value="value"
                        persistent-hint
                        dense hide-details
                        outlined
                        single-line
                        style="width:100px"
                      ></v-select>
                    </td>
                    <td class="pl-1 pr-1">-</td>
                    <td>
                      <v-select
                        v-model="item.endTime"
                        :items="items_time"
                        item-text="name"
                        item-value="value"
                        persistent-hint
                        dense hide-details
                        outlined
                        single-line
                        style="width:100px"
                      ></v-select>
                    </td>
                  </tr>
                </td>
              </tr>
            </table>
            <div class="pt-10">
              <v-btn color="success" @click="updateInitTimeSetting()">{{ use_language.button_save }}</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ac2 dialog -->
    <v-dialog v-model="dialog_ac2" scrollable  persistent  >
      <v-card class="my-0">
        <v-card-title>
          <span>{{ use_language.connect_ac2 }} {{ac2Item.id == null ? '(' + use_language.add + ')' : '(' + use_language.edit + ')'}}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogAc2">
            <v-icon color="danger">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <div>
            <v-row>
              <v-col cols="12" md="3" lg="3" align="left"> <b>Token : </b> </v-col>
              <v-col cols="12" md="9" lg="9" align="left">
                <v-text-field
                  v-model="ac2Item.token"
                  ref="refAc2Token"
                  autocomplete="off"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" lg="3" align="left"> <b>Owner Name : </b> </v-col>
              <v-col cols="12" md="9" lg="9" align="left">
                <v-text-field
                  v-model="ac2Item.shopName"
                  ref="refAc2OwnName"
                  autocomplete="off"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" lg="3" align="left"> <b>{{ use_language.pack_number }} : </b> </v-col>
              <v-col cols="12" md="9" lg="9" align="left">
                <v-radio-group v-model="ac2Item.isPackByPackhai" row>
                  <v-radio
                    v-for="item in ac2PackAtList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    color="info"
                  />
                </v-radio-group>
              </v-col>
            </v-row>                
            <div class="pt-6" align='center'>
              <v-btn @click="updateAc2" color="primary">
                <v-icon left>fa-link</v-icon> {{ use_language.connect }} AC2
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "@/website/components/Loading";
import { header_token } from "@/website/backend/token";
import {
  shopCallbackService,
  stockService_dotnet,
  ecomService_dotnet,
  shopService_dotnet,
  branchService_dotnet,
  expressService_dotnet,
} from "@/website/global";
import {
  DateNow,
  FormatInvoice,
  formatMoney,
  isNumberWithDot,
  isNumberWNoDot,
  Trim_value,
  GetHourList,
  GetMinuteList,
  set_format_date_time,
  get_languages,
} from "@/website/global_function";

import * as ShopHelper from '@/website/helper/ShopHelper.js';
export default {
  components: {
    Loading,
  },
  data: () => ({
    use_language: {},
    // ac2
    BranchID : parseInt(localStorage.getItem("branch_id")),
    acBranchId: localStorage.getItem("branch_id"),
    ac2Lsit: [],
    dialog_ac2: false,
    ac2Item: {
      id: null,
      shopID: localStorage.getItem("shop_id"),
      shopName: "",
      token: "",
      createdBy: localStorage.getItem("staff_id"),
      isPackByPackhai: false,
      isDeleted: false
    },
    ac2PackAtList: [
      {label: 'Packhai', value: true},
      {label: 'AC2', value: false},
    ],

    //
    header_token:{'Content-Type': 'application/json', 'Authorization': 'Bearer '+localStorage.getItem('authorization_token')},
    //day active
    dayListShopee: [],
    dayListLazada: [],
    dayListTiktok: [],

    items_time: [
      {name: '00:00', value: '00:00'},
      {name: '00:30', value: '00:30'},
      {name: '01:00', value: '01:00'},
      {name: '01:30', value: '01:30'},
      {name: '02:00', value: '02:00'},
      {name: '02:30', value: '02:30'},
      {name: '03:00', value: '03:00'},
      {name: '03:30', value: '03:30'},
      {name: '04:00', value: '04:00'},
      {name: '04:30', value: '04:30'},
      {name: '05:00', value: '05:00'},
      {name: '05:30', value: '05:30'},
      {name: '06:00', value: '06:00'},
      {name: '06:30', value: '06:30'},
      {name: '07:00', value: '07:00'},
      {name: '07:30', value: '07:30'},
      {name: '08:00', value: '08:00'},
      {name: '08:30', value: '08:30'},
      {name: '09:00', value: '09:00'},
      {name: '09:30', value: '09:30'},
      {name: '10:00', value: '10:00'},
      {name: '10:30', value: '10:30'},
      {name: '11:00', value: '11:00'},
      {name: '11:30', value: '11:30'},
      {name: '12:00', value: '12:00'},
      {name: '12:30', value: '12:30'},
      {name: '13:00', value: '13:00'},
      {name: '13:30', value: '13:30'},
      {name: '14:00', value: '14:00'},
      {name: '14:30', value: '14:30'},
      {name: '15:00', value: '15:00'},
      {name: '15:30', value: '15:30'},
      {name: '16:00', value: '16:00'},
      {name: '16:30', value: '16:30'},
      {name: '17:00', value: '17:00'},
      {name: '17:30', value: '17:30'},
      {name: '18:00', value: '18:00'},
      {name: '18:30', value: '18:30'},
      {name: '19:00', value: '19:00'},
      {name: '19:30', value: '19:30'},
      {name: '20:00', value: '20:00'},
      {name: '20:30', value: '20:30'},
      {name: '21:00', value: '21:00'},
      {name: '21:30', value: '21:30'},
      {name: '22:00', value: '22:00'},
      {name: '22:30', value: '22:30'},
      {name: '23:00', value: '23:00'},
      {name: '23:30', value: '23:30'},
    ],

    dayAllListShopee: [],
    dayAllListLazada: [],
    dayAllListTiktok: [],

    shopeeIdEdit: null,
    lazadaIdEdit: null,
    tiktokIdEdit: null,

    dayListEditShopee: [],
    dayListEditLazada: [],
    dayListEditTiktok: [],

    dialogEdit:false,
    dialogEditType: null,

    countOpen: 0,

    //
    sync_stock_dialog:false,

    page_loading: true,
    ShopID: parseInt(localStorage.getItem("shop_id")),
    StaffID: JSON.parse(localStorage.getItem("staff_id")),
    loading: false,
    language : "th",
    headers_shopee: [],
    lazada_warehouse_dialog:false,
    connect_shopee_data: [],
    check_init_shopee: null,
    check_init_tiktok:null,


    item_table_shopee_chat: [],

    item_table_lazada_chat: [],

    current_lazada_sellerID:null,
    Add_LazadaWarehouse_Selected: null,
    Add_Lazada_Warehouse: [],
    Add_SystemWarehouse_Selected: null,
    Add_System_Warehouse: [],
    headers_lazada: [],
    connect_lazada_data: [],
    check_init_lazada: null,

    sync_stock_radio:false,
    sync_stock_percent: null,
    sync_stock_minimum: null,
    sync_stock_static_quantity: null,
    sync_stock_updateall:false,

    headers_vrich: [],
    connect_vrich_data: [],

    headers_zwiz: [],
    connect_zwiz_data: [],

    headers_tiktok: [],
    connect_tiktok_data: [],
    syncStockInfoList:[],
    currentsyncStockInfo:{
      platformLogo:null,
      platformShopName:null,
    },
    channelSourceList: [],
    channelSource: {},
    ruleschannelSource: [],
    apiauthenId: 0,
    token: null,
    editVrich: false,
    pushURL: null,
    pushToken: null,
    rulespushURL: [],
    rulespushTokent: [],

    connect_woo_data: [],
    shopWoo: {
      id: 0,
      shopId: localStorage.getItem("shop_id"),
      baseURL: null,
      appKey: null,
      appSecret: null,
      rulesBaseURL: [],
      rulesAppKey: [],
      rulesAppSecret: [],
    },

    headers_shopify: [],
    connect_shopify_data: [],
    shop_shopify:{
      clientID:"",
      clientSecret:"",
      id:0,
      shopID: localStorage.getItem("shop_id"),
      warehouseID:0,
      baseUrl:"",  
      aP21_Integration_Type:'1'
    },

    connect_telegram_data: [],
    telegramType: 1,
    telegramTypeList: [],

    connect_line_data: [],


    connect_plugo_data: [],
    shopPlugo: {
      id: 0,
      shopId: localStorage.getItem("shop_id"),
      shopName: null,
      vendorID: null,
      apiKey: null,
      rulesShopName: [],
      rulesVendorID: [],
      rulesApiKey: [],
    },

    connect_amaze_data: [],
    shopAmaze: {
      id: 0,
      shopId: localStorage.getItem("shop_id"),
      shopName: null,
      userID: null,
      access_token: null,
      rulesUserID: [],
      rulesPassword: [],
      rulesStoreID: [],
    },

    connect_makro_data: [],
    shopMakro: {
      id: 0,
      shopId: parseInt(localStorage.getItem("shop_id")),
      shopName: null,
      url: null,
      token: null,
      rulesUrl: [],
      rulesToken: []
    },

    connect_nexgen_data: [],
    shopNexgen: {
      id: 0,
      shopId: parseInt(localStorage.getItem("shop_id")),
      ShopName: null,
      nexgenShopID: null,
      texID: null,
      apiKey: null,
      apiSecret: null,
      token: null,
      rulesName: [],
      rulesShopID: [],
      rulesTexID: [],
      rulesApiKey: [],
      rulesApiSecret: [],
      rulesToken: []
    },

    connect_bentoweb_data: [],
    shopBentoWeb: {
      id: 0,
      shopId: parseInt(localStorage.getItem("shop_id")),
      shopName: null,
      userID: null,
      password: null,
      storeID: null,
      clientID: null,
      clientSecret: null,
      rulesShopName: [],
      rulesUserID: [],
      rulesPassword: [],
      rulesStoreID: [],
      rulesClientID: [],
      rrulesClientSecret: []
    },

    connect_lineoa_data: [],
    dialog_line_oa: {
      lineId: null,
      lineName: null,
      lineToken: null,
    },
    LineMessageConnection:{},
    lineType: 1,
    lineTypeList: [],
    hourList: GetHourList(),
    hour: { data: "00" },
    minuteList: GetMinuteList(),
    minute: { data: "00" },

    // dialog
    connect_dialog: false,
    dialog_title: null,
    dialog_type: null,
    popupSize: "45%",
    popupSize1:"60%",
    // marketplace
    shop: {
      id: localStorage.getItem("shop_id"),
      isUpdateStockMarketplace: false,
      percentUpdateStockShopee: null,
      percentUpdateStockLazada: null,
      percentUpdateStockJDCentral: null,
      percentUpdateStockVrich: null,
      percentUpdateStockZwiz: null,
      percentUpdateStockWooCommerce: null,
      percentUpdateStockLineNotify: null,
      percentUpdateStockTiktok: null,
      percentUpdateStockShopify: null,
      minimumStock: null,
      minimumStockUpdateTo: null,
      // palamiter
      is_Active: false,
      marketplaceList: [
        {
          id: 1,
          isActive: false,
          select: false,
          percent: null,
          name: "Shopee",
          photoLink:
            "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/shopee.png",
        },
        {
          id: 2,
          isActive: false,
          select: false,
          percent: null,
          name: "Lazada",
          photoLink:
            "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/lazada.png",
        },
        {
          id: 3,
          isActive: false,
          select: false,
          percent: null,
          name: "JD Central",
          photoLink:
            "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/Shop/shop20202109292223580",
        },
        {
          id: 4,
          isActive: false,
          select: false,
          percent: null,
          name: "Woo Commerce",
          photoLink:
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/woo.png",
        },
        {
          id: 5,
          isActive: false,
          select: false,
          percent: null,
          name: "Tiktok",
          photoLink:
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/TikTok-Logo-1.png",
        },
        {
          id: 6,
          isActive: false,
          select: false,
          percent: null,
          name: "Line MyShop",
          photoLink:
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/linemyshop.png",
        },
        {
          id: 7,
          isActive: false,
          select: false,
          percent: null,
          name: "Shopify",
          photoLink:
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/Screenshot+2024-03-09+004759.png",
        }
        // {
        //   id: 7,
        //   isActive: false,
        //   select: false,
        //   percent: null,
        //   name: "Vrich",
        //   photoLink: "https://dewteerapat.vrich619.com/img/logo.png",
        // },
        // {
        //   id: 8,
        //   isActive: false,
        //   select: false,
        //   percent: null,
        //   name: "Zwiz",
        //   photoLink:
        //     "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/zwizlogo.jpg",
        // },
        // {
        //   id: 9,
        //   isActive: false,
        //   select: false,
        //   percent: null,
        //   name: "Line Notify",
        //   photoLink:
        //     "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/line.png",
        // }

      ],
    },
    
    logoConnect:null,
    webhookBearer:null,
    webhookUrl:null,
    apiauthenid:null,
    isWebhookTested:false,
    token_line_oa:null,
    //peak
    peak:{
      id:0,
      IsDelete:true,
      Token:null,
      PaymentMethod:null,
      MethodCode:null,
      PaymentMethodCheck:null,
      FirstTimeCheck:true,
      sendOrder:false,
      selectChannelData:[],
      nextStepAuthen:false,
      contact:null,
      uniqueID:0,
      marketplaceList: [
        {
          id: 3,
          uniqueID:0,
          isActive: false,
          select: false,
          contac: null,
          productID:null,
          MethodCode:null,
          contacValidate:null,
          productIDValidate:null,
          name: "Shopee",
          photoLink:
            "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/shopee.png",
        },
        {
          id: 4,
          uniqueID:0,
          isActive: false,
          select: false,
          contac: null,
          productID:null,
          MethodCode:null,
          contacValidate:null,
          productIDValidate:null,
          name: "Lazada",
          photoLink:
            "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/lazada.png",
        },
        {
          id: 144,
          uniqueID:0,
          isActive: false,
          select: false,
          contac: null,
          productID:null,
          MethodCode:null,
          contacValidate:null,
          productIDValidate:null,
          name: "Woo Commerce",
          photoLink:
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/woo.png",
        },
        {
          id: 11,
          uniqueID:0,
          isActive: false,
          select: false,
          contac: null,
          productID:null,
          MethodCode:null,
          contacValidate:null,
          productIDValidate:null,
          name: "Tiktok",
          photoLink:
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/TikTok-Logo-1.png",
        },
        {
          id: 8,
          uniqueID:0,
          isActive: false,
          select: false,
          contac: null,
          productID:null,
          MethodCode:null,
          contacValidate:null,
          productIDValidate:null,
          name: "Line MyShop",
          photoLink:
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/linemyshop.png",
        },
        {
          id: 6,
          uniqueID:0,
          isActive: false,
          select: false,
          contac: null,
          productID:null,
          MethodCode:null,
          contacValidate:null,
          productIDValidate:null,
          name: "Shopify",
          photoLink:
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/Screenshot+2024-03-09+004759.png",
        }
      ],
    },
    peakRule:{
      paymentMethodCodeRule:[],
    },
    // callBack
    data_callback: {
      id: 0,
      branchID: null,
      shopID: null,
      urlCallback: null,
      statusWaitPack: false,
      statusPacked: false,
      statusReady: false,
      statusSent: false,
      statusCancel: false,
      isDelete: false,
      isActive: false,
    },

    connect_token_data: [],
    Master_Warehouse:[],
    Shopee_Warehouse:[],
    Lazada_Warehouse:[],
    Tiktok_Warehouse:[],
    Woo_Warehouse:[],
    Shopify_Warehouse:[],
    LineMyShop_Warehouse:[] ,
    Plugo_Warehouse:[] ,
    Amaze_Warehouse:[] ,
    Makro_Warehouse:[] ,
    Nexgen_Warehouse:[] ,
    BentoWeb_Warehouse:[] ,
    ShopeeWarehouse_Selected:0,
    LazadaWarehouse_Selected:0,
    TiktokWarehouse_Selected:0,
    WooWarehouse_Selected:0,
    LineMyShopWarehouse_Selected:0,
    ShopifyWarehouse_Selected:0,
    PlugoWarehouse_Selected:0,
    AmazeWarehouse_Selected:0,
    NexgenWarehouse_Selected:0,
    BentoWebWarehouse_Selected:0,
    jaspalShop:[1888,6264,6265,1572,4869,4560],
    synnexBranch:[727,714],
    dialog_token_chanal: null,
    chanal_list: [],
    dialog_token_staff: null,
    staff_list: [],
    shop_data: null,
    shopInfo : JSON.parse(localStorage.getItem("shop")),
    lazadaStoreCode:null,
    shopeeStoreCode:null,
    tiktokStoreCode:null,
    invoiceAccount:null,
    inventLocation:null,
    synnex_ischeckcost: true,
    warehouse_list: [],
    dialog_token_warehouse: null,
    // line my shop
    line_my_shop_data_list: [],
    line_my_shop_data_list_for_edit: [],

    dialog_line_my_shop: {
      id: 0,
      token: null,
      shopName: null,
      salemanID: null,
    },
    line_action_type: null,

    token_line: null,
    PercentUpdateStock:0,
    CurrentUpdateStock:0,
    TotalUpdateStock:0,

    IsShowPercentSyncProgress:false,
    ResyncButtonPressed:false,
    IsShowSyncSuccess:false,
    IsShowCancelSyncButton:false,
    // fb
    fbSignInParams: {
      scope: 'public_profile, email, pages_show_list, pages_manage_metadata, pages_messaging, pages_manage_engagement, pages_read_engagement, pages_read_user_content, pages_manage_posts, pages_manage_cta, page_events, pages_messaging_subscriptions',
      return_scopes: true
    },
    codeFacebook: '',
    curDomain: null,

    token_login : null,
    facebook_UserID : null,
    user_access_token : null,
    fb_page_lists : [],
    fb_selected: [],
    connect_fackbook_data: [],
    show_admin_only: null,
    shop_feature:JSON.parse(localStorage.getItem("shop_feature")),
    ChatFeature:false,
    // ขนาดจอ
    size: "lg",
    window: {
      width: 0,
      height: 0,
    },
  }),
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    size() {
      if (this.size == "xs" || this.size == "sm") {
        this.popupSize = "95%";
        this.popupSize1 = "95%";
      } else {
        this.popupSize = "40%";
        this.popupSize1 = "60%";
      }
    },
  },
  async created() {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
      this.headers_shopee = [
      { text: this.use_language.number, align: "center", sortable: false, value: "no", width: "100px" },
      { text: "ID " + this.use_language.menu_manageshop, align: "left", value: "shopeeShopId",  sortable: false, width: "100px"},
      { text: this.use_language.shop_name, align: "left", value: "shopeeShopName", sortable: false },
      { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
      { text: this.use_language.creation_date, align: "center", value: "created",  sortable: false, width: "150px" },
      { text: this.use_language.expire, align: "center", value: "expired",  sortable: false, width: "150px"},
      { text: this.use_language.auto_pickup, align: "center", value: "isAutoInit", sortable: false, width: "80px" },
      { text: this.use_language.delete, align: "center", value: "isDelete", sortable: false, width: "60px" },
      ];
      this.headers_lazada = [
      { text: this.use_language.number, align: "center", sortable: false, value: "no", width: "100px" },
      {
        text: "ID " + this.use_language.menu_manageshop,
        align: "left",
        value: "lazadaUserId",
        sortable: false,
        width: "100px",
      },
      { text: this.use_language.shop_name, align: "left", value: "lazadaShopName", sortable: false },
      {
        text: this.use_language.creation_date,
        align: "center",
        value: "createDateTime",
        sortable: false,
        width: "150px",
      },
      { text: this.use_language.expire, align: "center", value: "expired",  sortable: false, width: "150px"},
      {
        text: this.use_language.auto_pickup,
        align: "center",
        value: "isAutoInit",
        sortable: false,
        width: "80px",
      },
      { text: this.use_language.delete, align: "center", value: "isDelete", sortable: false, width: "60px" },
      ];
      this.headers_vrich = [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "10%" },
      { text: "Token", align: "left", value: "token", sortable: false, width: "50%" },
      { text: "PushURL", align: "left", value: "pushURL", sortable: false, width: "10%" },
      {
        text: "PushToken",
        align: "left",
        value: "pushToken",
        sortable: false,
        width: "10%",
      },
      { text: this.use_language.edit, align: "center", sortable: false, value: "edit", width: "10%" },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
      this.headers_zwiz = [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "10%" },
      { text: "Token", align: "left", value: "token", sortable: false, width: "50%" },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
      this.headers_tiktok = [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "10%" },
      { text: this.use_language.menu_manageshop, align: "left", value: "shop_name", sortable: false },
      { text: "ID " + this.use_language.menu_manageshop, align: "left", value: "tiktok_shop_id", sortable: false },
      { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
      { text: this.use_language.creation_date, align: "center", value: "createDateTime",  sortable: false, width: "150px",},
      { text: this.use_language.expire, align: "center", value: "expired",  sortable: false, width: "150px"},
      { text: this.use_language.auto_pickup,  align: "center", value: "isAutoInit", sortable: false, width: "80px",},
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
      this.headers_shopify = [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: "URL " + this.use_language.menu_manageshop, align: "left", value: "baseUrl", sortable: false },
      { text: "Client ID", align: "left", value: "clientID", sortable: false },
      { text: "Client Secret", align: "left", value: "clientSecret", sortable: false },
      { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
      { text: this.use_language.edit, align: "center", value: "edit", sortable: false, width: "100px" },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
      this.telegramTypeList = [
      { id: 1, active: true, disabled: false, name: this.use_language.notify_low_stock },
      { id: 3, active: true, disabled: false, name: this.use_language.notify_new_order },
      { id: 2, active: true, disabled: false, name: this.use_language.notify_end_of_day_sales },
      { id: 4, active: true, disabled: false, name: this.use_language.notify_other },
      ];
      this.lineTypeList = [
      { id: 1, disabled: false, name: this.use_language.notify_low_stock },
      { id: 3, disabled: false, name: this.use_language.notify_new_order },
      { id: 2, disabled: false, name: this.use_language.notify_end_of_day_sales },
      { id: 4, disabled: false, name: this.use_language.notify_other },
      ];
    this.curDomain = window.location.origin;
     
    
    this.handleResize();
  
    if(this.jaspalShop.includes(this.ShopID)){
       
      
      this.headers_shopify.splice(5,0,{ text: "Store Code", align: "center", sortable: false, value: "storeCode", width: "70px" })
      this.headers_shopee.splice(6,0,{ text: "Store Code", align: "center", sortable: false, value: "ap21_sale_code", width: "70px" })
      this.headers_lazada.splice(5,0,{ text: "Store Code", align: "center", sortable: false, value: "ap21_sale_code", width: "70px" })
      this.headers_tiktok.splice(6,0,{ text: "Store Code", align: "center", sortable: false, value: "ap21_sale_code", width: "70px" })
    }
    if (this.synnexBranch.includes(this.BranchID)) {
      const checkCostCol = { text: this.use_language.check_cost, align: "center", sortable: false, value: "synnex_IsCheckCost", width: "120px" }
      this.headers_shopee.splice(this.headers_shopee.length - 1, 0, { ...checkCostCol })
      this.headers_lazada.splice(this.headers_lazada.length - 1, 0, { ...checkCostCol })
      this.headers_tiktok.splice(this.headers_tiktok.length - 1, 0, { ...checkCostCol })
    }
    await this.GetAllConnect();
    this.getTelegramList()
    this.getAc2()
    this.get_shop_call_back_url(); 
    this.get_shop_stock_allocation(); 
    if(this.shop_feature!=null && this.shop_feature.filter((i)=>i.featureID==2).length>0){
      this.ChatFeature=true;
    }
    this.ChatFeature=true; 
    this.logoConnect=this.shopInfo.logo_Square;
    await this.getPeakChannel()

    this.get_shop_market();
    this.headers_vrich[1].width = this.window.width / 2 + "px";
    this.headers_zwiz[1].width = this.window.width / 2 + "px";
    this.page_loading = false;
    this.IsDev = shopCallbackService.substring(8, 11);

    this.Master_Warehouse=  (await ShopHelper.get_warehouse_list(localStorage.getItem("shop_id"))).data;
    
    if(this.Master_Warehouse.length!=1){
      if(this.language=="th"){
        this.Master_Warehouse.unshift({id:0,name:"--" + this.use_language.please_select_warehouse + "--"});
      }
      else if(this.language=="en"){
        this.Master_Warehouse.unshift({id:0,name:"--Please select warehouse--"});
      }
      else if(this.language=="cn"){
        this.Master_Warehouse.unshift({id:0,name:"--请选择仓库--"});
      }
      
    }
    this.Shopee_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.Lazada_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.Tiktok_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.Woo_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.LineMyShop_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.Shopify_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.Plugo_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.Amaze_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.Makro_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.Nexgen_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  
    this.BentoWeb_Warehouse =JSON.parse(JSON.stringify( this.Master_Warehouse));  

    this.ShopeeWarehouse_Selected=this.Shopee_Warehouse[0];
    this.LazadaWarehouse_Selected=this.Lazada_Warehouse[0];
    this.TiktokWarehouse_Selected=this.Tiktok_Warehouse[0];
    this.WooWarehouse_Selected=this.Woo_Warehouse[0];
    this.LineMyShopWarehouse_Selected=this.LineMyShop_Warehouse[0];
    this.ShopifyWarehouse_Selected=this.Shopify_Warehouse[0];
    this.PlugoWarehouse_Selected=this.Plugo_Warehouse[0];
    this.AmazeWarehouse_Selected=this.Amaze_Warehouse[0];
    this.MakroWarehouse_Selected=this.Makro_Warehouse[0];
    this.NexgenWarehouse_Selected=this.Nexgen_Warehouse[0];
    this.BentoWebWarehouse_Selected=this.BentoWeb_Warehouse[0];

    await this.facebooksignup()
    await this.get_shop_page_list(); 

    if(this.$route.query.admin == 1){
      this.show_admin_only = this.$route.query.admin
    }else {
      this.show_admin_only = null
    }

    this.createDayList()
    this.CheckSyncStatus();
  },

  mounted() {
    window.onTelegramAuth = this.onTelegramAuth;

    // โหลด script Telegram widget (แค่ครั้งเดียว)
    if (!document.getElementById('telegram-widget-lib')) {
      const script = document.createElement('script');
      script.id = 'telegram-widget-lib';
      script.src = 'https://telegram.org/js/telegram-widget.js?7';
      document.head.appendChild(script);
    }
  },

  computed: {
    ac2Headers() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "no", width: "100px" },
      { text: this.use_language.shop_name, align: "center", value: "shopName", sortable: false },
      { text: "token", align: "center", value: "token", sortable: false },
      { text: this.use_language.pack_number, align: "center", value: "isPackByPackhai",  sortable: false, width: "150px" },
      { text: this.use_language.creation_date, align: "center", value: "createdShow",  sortable: false, width: "150px"},
      { text: this.use_language.edit, align: "center", value: "edit",  sortable: false, width: "70px"},
      { text: this.use_language.delete, align: "center", value: "delete",  sortable: false, width: "70px"},
      ];
    },
    daysLoop() {
      return [
      { id: 0, text: this.use_language.sunday },
      { id: 1, text: this.use_language.monday },
      { id: 2, text: this.use_language.tuesday },
      { id: 3, text: this.use_language.wednesday },
      { id: 4, text: this.use_language.thursday },
      { id: 5, text: this.use_language.friday },
      { id: 6, text: this.use_language.saturday },
      ];
    },
    headers_table_shopee_chat() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "no", width: "100px" },
      { text: "ID " + this.use_language.menu_manageshop, align: "left", value: "shopeeShopId",  sortable: false, width: "100px"},
      { text: this.use_language.shop_name, align: "left", value: "shopeeShopName", sortable: false }, 
      { text: this.use_language.creation_date, align: "center", value: "created",  sortable: false, width: "150px" },
      { text: this.use_language.expire, align: "center", value: "expired",  sortable: false, width: "150px"}, 
      { text: this.use_language.delete, align: "center", value: "isDelete", sortable: false, width: "60px" },
      ];
    },
    headers_table_lazada_chat() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "no", width: "100px" },
      { text: "ID " + this.use_language.menu_manageshop, align: "left", value: "lazadaSellerID",  sortable: false, width: "100px"},
      { text: this.use_language.shop_name, align: "left", value: "lazadaShopName", sortable: false }, 
      { text: this.use_language.creation_date, align: "center", value: "createDateTime",  sortable: false, width: "150px" },
      { text: this.use_language.expire, align: "center", value: "refresh_expires_in",  sortable: false, width: "150px"}, 
      { text: this.use_language.delete, align: "center", value: "isDelete", sortable: false, width: "60px" },
      ];
    },
    headers_lazada_warehouse() {
      return [
      
      {
        text: this.use_language.warehouse_name + " Lazada",
        align: "left",
        value: "lazadaWarehouseName",
        sortable: false,
       
      },
      {
        text: "Code " + this.use_language.treasury + " Lazada",
        align: "left",
        value: "lazadaWarehouseCode",
        sortable: false,
       
      },
      {
        text: this.use_language.warehouse_address + " Lazada",
        align: "left",
        value: "lazadaWarehouseAddress",
        sortable: false,
       
      },
      {
        text: this.use_language.connected_warehouses,
        align: "left",
        value: "systemWarehouse",
        sortable: false,
       
      },
      { text: this.use_language.delete, align: "center", value: "isDelete", sortable: false, width: "60px" },
      ];
    },
    headers_syncStock() {
      return [
      { text: this.use_language.edit, align: "center", sortable: false, value: "edit", width: "100px" },
      { text: this.use_language.channel, align: "left", value: "platformLogo", sortable: false , width: "80px"},
      { text: this.use_language.menu_manageshop, align: "left", value: "platformShopName", sortable: false, width: "300px" },
      { text: this.use_language.status + " sync stock", align: "left", value: "isUpdateStock", sortable: false, width: "120px" },
      { text: "%" + this.use_language.action_word + " sync", align: "left", value: "updateStockPercent", sortable: false, width: "90px" },
      { text: this.use_language.note, align: "left", value: "remark", sortable: false },
     
      ];
    },
    headers_woo() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: "URL " + this.use_language.menu_manageshop, align: "left", value: "baseURL", sortable: false },
      { text: "App Key", align: "left", value: "appKey", sortable: false },
      { text: "App Secret", align: "left", value: "appSecret", sortable: false },
      { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
      { text: this.use_language.edit, align: "center", value: "edit", sortable: false, width: "100px" },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
    headers_telegram() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: "ChatID", align: "left", value: "chatID", sortable: false },
      { text: this.use_language.category, align: "left", value: "typeName", sortable: false, width: "220px",},
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
    headers_line() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: "Token", align: "left", value: "token", sortable: false },
      {
        text: this.use_language.category,
        align: "left",
        value: "typeName",
        sortable: false,
        width: "220px",
      },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
    headers_lineoa() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: this.use_language.name + " Line", align: "left", value: "lineName", sortable: false },
      { text: "Webhook url", align: "left", value: "webhookUrl", sortable: false, width: "60%" },
      { text: this.use_language.delete, align: "left", value: "delete", sortable: false, width: "40px" },
      ];
    },
    headers_plugo() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: this.use_language.name + " Plugo", align: "left", value: "shopName", sortable: false },
      { text: "VendorID", align: "left", value: "vendorID", sortable: false, width: "60%" },
      { text: "ApiKey", align: "left", value: "apiKey", sortable: false, width: "60%" },
      { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
      { text: this.use_language.edit, align: "center", value: "edit", sortable: false, width: "100px" },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
    headers_amaze() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: this.use_language.name + " Amaze", align: "left", value: "amazeShopName", sortable: false, width: "160px" },
      { text: "UserID", align: "left", value: "userID", sortable: false, width: "80px" },
      { text: "ShopAmazeId", align: "left", value: "amazeShopID", sortable: false },
      { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
      { text: this.use_language.connection_date, align: "left", value: "createdShow", sortable: false },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
     headers_Makro() {
       return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: this.use_language.shop_name_label, align: "left", value: "name", sortable: false, width: "160px" },
      { text: "URL", align: "left", value: "url", sortable: false, width: "250px" },
      { text: "Token", align: "left", value: "token", sortable: false },
      { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
      { text: this.use_language.connection_date, align: "left", value: "created", sortable: false },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
       ];
     },
     headers_nexgen() {
      return [
        { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
        { text: this.use_language.shop_name_label, align: "left", value: "nexGenShopName", sortable: false, width: "160px" },
        { text: "ShopNexgenId", align: "left", value: "nexGenShopID", sortable: false, width: "250px" },
        { text: "Token", align: "left", value: "access_token", sortable: false },
        { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
        { text: this.use_language.connection_date, align: "left", value: "createdShow", sortable: false },
        { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
    headers_bentoweb() {
      return [
        { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
        { text: this.use_language.shop_name_label, align: "left", value: "shopName", sortable: false, width: "160px" },
        { text: "StoreId", align: "left", value: "storeId", sortable: false, width: "250px" },
        { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false },
        { text: this.use_language.connection_date, align: "left", value: "createdShow", sortable: false },
        { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
    headers_token() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: "Token", align: "left", value: "token", sortable: false },
      {
        text: this.use_language.sales_channel,
        align: "left",
        value: "channelName",
        sortable: false,
        width: "150px",
      },
      {
        text: this.use_language.connected_warehouse,
        align: "left",
        value: "warehouseName",
        sortable: false,
        width: "150px",
      },
      {
        text: this.use_language.salesperson,
        align: "left",
        value: "salemanName",
        sortable: false,
        width: "150px",
      },
      {
        text: "webhook",
        align: "left",
        value: "webhookUrl",
        sortable: false,
        width: "300px",
      },
      {
        text: this.use_language.menu_settings + " Webhook",
        align: "left",
        value: "webhookSetting",
        sortable: false, 
        width: "60px"
      },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
    headers_line_my_shop() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      {
        text: this.use_language.shop_name_label,
        align: "left",
        value: "shopName",
        sortable: false,
        width: "150px",
      },
      {
        text: this.use_language.salesperson,
        align: "left",
        value: "salemanName",
        sortable: false,
        width: "150px",
      },
      { text: "API KEY", align: "left", value: "token", sortable: false, width: "100px" },
      { text: this.use_language.connected_warehouse, align: "left", value: "warehouseName", sortable: false,width: "200px"   },
      {
        text: "CallbackUrl",
        align: "left",
        value: "callBackUrl",
        sortable: false,
        width: "250px",
      },
      {
        text: this.use_language.creation_date,
        align: "left",
        value: "createdShow",
        sortable: false,
        width: "150px",
      },
      { text: this.use_language.edit, align: "center", sortable: false, value: "edit", width: "60px" },
      { text: this.use_language.delete, align: "center", sortable: false, value: "delete", width: "60px" },
      ];
    },
    headers_fackbook() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No", width: "100px" },
      { text: "Logo", align: "center",value: "pagePictureURL",sortable: false, width: "60px"},
      { text: this.use_language.page_name, align: "left",value: "pageName",sortable: false, width: "220px"},
      { text: this.use_language.connection_date, align: "center",value: "created",sortable: false, width: "160px"},
      { text: this.use_language.delete, align: "center", value: "isDelete", sortable: false, width: "60px" },
      ];
    },
    headers_fackbook_for_select() {
      return [
      { text: this.use_language.number, align: "center", sortable: false, value: "No"},
      { text: "Logo", align: "center",value: "facebook_PagePictureURL",sortable: false},
      { text: this.use_language.page_name, align: "left",value: "facebook_PageName",sortable: false},
      ];
    },
  },
  methods: {
    get_languages,
    async getAc2() {
      let response = await axios.post(
        ecomService_dotnet + 'Ac2/get-shop-ac2',
        { shopID: JSON.parse(localStorage.getItem("shop_id")) },
        { headers: header_token }
      );
      this.ac2Lsit = response.data.data
    },
    async updateAc2() {
      let response = await axios.post(
        ecomService_dotnet + 'Ac2/update-shop-ac2',
        this.ac2Item,
        { headers: header_token }
      );
      if (response.data.status == "success") {
        Swal.fire({
          position:"top",
          type: "success",
          toast:true,
          timer:1500,
          text: this.use_language.ac2_connected_success,
        });
        this.closeDialogAc2()
        this.ac2Lsit = response.data.data
      }
    },
    async deleteAc2(item) {
      Swal.fire({ 
        type: "question", 
        text: this.use_language.confirm_want_delete,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.post(
            ecomService_dotnet + 'Ac2/update-shop-ac2',
            {
              "id": item.id,
              "shopID": localStorage.getItem("shop_id"),
              "shopName": item.shopName,
              "token": item.token,
              "createdBy": localStorage.getItem("staff_id"),
              "isPackByPackhai": item.isPackByPackhai,
              "isDeleted": true
            },
            { headers: header_token }
          );
          if (response.data.status == "success") {
            Swal.fire({
              position:"top",
              type: "success",
              toast:true,
              timer:1500,
              text: this.use_language.ac2_disconnect_success,
            });
            this.ac2Lsit = response.data.data
          }
        }
      });
    },
    openDialogAc2(item) {
      this.dialog_ac2 = true
      this.ac2Item = {
        id: item.id,
        shopID: localStorage.getItem("shop_id"),
        shopName: item.shopName,
        token: item.token,
        createdBy: localStorage.getItem("staff_id"),
        isPackByPackhai: item.isPackByPackhai,
        isDeleted: false
      }
    },
    closeDialogAc2() {
      this.dialog_ac2 = false
      this.ac2Item = {
        id: null,
        shopID: localStorage.getItem("shop_id"),
        shopName: "",
        token: "",
        createdBy: localStorage.getItem("staff_id"),
        isPackByPackhai: false,
        isDeleted: false
      }
    },
    //
    async createBtnTelegram() {
      // ล้าง widget เก่าถ้ามี
      const container = document.getElementById('telegram-login-button');
      container.innerHTML = '';

      // สร้าง widget ใหม่ทุกครั้ง
      const widget = document.createElement('script');
      widget.src = 'https://telegram.org/js/telegram-widget.js?7';
      widget.setAttribute('data-telegram-login', 'Packhai_Bot');
      widget.setAttribute('data-size', 'large');
      widget.setAttribute('data-userpic', 'false');
      widget.setAttribute('data-onauth', 'onTelegramAuth(user)');
      widget.setAttribute('data-request-access', 'write');

      container.appendChild(widget);

    },
    async onTelegramAuth(user) {
      var isActive = this.telegramTypeList.filter(i => i.active == true).map(i => i.id);
      var isTime = this.telegramTypeList.find(i => i.id == 2 && i.active == true);

      let response = await axios.post(
        ecomService_dotnet + 'Telegram/authorize',
        {
          shopID: JSON.parse(localStorage.getItem("shop_id")),
          chatID: user.id.toString(),
          type: isActive,
          time: isTime == undefined ? null : this.hour.data + ":" + this.minute.data
        },
        { headers: header_token }
      );
      if (response.data == "success") {
        Swal.fire({
          position:"top",
          type: "success", 
          toast:true,
          timer:1500,
          text: this.use_language.telegram_connected_success,
        });
        await this.closedialog("telegram bot")
        this.connect_dialog = false;
        this.getTelegramList()
      }
    },
    async getTelegramList() {
      let response = await axios.post(
        ecomService_dotnet + 'Telegram/get-telegram',
        {
          shopID: JSON.parse(localStorage.getItem("shop_id")),
        },
        { headers: header_token }
      );
      this.connect_telegram_data = response.data
      this.connect_telegram_data = this.connect_telegram_data.map((item) =>
        ({...item, typeName: this.telegramTypeList.filter(x => x.id == item.type)[0].name})
      )
    },
    async DeleteTelegram(item){
      Swal.fire({ 
        type: "question", 
        text: this.use_language.confirm_want_delete,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.post(
            ecomService_dotnet + "Telegram/remove",
            {
              "shopID": JSON.parse(localStorage.getItem("shop_id")),
              "telegramID": item.id
            },
            { headers: this.header_token }
          );
          if (response.data == "success") {
            Swal.fire({
              position:"top",
              type: "success", 
              toast:true,
              timer:1500,
              text: this.use_language.telegram_deleted,
            });
            this.getTelegramList()
          }
        }
      });
    },
    daysLoopActiveChanged(item){
      if(item.isActive){
        item.initType = 1;
      }else{
        item.initType = null;
        item.startTime = null;
        item.endTime = null
      }
    },
    async get_shop_stock_allocation(){
      var shopid=localStorage.getItem("shop_id");
      let marketplaceList = await axios.get(
        ecomService_dotnet + "Shop/get-marketplace-allocation?ShopID="+shopid ,
        { headers: this.header_token }
      );

      this.syncStockInfoList = marketplaceList.data.items;

    },
    async addToLocal(type) {
      if (type == 1) {
        localStorage.setItem("day_active_shopee", JSON.stringify(this.dayListShopee))
      } else if ( type == 2) {
        localStorage.setItem("day_active_lazada", JSON.stringify(this.dayListLazada))
      } else {
        localStorage.setItem("day_active_tiktok", JSON.stringify(this.dayListTiktok))
      }
    },
    async createDayList() {
      this.dayListShopee=[]
      this.dayListLazada=[]
      this.dayListTiktok=[]
      for (let i = 0; i < 7; i++) {
        this.dayListShopee.push({
          "dayOfWeek": i,
          "isActive": true,
          "initType":1
        })
        this.dayListLazada.push({
          "dayOfWeek": i,
          "isActive": true,
          "initType":1
        })
        this.dayListTiktok.push({
          "dayOfWeek": i,
          "isActive": true,
          "initType":1
        })
      }
    },
    openDialogEdit(item, type) {
      this.countOpen++
      this.dialogEdit = true
      this.dialogEditType = type
    
      
      this.inventLocation=null;
      this.invoiceAccount=null;
      if (type == 'shopee') {
        this.dayListEditShopee = []
        this.shopeeIdEdit = item.shopeeShopId
        if (item.initTimeSetting != null) {
          item.initTimeSetting.forEach((e) => {
            this.dayListEditShopee.push({
              'id': 's' + this.countOpen,
              'dayOfWeek': e.dayOfWeek,
              'endTime': e.endTime,
              'initType': e.initType,
              'isActive': e.isActive,
              'startTime': e.startTime
            })
          });
        } else {
          for (let i = 0; i < 7; i++) {
            this.dayListEditShopee.push({
              "dayOfWeek": i,
              "isActive": true,
              "initType":1
            })
          }
        }
      } else if (type == 'lazada') {
        this.dayListEditLazada = []
        this.lazadaIdEdit = item.lazadaSellerId
        if (item.initTimeSetting != null) {
          item.initTimeSetting.forEach((e) => {
            this.dayListEditLazada.push({
              'id': 'l' + this.countOpen,
              'dayOfWeek': e.dayOfWeek,
              'endTime': e.endTime,
              'initType': e.initType,
              'isActive': e.isActive,
              'startTime': e.startTime
            })
          });
        } else {
          for (let i = 0; i < 7; i++) {
            this.dayListEditLazada.push({
              "dayOfWeek": i,
              "isActive": true,
              "initType":1
            })
          }
        }
      } else if (type == 'tiktok') {
        this.dayListEditTiktok = []
        this.tiktokIdEdit = item.tiktok_shop_id
        if (item.initTimeSetting != null) {
          item.initTimeSetting.forEach((e) => {
            this.dayListEditTiktok.push({
              'id': 't' + this.countOpen,
              'dayOfWeek': e.dayOfWeek,
              'endTime': e.endTime,
              'initType': e.initType,
              'isActive': e.isActive,
              'startTime': e.startTime
            })
          });
        } else {
          for (let i = 0; i < 7; i++) {
            this.dayListEditTiktok.push({
              "dayOfWeek": i,
              "isActive": true,
              "initType":1
            })
          }
        }
      }
    },
    closeDialogEdit() {
      this.dialogEdit = false
    },
    async updateInitTimeSetting() {
      var list = []
      if (this.dialogEditType == 'shopee') {
        this.dayListEditShopee.forEach((e) => {
          list.push({
            'dayOfWeek': e.dayOfWeek,
            'isActive': e.isActive,
            'initType': e.initType,
            'startTime': e.startTime,
            'endTime': e.endTime
          })
        });
        let response = await axios.post(
          ecomService_dotnet + "Shopee/update-auto-init-timerange",
          {
            shopee_shopID: this.shopeeIdEdit,
            initTimeSetting: list
          },
          { headers: this.header_token }
        );
        this.get_data_connect_shopee()

      } else if (this.dialogEditType == 'lazada') {
        this.dayListEditLazada.forEach((e) => {
          list.push({
            'dayOfWeek': e.dayOfWeek,
            'isActive': e.isActive,
            'initType': e.initType,
            'startTime': e.startTime,
            'endTime': e.endTime
          })
        });
        let response = await axios.post(
          ecomService_dotnet + "Lazada/update-auto-init-timerange",
          {
            lazadaSellerID: this.lazadaIdEdit,
            initTimeSetting:list
          },
          { headers: this.header_token }
        );
        this.get_data_connect_lazada()

      } else if (this.dialogEditType == 'tiktok') {
        this.dayListEditTiktok.forEach((e) => {
          list.push({
            'dayOfWeek': e.dayOfWeek,
            'isActive': e.isActive,
            'initType': e.initType,
            'startTime': e.startTime,
            'endTime': e.endTime
          })
        });
        let response = await axios.post(
          ecomService_dotnet + "Tiktok/update-auto-init-timerange",
          {
            tiktok_shop_id: this.tiktokIdEdit,
            initTimeSetting: list
          },
          { headers: this.header_token }
        );
        this.get_data_connect_tiktok()

      }
      this.closeDialogEdit()
    },
    async connect_shopee_chat(){
      var url = document.URL;
      let response = await axios.get(expressService_dotnet + "ShopeeChat/get-auth-chat-app?url="+url,{ headers: this.header_token });
      var url_shopee = response.data.url;  
      window.location.assign(url_shopee);
    },
    async get_connect_shopee_chat(){ 
      let response = await axios.get(expressService_dotnet + "ShopeeChat/get-chat-app-list?shopId"+this.ShopID,{ headers: this.header_token });
      this.item_table_shopee_chat = response.data.data;

    },
    async delete_connect_shopee_chat(item){
      Swal.fire({ 
        type: "question", 
        text: this.use_language.confirm_want_delete,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.get(expressService_dotnet + "ShopeeChat/delete-chat-app-list?id="+item.id,{ headers: this.header_token });
          await this.get_connect_shopee_chat();
        }});
    },
    async connect_lazada_chat(){
      var url = document.URL;
      let response = await axios.get(expressService_dotnet + "LazadaMessage/get-auth?url="+url,{ headers: this.header_token });
      var url_lazada = response.data.url;  
      window.location.assign(url_lazada);
    },
    async get_connect_lazada_chat(){ 
      let response = await axios.get(expressService_dotnet + "LazadaMessage/get-chat-app-list?shopId"+this.ShopID,{ headers: this.header_token });
      this.item_table_lazada_chat = response.data.data;

    },
    async delete_connect_lazada_chat(item){
      Swal.fire({ 
        type: "question", 
        text: this.use_language.confirm_want_delete,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.get(expressService_dotnet + "LazadaMessage/delete-chat-app-list?id="+item.id,{ headers: this.header_token });
          await this.get_connect_lazada_chat();
        }});
    },
    async GetAllConnect() {
      await axios
        .all([
          axios.post(
            ecomService_dotnet + "Shopee/get-shop-shopee",
            {
              shopID:  this.ShopID,
            },
            { headers: this.header_token }
          ),
          axios.get(
            expressService_dotnet + "ShopeeChat/get-chat-app-list?shopId="+this.ShopID, 
            { headers: this.header_token }
          ),
          axios.post(
            ecomService_dotnet + "Lazada/get-shop-lazada",
            {
              shopID:  this.ShopID,
            },
            { headers: this.header_token }
          ),
          axios.get(
            expressService_dotnet + "LazadaMessage/get-chat-app-list?shopId="+this.ShopID, 
            { headers: this.header_token }
          ),
          // axios.post(
          //   ecomService_dotnet + "JD/get-shop-jd",
          //   {
          //     shopID: localStorage.getItem("shop_id"),
          //   },
          //   { headers: this.header_token }
          // ),

          axios.post(
            ecomService_dotnet + "Account/GetPartnerConnections",
            {
              shopID:  this.ShopID,
            },
            { headers: this.header_token }
          ),

          axios.post(
            ecomService_dotnet + "Account/GetChannelSource",
            {
              shopId:  this.ShopID,
            },
            { headers: this.header_token }
          ),

          axios.post(ecomService_dotnet+'Line/get-token', {
            "shopId":  this.ShopID
          }, {headers: this.header_token}),

          axios.post(
            ecomService_dotnet + "Woo/get-shopwoo",
            {
              shopId:  this.ShopID,
            },
            { headers: this.header_token }
          ),
          axios.post(
            ecomService_dotnet + "Shopify/get-shop-shopify",
            {
              shopId:  this.ShopID,
            },
            { headers: this.header_token }
          ),
          axios.get(
            ecomService_dotnet +
              "Tiktok/get-shop-tiktok?shopid=" +
               this.ShopID,
            { headers: this.header_token }
          ),

          axios.post(
            ecomService_dotnet + "Line/get-shop-line",
            {
              shopID:  this.ShopID,
            },
            { headers: this.header_token }
          ),

          axios.get(
            expressService_dotnet + "CoreMessage/get-line-oa?shopId=" +  this.ShopID,
            { headers: this.header_token }
          ),

          axios.post(
            shopService_dotnet + "ShopAccPeak/get-shop-account?shopId="+ this.ShopID,
            {
            },
            { headers: this.header_token }
          ),
          
          axios.post(
            ecomService_dotnet + "Plugo/get-shop-plugo?shopId="+ this.ShopID,
            {
              shopId:  this.ShopID,
            },
            { headers: this.header_token }
          ),
          
          axios.post(
            ecomService_dotnet + "Amaze/get-shop-amaze?shopId="+ this.ShopID,
            {
              shopId:  this.ShopID,
            },
            { headers: this.header_token }
          ),
          
          axios.get(
            ecomService_dotnet + "Makro/get-shop-makro?shopId="+ this.ShopID, 
            { headers: this.header_token }
          ),

          axios.post(
            ecomService_dotnet + "NexGen/get-shop-nexgen?shopId="+ this.ShopID,
            {
              shopId:  this.ShopID,
            },
            { headers: this.header_token }
          ),

          axios.post(
            ecomService_dotnet + "BentoWeb/get-shop-bentoweb?shopId="+ this.ShopID,
            {
              shopId:  this.ShopID,
            },
            { headers: this.header_token }
          )
          
          //
          // axios.post(stockService_dotnet+'Stock/get-shop', {
          //   "shopId": localStorage.getItem('shop_id')
          // }, {headers: this.header_token}),
        ])
        .then(
          axios.spread(
            (
              shopeeList,
              shopeechatlist,
              lazadaList,
              LazadaChatlist,
              // jdList,
              APIAuthenList,
              ChannelSourceList,
              lineNotifyList,
              wooList,
              shopifyList,
              tiktokList,
              LineList,
              lineOAList,
              peakAccount,
              plugoList,
              amazeList,
              makroList,
              nexgenList,
              bentowebList,
            ) => {
              // .then(axios.spread((shopeeList, lazadaList, jdList, APIAuthenList, ChannelSourceList, lineList, wooList, tiktokList, marketplaceList) => {
              // shopee
              if (shopeeList.status == 200) {
                this.connect_shopee_data = shopeeList.data;
              }
              if (shopeechatlist.status == 200) {
                this.item_table_shopee_chat = shopeechatlist.data.data;
              }
              if (LazadaChatlist.status == 200) {
                this.item_table_lazada_chat = LazadaChatlist.data.data;
              }
              // lazada
              if (lazadaList.status == 200) {
                this.connect_lazada_data = lazadaList.data;
              }
              // jd
              // if (jdList.status == 200) {
              //   this.connect_jd_data = jdList.data;
              // }
              // vrish and zwiz
              if (APIAuthenList.status == 200) {
                this.connect_vrich_data = APIAuthenList.data.filter(
                  (x) => x.partnerName == "vrich" || x.channelID == 36
                );
                this.connect_zwiz_data = APIAuthenList.data.filter(
                  (x) => x.partnerName == "zwiz" || x.channelID == 21
                );
                this.connect_token_data = APIAuthenList.data.filter(
                  (x) => x.channelID !=null && x.salemanID !=null
                );
              }
              // ChannelSource
              if (ChannelSourceList.status == 200) {
                this.channelSourceList = ChannelSourceList.data;
                this.channelSourceList.splice(0, 0, { id: 0, channelName: "--" + this.use_language.choose + "--" });
              }
              // line
              if (lineNotifyList.status==200){
                var data = lineNotifyList.data
                this.connect_line_data = []
                for (var i in data){
                  data[i].typeName = this.lineTypeList.filter(x => x.id == data[i].type)[0].name
                  this.connect_line_data.push(data[i])
                }
                this.LineSelectType()
              }
              // line oa
              if (lineOAList.data.status == 'success') {
                this.connect_lineoa_data = lineOAList.data.data
              }
              // woo
              if (wooList.status == 200) {
                this.connect_woo_data = wooList.data;
              }
              if (makroList.status == 200) {
                this.connect_makro_data = makroList.data;
              }
              if (shopifyList.status == 200) {
                if(shopifyList.data.items!=null){
                  this.connect_shopify_data = shopifyList.data.items;
                  this.connect_shopify_data.forEach(element => {
                    element.aP21_Integration_Type = element.aP21_Integration_Type.toString();
                  });
                  
                  if(this.connect_shopify_data!=null && this.connect_shopify_data.length > 0 && this.jaspalShop.includes(this.connect_shopify_data[0].shopID))
                  {  
                    this.headers_shopify.push(   { text: "Integration", align: "center", sortable: false, value: "aP21_Integration_Type_Desc", width: "100px" });
                  }
                }
              }
              // tiktok
              if (tiktokList.status == 200) {
                this.connect_tiktok_data = tiktokList.data;
              }
               if (LineList.status == 200) {
                this.line_my_shop_data_list = LineList.data;
              }

              //peak
              if(peakAccount.data.status === 'success')
              { 
                if(peakAccount.data.shopPeak !== null)
                {
                  const dataPeak = peakAccount.data.shopPeak
                  this.peak.FirstTimeCheck = true
                  this.peak.nextStepAuthen = true
                  this.peak.Token =dataPeak.clientToken
                  this.peak.id = dataPeak.id
                  this.peak.PaymentMethod = dataPeak.paymentMethodCode
                  this.peak.sendOrder = dataPeak.isCreateReceiptSummaryDaily
                  this.peak.IsDelete = !dataPeak.isDelete
                }else{this.peak.FirstTimeCheck = false}
              }
              if (plugoList.data.status == 'success') {
                this.connect_plugo_data = plugoList.data.data;
              }
              if (amazeList.data.status == 'success') {
                this.connect_amaze_data = amazeList.data.data;
              }
              //nexgen
              if (nexgenList.status == 200) {
                this.connect_nexgen_data = nexgenList.data.data;
              }
              //bentoweb
              if (bentowebList.status == 200) {
                this.connect_bentoweb_data = bentowebList.data.data;
              }
            }
          )
        );
    },
    sync_stock_radio_changed(){
      if(this.sync_stock_radio==1 && (this.sync_stock_percent==null ||this.sync_stock_percent=='')){
        this.sync_stock_percent=100;
      }
    },
    async get_resync_stock_percent(){
      let response = await axios.get(ecomService_dotnet + "Stock/get-resync-stock-percent?ShopID="+this.ShopID,{ headers: this.header_token });
      return response;

      // if(response.data.status=="success"){

      //   this.PercentUpdateStock=  response.data.percent;
      //   this.CurrentUpdateStock=  response.data.current;
      //   this.TotalUpdateStock= response.data.total;
      //   this.IsShowSyncSuccess=false;
      //   if( this.PercentUpdateStock>0){
      //     this.IsShowPercentSyncProgress=true;
      //   }
      //   else{
      //     if(this.ResyncButtonPressed){
      //       this.IsShowPercentSyncProgress=true;
      //       this.IsShowSyncSuccess=true;
      //     }
      //     else
      //     {
      //       this.IsShowPercentSyncProgress=false;
            
      //     }
      //   }
      
      // }else{
      //   this.PercentUpdateStock=  0;
      //   this.CurrentUpdateStock= 0;
      //   this.TotalUpdateStock= 0; 
      //   Swal.fire({
      //       type: "warning", 
      //       text: response.data.error_description,
      //     });
        
      // }
    
    },
    async cancel_resync_stock(){

      Swal.fire({
     
        type: "question",
        title: this.use_language.want_to_cancel + " sync?",
        text: this.use_language.confirm_transaction,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.get(ecomService_dotnet + "Stock/cancel-resync-stock?ShopID="+this.ShopID,{ headers: this.header_token });
          
          if(response.data.status=="success"){
            Swal.fire({
              position:"top",
              type: "success", 
              toast:true,
              timer:1500,
              text: this.use_language.cancelled_successfully,
            });
            this.IsShowCancelSyncButton=false;
            this.IsShowPercentSyncProgress=false;
            this.ResyncButtonPressed=false;
            this.IsShowSyncSuccess=false;

            this.PercentUpdateStock=0;
            this.CurrentUpdateStock=0;
            this.TotalUpdateStock=0;
          }else{
            Swal.fire({
              type: "error", 
              toast:true,
              timer:1500,
              text: response.data.error_description,
            });
          }
        }
      });


    
   
    },
    async get_shop_market() {
      let marketplaceList = await axios.post(
        shopService_dotnet + "Shop/get-shop",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );

      // marketplace
      if (marketplaceList.status == 200) {
        this.shop.isUpdateStockMarketplace = marketplaceList.data.isUpdateStockMarketplace;
        this.shop.minimumStock = marketplaceList.data.minimumStock;
        this.shop.minimumStockUpdateTo = marketplaceList.data.minimumStockUpdateTo;
        this.shop.marketplaceList[0].percent = marketplaceList.data.percentUpdateStockShopee;
        this.shop.marketplaceList[1].percent = marketplaceList.data.percentUpdateStockLazada;
        // this.shop.marketplaceList[2].percent = marketplaceList.data.percentUpdateStockJDCentral;
        this.shop.marketplaceList[3].percent = marketplaceList.data.percentUpdateStockWoo;
        this.shop.marketplaceList[4].percent = marketplaceList.data.percentUpdateStockTiktok;
        this.shop.marketplaceList[5].percent = marketplaceList.data.percentUpdateStockLine;
        this.shop.marketplaceList[6].percent = marketplaceList.data.percentUpdateStockShopify;

        this.shop.marketplaceList[0].select = ((marketplaceList.data.percentUpdateStockShopee != null && marketplaceList.data.percentUpdateStockShopee != "") ? true : false);
        this.shop.marketplaceList[1].select = ((marketplaceList.data.percentUpdateStockLazada != null && marketplaceList.data.percentUpdateStockLazada != "")? true: false);
        // this.shop.marketplaceList[2].select = ((marketplaceList.data.percentUpdateStockJDCentral != null && marketplaceList.data.percentUpdateStockJDCentral != "" )? true: false);
        this.shop.marketplaceList[3].select = ((marketplaceList.data.percentUpdateStockWoo != null && marketplaceList.data.percentUpdateStockWoo != "")? true : false);
        this.shop.marketplaceList[4].select = ((marketplaceList.data.percentUpdateStockTiktok != null && marketplaceList.data.percentUpdateStockTiktok != "")? true: false);
        this.shop.marketplaceList[5].select = ((marketplaceList.data.percentUpdateStockLine != null && marketplaceList.data.percentUpdateStockLine != "")? true: false);
        this.shop.marketplaceList[6].select = ((marketplaceList.data.percentUpdateStockShopify != null && marketplaceList.data.percentUpdateStockShopify != "")? true: false);
      }

      // Check if

      if (this.connect_shopee_data.length > 0) {
        this.shop.marketplaceList[0].isActive = true;
        this.peak.marketplaceList[0].isActive = true;
        this.shop.is_Active = true;
      }
      if (this.connect_lazada_data.length > 0) {
        this.shop.marketplaceList[1].isActive = true;
        this.peak.marketplaceList[1].isActive = true;
        this.shop.is_Active = true;
      }
      if (this.connect_woo_data.length > 0) {
        this.shop.marketplaceList[3].isActive = true;
        this.peak.marketplaceList[2].isActive = true;
        this.shop.is_Active = true;
      }
      if (this.connect_tiktok_data.length > 0) {
        this.shop.marketplaceList[4].isActive = true;
        this.peak.marketplaceList[3].isActive = true;
        this.shop.is_Active = true;
      }
      if (this.line_my_shop_data_list.length > 0) {
        this.shop.marketplaceList[5].isActive = true;
        this.peak.marketplaceList[4].isActive = true;
        this.shop.is_Active = true;
      }
      if (this.connect_shopify_data.length > 0) {
        this.shop.marketplaceList[6].isActive = true;
        this.peak.marketplaceList[5].isActive = true;
        this.shop.is_Active = true;
      }
    },

    async get_data_connect_shopify() {
      this.loading = true;
      let response = await axios.post(
        ecomService_dotnet + "Shopify/get-shop-shopify",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );
      this.connect_shopify_data = response.data.items;
      this.loading = false;
    },
    async get_data_connect_shopee() {
      this.loading = true;
      let response = await axios.post(
        ecomService_dotnet + "Shopee/get-shop-shopee",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );
      this.connect_shopee_data = response.data;
      this.loading = false;
    },
    async get_data_connect_lazada() {
      this.loading = true;
      let response = await axios.post(
        ecomService_dotnet + "Lazada/get-shop-lazada",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );
      this.connect_lazada_data = response.data;
      this.loading = false;
    },
    async get_data_connect_tiktok() {
      this.loading = true;
      let response = await axios.get(
        ecomService_dotnet + "Tiktok/get-shop-tiktok?shopid=" + localStorage.getItem("shop_id"),
        { headers: this.header_token }
      );
      this.connect_tiktok_data = response.data;
      this.loading = false;
    },
    async get_data_GetPartnerConnections() {
      let response = await axios.post(
        ecomService_dotnet + "Account/GetPartnerConnections",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );
      if (response.status == 200) {
        this.connect_vrich_data = response.data.filter(
          (x) => x.partnerName == "vrich" || x.channelID == 36
        );
        this.connect_zwiz_data = response.data.filter(
          (x) => x.partnerName == "zwiz" || x.channelID == 21
        );
        this.connect_token_data = response.data.filter(
          (x) => x.channelID !=null && x.salemanID !=null
        );
      }
    },
    async update_IsAutoInit(id, isAutoInit, chanal) {
      this.loading = true;
      if (chanal == "shopee") {
        let response = await axios.post(
          ecomService_dotnet + "Shopee/update-shopee-is-auto-init",
          {
            id: id,
            isInit: isAutoInit,
          },
          { headers: this.header_token }
        );
        this.get_data_connect_shopee();
      } else if (chanal == "lazada") {
        let response2 = await axios.post(
          ecomService_dotnet + "Lazada/update-lazada-is-auto-init",
          {
            id: id,
            isInit: isAutoInit,
          },
          { headers: this.header_token }
        );
        this.get_data_connect_lazada();
      } else if (chanal == "tiktok") {
        let response2 = await axios.post(
          ecomService_dotnet + "Tiktok/update-tiktok-is-auto-init",
          {
            id: id,
            isInit: isAutoInit,
          },
          { headers: this.header_token }
        );
        this.get_data_connect_tiktok();
      }
      this.loading = false;
    },
  
    async DeleteApiauthen(item, typeName) {
      var massage_d = item.token;
      if (typeName == "token") {
        massage_d =
          "(" + this.use_language.sales_channel + "):" +
          item.channelName +
          " / " +
          "(" + this.use_language.salesperson + "):" +
          item.salemanName;
      } else if (typeName == "lineMyShop") {
        massage_d =
          "(" + this.use_language.menu_manageshop + "):" + item.shopName + " / " + "(" + this.use_language.salesperson + "):" + item.salemanName;
      }
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete_question,
        text: massage_d,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            this.loading = true;
            if (typeName == "vrich") {
              let response1 = await axios.post(
                ecomService_dotnet + "Account/DeleteApiauthen",
                {
                  Id: item.id,
                },
                { headers: this.header_token }
              );
              this.connect_vrich_data.splice(this.connect_vrich_data.indexOf(item), 1);
            } else if (typeName == "zwiz") {
              let response2 = await axios.post(
                ecomService_dotnet + "Account/DeleteApiauthen",
                {
                  Id: item.id,
                },
                { headers: this.header_token }
              );
              this.connect_zwiz_data.splice(this.connect_zwiz_data.indexOf(item), 1);
            } else if (typeName == "tiktok") {
              let response3 = await axios.get(
                ecomService_dotnet +
                  "Tiktok/delete-shop-tiktok?tiktok_shop_id=" +
                  item.tiktok_shop_id,
                { headers: this.header_token }
              );
              this.connect_tiktok_data.splice(this.connect_tiktok_data.indexOf(item), 1);
            } else if (typeName == "linenotify") {
              let response3 = await axios.post(
                ecomService_dotnet + "Line/delete-token" ,
                {
                  id: item.id,
                },
                { headers: this.header_token }
              );
              this.connect_line_data.splice(this.connect_line_data.indexOf(item), 1);
              this.LineSelectType();
            } else if (typeName == "token") {
              let response = await axios.post(
                ecomService_dotnet + "ShopCallBack/delete-shop-token",
                {
                  tokenID: item.id,
                },
                { headers: this.header_token }
              );
              this.get_data_GetPartnerConnections();
            } else if (typeName == "lineMyShop") {
              let response = await axios.get(
                ecomService_dotnet +
                  "Line/delete-shop-line?ShopLineID=" +
                  item.id.toString(),
                { headers: this.header_token }
              );
              this.get_shop_line();
            }

            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } catch (e) {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },
    async DeleteWoo(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete_question,
        text: item.baseURL,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "Woo/delete-shopwoo",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_woo_data.splice(this.connect_woo_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },
    async DeleteShopify(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete_question,
        text: item.baseURL,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "Shopify/delete-shop-shopify",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_shopify_data.splice(this.connect_shopify_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },
    async DeleteTokenLine(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete_question,
        text: item.token,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "Line/delete-token",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_line_data.splice(this.connect_line_data.indexOf(item), 1);
            this.LineSelectType();
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },
    async DeleteShopShopee(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.disconnect,
        text: this.use_language.menu_manageshop + " " + item.shopeeShopName,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "Shopee/delete-shop-shopee",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_shopee_data.splice(this.connect_shopee_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.disconnect_success,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },
    async DeleteShopLazada(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.disconnect,
        text: this.use_language.menu_manageshop + " " + item.lazadaShopName,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "Lazada/delete-shop-lazada",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_lazada_data.splice(this.connect_lazada_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.disconnect_success,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },
    async DeleteShopLazadaWarehouse(item) {
      Swal.fire({ 
        type: "question",
        title: this.use_language.confirm_want_delete,
        text: this.use_language.want_to_delete_warehouse_connection + " Lazada : " + item.lazadaWarehouseName + " " + this.use_language.with_system_warehouse + " : "+item.systemWarehouse,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true; 
          let response = await axios.post(ecomService_dotnet + "Lazada/delete-shop-lazada-warehouse?id="+ item.id,{},{ headers: this.header_token });
          if (response.status == 200  ) {

            var getlazadaResponse= await axios.post(
                                    ecomService_dotnet + "Lazada/get-shop-lazada",
                                    {
                                      shopID: localStorage.getItem("shop_id"),
                                    },
                                    { headers: this.header_token }
                                  )
            this.connect_lazada_data =getlazadaResponse.data;
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.warehouse_disconnect_success,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning", 
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },
    async DeletePlugo(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete_question,
        text: item.baseURL,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "plugo/delete-shop-plugo",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_plugo_data.splice(this.connect_plugo_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },
    async DeleteMakro(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete,
        text: item.baseURL,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.get(
            ecomService_dotnet + "Makro/delete-shop-makro?id="+ item.id,
            { headers: this.header_token }
          );
          if (response.status == 200 ) {
            this.connect_makro_data.splice(this.connect_makro_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },

    async DeleteAmaze(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete_question,
        text: item.baseURL,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "amaze/delete-shop-amaze",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_amaze_data.splice(this.connect_amaze_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },

    async DeleteNexgen(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete_question,
        text: item.baseURL,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "nexgen/delete-shop-nexgen",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_nexgen_data.splice(this.connect_nexgen_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },

    async DeleteBentoWeb(item) {
      Swal.fire({
        position: "top",
        type: "warning",
        title: this.use_language.confirm_delete_question,
        text: item.baseURL,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "BentoWeb/delete-shop-bentoweb",
            {
              id: item.id,
            },
            { headers: this.header_token }
          );
          if (response.status == 200 || response.status == 204) {
            this.connect_bentoweb_data.splice(this.connect_bentoweb_data.indexOf(item), 1);
            this.loading = false;
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: this.use_language.delete_done,
            });
          } else {
            this.loading = false;
            Swal.fire({
              type: "warning",
              position: "top",
              icon: "error",
              text: this.use_language.cannot_perform_operation,
            });
          }
        }
      });
    },


    async GetShopLazadaWarehouseForAdd(item) {

     
      this.current_lazada_sellerID =item.lazadaSellerId;
      var getlazadaWarehouseResponse= await axios.post( ecomService_dotnet + "Lazada/get-lazada-warehouse-for-add?lazadaSellerID="+item.lazadaSellerId, { }, { headers: this.header_token } )

      if(getlazadaWarehouseResponse.data.status=="success"){
        this.lazada_warehouse_dialog=true;
        this.Add_Lazada_Warehouse = getlazadaWarehouseResponse.data.lazadaWarehouseList;
        this.Add_System_Warehouse = getlazadaWarehouseResponse.data.systemWarehouseList;

        this.Add_Lazada_Warehouse.forEach(element => {
          element.fullname = element.name+" : "+element.code+" : "+element.detailAddress;
        });
        if(this.Add_Lazada_Warehouse.length>0){
          this.Add_LazadaWarehouse_Selected = this.Add_Lazada_Warehouse[0];
        }else{
          this.Add_LazadaWarehouse_Selected=null
        }

        if(this.Add_System_Warehouse.length>0){
          this.Add_SystemWarehouse_Selected = this.Add_System_Warehouse[0];
        }else{
          this.Add_SystemWarehouse_Selected=null
        }
      }else{
        Swal.fire({ 
          type: "warning",
          text:getlazadaWarehouseResponse.error_description,
        });
      }
      
    },
    async add_lazada_warehouse(){

      if(this.Add_SystemWarehouse_Selected==null || this.Add_LazadaWarehouse_Selected==null){

        this.lazada_warehouse_dialog=false;
        return;
      }
      
      var AddLazadaWarehouseResponse= await axios.post(ecomService_dotnet + "Lazada/add-shop-lazada-warehouse",{ 
        "id": 0,
        "warehouseID": this.Add_SystemWarehouse_Selected.id,
        "lazadaWarehouseCode": this.Add_LazadaWarehouse_Selected.code,
        "lazadaWarehouseName":this.Add_LazadaWarehouse_Selected.name,
        "lazadaWarehouseAddress": this.Add_LazadaWarehouse_Selected.detailAddress,
        "lazadaSellerID":this.current_lazada_sellerID
      },{ headers: this.header_token });
      if(AddLazadaWarehouseResponse.status==200){
        var getlazadaResponse= await axios.post(ecomService_dotnet + "Lazada/get-shop-lazada",{shopID: localStorage.getItem("shop_id"),},{ headers: this.header_token });
        this.connect_lazada_data =getlazadaResponse.data;
      } 
      this.lazada_warehouse_dialog=false;
    },
    // connection
    async shopee_connection() { 
      if(this.ShopeeWarehouse_Selected.id ==0){
        Swal.fire({ 
          type: "warning",
          text: this.use_language.please_select_warehouse_to_connect,
        });
        return;
      }
      if(this.jaspalShop.includes(this.ShopID)){
        if(!this.shopeeStoreCode){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Store Code",
          });
          return;
        }
        else if (this.shopeeStoreCode.length>5){
          Swal.fire({ 
            type: "warning",
            text: "Store Code " + this.use_language.max_5_characters,
        
          });
          return;
        }
        
      }

      if(this.synnexBranch.includes(this.BranchID)){
        if(!this.invoiceAccount){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Invoice Account",
          });
          return;
        }
        if (!this.inventLocation){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Invent Location",
        
          });
          return;
        }
        
      }

      this.loading = true;
      var url = document.URL;
      
      try {
        let response1 = await axios.get(ecomService_dotnet + "Shopee/get-auth?url="+url+"&warehouse_id="+this.ShopeeWarehouse_Selected.id+"&shopid="+this.ShopID+"&isInit="+ this.check_init_shopee, {
          headers: this.header_token,
        });
        var url_shopee = response1.data.url;
        this.connect_dialog = false;
        this.loading = false;
        localStorage.removeItem("check_init_shopee");
        localStorage.removeItem("storeCode");
        localStorage.removeItem("invoiceAccount");
        localStorage.removeItem("inventLocation");
        localStorage.removeItem("shopee_connect_warehouse");
        localStorage.removeItem("synnex_ischeckcost");
        localStorage.setItem("check_init_shopee", this.check_init_shopee);
        if(this.shopeeStoreCode)
          localStorage.setItem("storeCode", this.shopeeStoreCode);
        if(this.invoiceAccount)
          localStorage.setItem("invoiceAccount", this.invoiceAccount);
        if(this.inventLocation)
          localStorage.setItem("inventLocation", this.inventLocation);
        localStorage.setItem("synnex_ischeckcost", this.synnexBranch.includes(this.BranchID) ? this.synnex_ischeckcost : null);
        localStorage.setItem("shopee_connect_warehouse", this.ShopeeWarehouse_Selected.id);
        localStorage.setItem("shopee_init_timerange", JSON.stringify(this.dayListShopee) );
        
        window.location.assign(url_shopee);
      } catch (e) {
        Swal.fire({
          position: "top",
          type: "error",
          text: this.use_language.error,
        });
        this.loading = false;
      }
    },
    async lazada_connection() {
      if(this.LazadaWarehouse_Selected.id ==0){
        Swal.fire({ 
          type: "warning",
          text: this.use_language.please_select_warehouse_to_connect,
        });
        return;
      }
      if(this.jaspalShop.includes(this.ShopID)){
        if(!this.lazadaStoreCode){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Store Code",
          });
          return;
        }
        else if (this.lazadaStoreCode.length>5){
          Swal.fire({ 
            type: "warning",
            text: "Store Code " + this.use_language.max_5_characters,
        
          });
          return;
        }
       
      }
      if(this.synnexBranch.includes(this.BranchID)){
        if(!this.invoiceAccount){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Invoice Account",
          });
          return;
        }
        if (!this.inventLocation){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Invent Location",
        
          });
          return;
        }
        
      }

      this.loading = true;
      var url = document.URL;
      try {
        let response1 = await axios.get(ecomService_dotnet + "Lazada/get-auth", {
          headers: this.header_token,
        });
        var url_lazada = response1.data.url;
        localStorage.removeItem("check_init_lazada");
        localStorage.setItem("check_init_lazada", this.check_init_lazada);
        localStorage.removeItem("url");
        localStorage.setItem("url", url);
        localStorage.removeItem("storeCode");
        localStorage.removeItem("invoiceAccount");
        localStorage.removeItem("inventLocation");
        localStorage.removeItem("synnex_ischeckcost");
        if(this.lazadaStoreCode)
          localStorage.setItem("storeCode", this.lazadaStoreCode);
        if(this.invoiceAccount)
          localStorage.setItem("invoiceAccount", this.invoiceAccount);
        if(this.inventLocation)
          localStorage.setItem("inventLocation", this.inventLocation);
        localStorage.setItem("synnex_ischeckcost", this.synnexBranch.includes(this.BranchID) ? this.synnex_ischeckcost : null);

        localStorage.removeItem("lazada_connect_warehouse");
        localStorage.setItem("lazada_connect_warehouse", this.LazadaWarehouse_Selected.id);
        localStorage.setItem("lazada_init_timerange",JSON.stringify(this.dayListLazada)  );
        window.location.assign(url_lazada);
      } catch (e) {
        Swal.fire({
          position: "top",
          type: "error",
          text: this.use_language.error,
        });
        this.loading = false;
      }
    },
    async tiktok_connection() {
      if(this.TiktokWarehouse_Selected.id ==0){
        Swal.fire({ 
          type: "warning",
          text: this.use_language.please_select_warehouse_to_connect,
        });
        return;
      }
      if(this.jaspalShop.includes(this.ShopID)){
        if(!this.tiktokStoreCode){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Store Code",
          });
          return;
        }
        else if (this.tiktokStoreCode.length>5){
          Swal.fire({ 
            type: "warning",
            text: "Store Code " + this.use_language.max_5_characters,
        
          });
          return;
        }
    
      }
      if(this.synnexBranch.includes(this.BranchID)){
        if(!this.invoiceAccount){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Invoice Account",
          });
          return;
        }
        if (!this.inventLocation){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_fill + " Invent Location",
        
          });
          return;
        }
       
      }
      this.loading = true;
      var url = document.URL;
      try {
        let response1 = await axios.get(ecomService_dotnet + "Tiktok/get-auth?url="+url, {
          headers: this.header_token,
        });
        localStorage.removeItem("storeCode");
        localStorage.removeItem("invoiceAccount");
        localStorage.removeItem("inventLocation");
        localStorage.removeItem("check_init_tiktok");
        localStorage.removeItem("tiktok_connect_warehouse");
        localStorage.removeItem("synnex_ischeckcost");
        if(this.tiktokStoreCode)
          localStorage.setItem("storeCode", this.tiktokStoreCode);
        if(this.invoiceAccount)
          localStorage.setItem("invoiceAccount", this.invoiceAccount);
        if(this.inventLocation)
          localStorage.setItem("inventLocation", this.inventLocation);
        localStorage.setItem("synnex_ischeckcost", this.synnexBranch.includes(this.BranchID) ? this.synnex_ischeckcost : null);
        localStorage.setItem("check_init_tiktok", this.check_init_tiktok);
        localStorage.setItem("tiktok_connect_warehouse", this.TiktokWarehouse_Selected.id);
        localStorage.setItem("tiktok_init_timerange", JSON.stringify(this.dayListTiktok)  );
        var url_tiktok = response1.data.url;
        window.location.assign(url_tiktok);
      } catch (e) {
        Swal.fire({
          position: "top",
          type: "error",
          text: this.use_language.error,
        });
        this.loading = false;
      }
    },

    async ChannelSource_connection() {
      await this.rulesChannelSourceCheck();
      if (this.$refs.formChannelSource.validate()) {
        this.loading = true;

        var Apiauthen = {
          Id: 0,
          PartnerId: "",
          PartnerKey: "",
          ShopId: localStorage.getItem("shop_id"),
          PartnerName: "",
          Token: "",
          Role: "",
          ChannelID: "",
          SalemanID: "",
          PushURL: "",
          PushToken: "",
        };

        if (this.dialog_type == "vrich") {
          Apiauthen.SalemanID = 525;
        } else if (this.dialog_type == "zwiz") {
          Apiauthen.SalemanID = 439;
        }
        Apiauthen.ChannelID = this.channelSource.id;
        Apiauthen.Role = "partner";
        Apiauthen.PartnerName = this.dialog_type;

        try {
          let response = await axios.post(
            ecomService_dotnet + "Account/RegisterNew",
            {
              Apiauthen: Apiauthen,
            },
            { headers: this.header_token }
          );
          if (response.status == 200) {
            if (response.data == "duplicate") {
              this.loading = false;
              Swal.fire({
                position: "top",
                type: "warning",
                text: this.channelSource.channelName + " " + this.use_language.already_in_use + " !!",
              });
              return;
            }
            this.get_data_GetPartnerConnections();
            this.token = response.data;
            this.loading = false;
          }
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.error,
          });
        }
      }
    },
    async EditVrich() {
      await this.rulesEditVrichCheck();
      if (this.$refs.formChannelSource.validate()) {
        this.loading = true;
        try {
          let response = await axios.post(
            ecomService_dotnet + "Account/UpdateApiauthen",
            {
              Id: this.apiauthenId,
              PushURL: this.pushURL,
              PushToken: this.pushToken,
            },
            { headers: this.header_token }
          );
          if (response.status == 200) {
            Swal.fire({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: "top",
              type: "success",
              title: "Success",
            });
            this.get_data_GetPartnerConnections();
            this.loading = false;
            this.connect_dialog = false;
          }
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          });
        }
      }
    },
    async line_connection() {
      this.loading = true;
      try {
        let response = await axios.post(
          ecomService_dotnet + "Line/authorize",
          {
            shopId: localStorage.getItem("shop_id"),
            type: this.lineType,
            time: this.lineType == 2 ? this.hour.data + ":" + this.minute.data : null,
          },
          { headers: this.header_token }
        );
        this.connect_dialog = false;
        this.loading = false;
        window.location.assign(response.data);
      } catch (e) {
        Swal.fire({
          position: "top",
          type: "error",
          text: this.use_language.error,
        });
        this.loading = false;
      }
    },
    async woo_connection() {
      await this.rulesShopWooCheck();
      if (this.$refs.formShopWoo.validate()) {
        if(this.WooWarehouse_Selected.id ==0){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_select_warehouse_to_connect,
          });
          return;
        }
        this.shopWoo.warehouseID=this.WooWarehouse_Selected.id;
        this.loading = true;
        try {
          let response = await axios.post(
            ecomService_dotnet + "Woo/update-shopwoo",
            {
              shopWoo: this.shopWoo,
            },
            { headers: this.header_token }
          );
          this.connect_dialog = false;
          this.loading = false;
          this.connect_woo_data = [];
          this.connect_woo_data = response.data;
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: "top",
            type: "success",
            title: "Success",
          });
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          });
        }
      }
    },
    async shopify_connection() {
      
      await this.rulesShopifyCheck();
      if (this.$refs.formShopShopify.validate()) {
        if(this.ShopifyWarehouse_Selected.id ==0){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_select_warehouse_to_connect,
          });
          return;
        }
        this.shop_shopify.warehouseID=this.ShopifyWarehouse_Selected.id;
        if(this.shop_shopify.clientID==null || this.shop_shopify.clientID==""){
          return;
        }
        if(this.shop_shopify.clientSecret==null || this.shop_shopify.clientSecret==""){
          return;
        }
        if(this.shop_shopify.baseUrl==null || this.shop_shopify.baseUrl==""){
          return;
        } 
       
        if(this.jaspalShop.includes(this.ShopID)){
          if(!this.shop_shopify.storeCode){
            Swal.fire({ 
              type: "warning",
              text: this.use_language.please_fill + " Store Code",
            });
            return;
          }
          else if (this.shop_shopify.storeCode.length>5){
            Swal.fire({ 
              type: "warning",
              text: "Store Code " + this.use_language.max_5_characters,
          
            });
            return;
          }
         
        }
        
        this.loading = true;
        try {
          let response = await axios.post(
            ecomService_dotnet + "Shopify/update-shop-shopify",
            {
              "id": this.shop_shopify.id,
              "shopID": this.shop_shopify.shopID,
              "warehouseID": this.shop_shopify.warehouseID,
              "baseUrl": this.shop_shopify.baseUrl,
              "clientID":this.shop_shopify.clientID,
              "clientSecret":this.shop_shopify.clientSecret,
              "storeCode":this.shop_shopify.storeCode,
              "aP21_Integration_Type":parseInt(this.shop_shopify.aP21_Integration_Type)
            },
            { headers: this.header_token }
          );
          this.connect_dialog = false;
          this.loading = false;
          this.get_data_connect_shopify();
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: "top",
            type: "success",
            title: "Success",
          });
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          });
        }
      }
    },

    async plugo_connection() {
      await this.rulesShopPlugoCheck();
      if (this.$refs.formShopPlugo.validate()) {
        if(this.PlugoWarehouse_Selected.id ==0){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_select_warehouse_to_connect,
          });
          return;
        }
        this.shopPlugo.warehouseID=this.PlugoWarehouse_Selected.id;
        this.loading = true;
        try {
          let response = await axios.post(
            ecomService_dotnet + "Plugo/update-shop-plugo",
            {
              ID: this.shopPlugo.id,
              ShopID: this.shopPlugo.shopId,
              WarehouseID: this.shopPlugo.warehouseID,
              ShopName: this.shopPlugo.shopName,
              VendorID: this.shopPlugo.vendorID,
              ApiKey: this.shopPlugo.apiKey,
            },
            { headers: this.header_token }
          );
          this.connect_dialog = false;
          this.loading = false;
          this.connect_plugo_data = [];
          this.connect_plugo_data = response.data.data;
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: "top",
            type: "success",
            title: "Success",
          });
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          });
        }
      }
    },
    async makro_connection() {
      await this.rulesShopMakroCheck();
      if (this.$refs.formShopMakro.validate()) {
        if(this.MakroWarehouse_Selected.id ==0){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_select_warehouse_to_connect,
          });
          return;
        }
        this.shopMakro.warehouseID=this.MakroWarehouse_Selected.id;
        this.loading = true;
        try {
          let response = await axios.post(
            ecomService_dotnet + "Makro/update-shop-makro",
            {
              id: this.shopMakro.id,
              shopID: this.shopMakro.shopId,
              warehouseID: this.shopMakro.warehouseID,
              name: this.shopMakro.name,
              token: this.shopMakro.token,
              url: this.shopMakro.url,
            },
            { headers: this.header_token }
          );
          this.connect_dialog = false;
          this.loading = false;
          this.connect_makro_data = [];
          await this.get_data_connect_makro();
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: "top",
            type: "success",
            title: "Success",
          });
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          });
        }
      }
    },
    async get_data_connect_makro(){
      try {
        let response = await axios.get(
          ecomService_dotnet + "Makro/get-shop-makro?shopID=" +this.ShopID, 
          { headers: this.header_token }
        );
        this.connect_makro_data = response.data;
      } catch (e) {
        Swal.fire({
          position: "top",
          type: "error",
          text: this.use_language.cannot_load_data,
        });
      }
    },
    async amaze_connection() {
      await this.rulesShopAmazeCheck();
      if (this.$refs.formShopAmaze.validate()) {
        if(this.AmazeWarehouse_Selected.id ==0){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_select_warehouse_to_connect,
          });
          return;
        }
        this.shopAmaze.warehouseID=this.AmazeWarehouse_Selected.id;
        this.loading = true;
        try {
          let response = await axios.post(
            ecomService_dotnet + "Amaze/update-shop-amaze",
            {
              ID: this.shopAmaze.id,
              ShopID: this.shopAmaze.shopId,
              WarehouseID: this.shopAmaze.warehouseID,
              UserID: this.shopAmaze.userID,
              Password: this.shopAmaze.password,
              Amaze_StoreId: this.shopAmaze.StoreID
            },
            { headers: this.header_token }
          );

          if (!response?.data || response.data.status !== "success") {
            Swal.fire({
              type: "error",
              title: this.use_language.fail,
              text: response.data.message || this.use_language.cannot_perform_operation,
              position: "top"
            });
            return;
          }

          this.connect_dialog = false;
          this.connect_amaze_data = [];
          this.connect_amaze_data = response.data.data;
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: "top",
            type: "success",
            title: "Success",
          });
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          });
          return;
        } finally {
          this.loading = false;
        }
      }
    },
    async nexgen_connection() {
      await this.rulesShopNexgenCheck();
      if (this.$refs.formShopNexgen.validate()) {
        if(this.NexgenWarehouse_Selected.id ==0){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_select_warehouse_to_connect,
          });
          return;
        }
        this.shopNexgen.warehouseID=this.NexgenWarehouse_Selected.id;
        this.loading = true;
        try {
          let response = await axios.post(
            ecomService_dotnet + "Nexgen/update-shop-nexgen",
            {
              ID: this.shopNexgen.id,
              ShopID: this.shopNexgen.shopId,
              WarehouseID: this.shopNexgen.warehouseID,
              NexGen_ShopName: this.shopNexgen.name,
              NexGen_ShopID: this.shopNexgen.nexgenShopID,
              NexGen_TaxID: this.shopNexgen.texID,
              ApiKey: this.shopNexgen.apiKey,
              ApiSecret: this.shopNexgen.apiSecret,
              Token: this.shopNexgen.token,
            },
            { headers: this.header_token }
          );

          if (!response?.data || response.data.status !== "success") {
            Swal.fire({
              type: "error",
              title: this.use_language.fail,
              text: response.data.message || this.use_language.cannot_perform_operation,
              position: "top"
            });
            return;
          }

          this.connect_dialog = false;
          this.connect_nexgen_data = [];
          this.connect_nexgen_data = response.data.data;
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: "top",
            type: "success",
            title: "Success",
          });
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          });
          return;
        } finally {
          this.loading = false;
        }
      }
    },
    async bentoweb_connection() {
      await this.rulesShopBentoWebCheck();
      if (this.$refs.formShopBentoWeb.validate()) {
        if(this.BentoWebWarehouse_Selected.id ==0){
          Swal.fire({ 
            type: "warning",
            text: this.use_language.please_select_warehouse_to_connect,
          });
          return;
        }
        this.shopBentoWeb.warehouseID=this.BentoWebWarehouse_Selected.id;
        this.loading = true;
        try {
          let response = await axios.post(
            ecomService_dotnet + "BentoWeb/update-shop-bentoweb",
            {
              ID: this.shopBentoWeb.id,
              ShopID: this.shopBentoWeb.shopId,
              WarehouseID: this.shopBentoWeb.warehouseID,
              ShopName: this.shopBentoWeb.shopName,
              StoreId: this.shopBentoWeb.storeID,
              UserID: this.shopBentoWeb.userID,
              Password: this.shopBentoWeb.password,
              Client_ID: this.shopBentoWeb.clientID,
              Client_Secret: this.shopBentoWeb.clientSecret,
              
            },
            { headers: this.header_token }
          );

          if (!response?.data || response.data.status !== "success") {
            Swal.fire({
              type: "error",
              title: this.use_language.fail,
              text: response.data.message || this.use_language.cannot_perform_operation,
              position: "top"
            });
            return;
          }

          this.connect_dialog = false;
          this.connect_bentoweb_data = [];
          this.connect_bentoweb_data = response.data.data;
          Swal.fire({
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            position: "top",
            type: "success",
            title: "Success",
          });
        } catch (e) {
          this.loading = false;
          Swal.fire({
            position: "top",
            type: "error",
            text: this.use_language.cannot_perform_operation,
          });
          return;
        } finally {
          this.loading = false;
        }
      }
    },
    // dialog
    Edit_Vrich(item) {
      this.editVrich = true;
      this.apiauthenId = item.id;
      this.token = item.token;
      this.pushURL = item.pushURL;
      this.pushToken = item.pushToken;
      this.rulesEditVrich();
    },
    SetShopWoo(item) {
       
      this.rulesShopWoo();
    
      if (item == null) {
        this.WooWarehouse_Selected = this.Woo_Warehouse[0];
        this.shopWoo.id = 0;
        this.shopWoo.baseURL = null;
        this.shopWoo.appKey = null;
        this.shopWoo.appSecret = null;
      } else {
        this.Woo_Warehouse.forEach(element => {
          if(element.id == item.warehouseID){
            this.WooWarehouse_Selected =element;
          }
        });
        this.shopWoo.id = item.id;
        this.shopWoo.baseURL = item.baseURL;
        this.shopWoo.appKey = item.appKey;
        this.shopWoo.appSecret = item.appSecret;
      }
    },
    SetShopPlugo(item) {
       
       this.rulesShopPlugo();
     
       if (item == null) {
         this.WooWarehouse_Selected = this.Woo_Warehouse[0];
         this.shopPlugo.id = 0;
         this.shopPlugo.shopName = null;
         this.shopPlugo.vendorID = null;
         this.shopPlugo.apiKey = null;
       } else {
         this.shopPlugo.id = item.id;
         this.shopPlugo.shopName = item.shopName;
         this.shopPlugo.vendorID = item.vendorID;
         this.shopPlugo.apiKey = item.apiKey;
         this.shopPlugo.warehouseID = item.warehouseID;
         for (let index = 0; index < this.Plugo_Warehouse.length; index++) {
           
          if(this.Plugo_Warehouse[index].id ==  item.warehouseID){
            this.PlugoWarehouse_Selected=this.Plugo_Warehouse[index]
          }
         }
       }
     },
    SetShopAmaze(item) {
       
       this.rulesShopAmaze();
     
       if (item == null) {
         this.AmazeWarehouse_Selected = this.Amaze_Warehouse[0];
         this.shopAmaze.id = 0;
         this.shopAmaze.userID = null;
         this.shopAmaze.password = null;
         this.shopAmaze.amazeStoreID = null;
       } else {
         this.shopAmaze.id = item.id;
         this.shopAmaze.userID = item.userID;
         this.shopAmaze.password = item.password;
         this.shopAmaze.warehouseID = item.warehouseID;
         this.shopAmaze.amazeStoreID = item.amazeStoreID
         for (let index = 0; index < this.Amaze_Warehouse.length; index++) {
           
          if(this.Amaze_Warehouse[index].id ==  item.warehouseID){
            this.AmazeWarehouse_Selected=this.Amaze_Warehouse[index]
          }
         }
       }
     },
     SetShopMakro(item) {
       
       this.rulesShopMakro();
     
       if (item == null) {
         this.MakroWarehouse_Selected = this.Makro_Warehouse[0];
         this.shopMakro.id = 0;
         this.shopMakro.name = null;
         this.shopMakro.token = null;
        this.shopMakro.url = "https://maknet-prod.mirakl.net";
       } else {
         this.shopMakro.id = item.id;
         this.shopMakro.name = item.name;
         this.shopMakro.token = item.token;
         this.shopMakro.url = item.url;
         this.shopMakro.warehouseID = item.warehouseID;
         for (let index = 0; index < this.Makro_Warehouse.length; index++) {
           
          if(this.Makro_Warehouse[index].id ==  item.warehouseID){
            this.MakroWarehouse_Selected=this.Makro_Warehouse[index]
          }
         }
       }
     },
     SetShopNexgen(item) {
      this.rulesShopNexgen();
    
      if (item == null) {
        this.NexgenWarehouse_Selected = this.Nexgen_Warehouse[0];
        this.shopNexgen.id = 0;
        this.shopNexgen.name = null;
        this.shopNexgen.nexgenShopID = null;
        this.shopNexgen.taxID = null; // อิงตาม v-model="shopNexgen.taxID"
        this.shopNexgen.apiKey = null;
        this.shopNexgen.apiSecret = null;
        this.shopNexgen.token = null;
      } else {
        this.shopNexgen.id = item.id;
        this.shopNexgen.name = item.nexGenShopName;
        this.shopNexgen.nexgenShopID = item.nexGenShopID;
        this.shopNexgen.taxID = item.nexGenTexID;
        this.shopNexgen.apiKey = item.apiKey;
        this.shopNexgen.apiSecret = item.apiSecret;
        this.shopNexgen.token = item.token; // ดึงจาก access_token
        this.shopNexgen.warehouseID = item.warehouseID;
        for (let index = 0; index < this.Nexgen_Warehouse.length; index++) {
          if(this.Nexgen_Warehouse[index].id == item.warehouseID) {
            this.NexgenWarehouse_Selected = this.Nexgen_Warehouse[index];
          }
        }
      }
    },
    SetShopBentoWeb(item) {
      this.rulesShopBentoWeb();
    
      if (item == null) {
        this.NexgenWarehouse_Selected = this.Nexgen_Warehouse[0];
        this.shopNexgen.id = 0;
        this.shopNexgen.shopName = null;
        this.shopNexgen.userID = null;
        this.shopNexgen.password = null;
        this.shopNexgen.storeID = null;
        this.shopNexgen.clientID = null;
        this.shopNexgen.clientSecret = null;
        this.shopNexgen.token = null;
      } else {
        this.shopNexgen.id = item.id;
        this.shopNexgen.shopName = item.shopName;
        this.shopNexgen.userID = item.userID;
        this.shopNexgen.password = item.password;
        this.shopNexgen.storeID = item.storeID;
        this.shopNexgen.clientID = item.clientID;
        this.shopNexgen.clientID = item.clientID;
        this.shopNexgen.token = item.token;
        this.shopNexgen.warehouseID = item.warehouseID;
        for (let index = 0; index < this.Nexgen_Warehouse.length; index++) {
          if(this.Nexgen_Warehouse[index].id == item.warehouseID) {
            this.NexgenWarehouse_Selected = this.Nexgen_Warehouse[index];
          }
        }
      }
    },
     
     
    SetShopShopify(item) {
       
        this.rulesShopify();
     
       if (item == null) {
         this.WooWarehouse_Selected = this.Woo_Warehouse[0];
         this.shop_shopify.id = 0;
         this.shop_shopify.baseUrl = null;
         this.shop_shopify.clientID = null;
         this.shop_shopify.clientSecret = null; 
         this.shop_shopify.aP21_Integration_Type ='1';
       } else {
          
         this.shop_shopify.id = item.id;
         this.shop_shopify.baseUrl = item.baseUrl;
         this.shop_shopify.clientID = item.clientID;
         this.shop_shopify.clientSecret = item.clientSecret;
         this.shop_shopify.warehouseID = item.warehouseID;
         this.shop_shopify.aP21_Integration_Type = item.aP21_Integration_Type;
         for (let index = 0; index < this.Shopify_Warehouse.length; index++) {
           
          if(this.Shopify_Warehouse[index].id ==  item.warehouseID){
            this.ShopifyWarehouse_Selected=this.Shopify_Warehouse[index]
          }
         }
        
       }
     },
    async open_dialog_topup(type) {
      this.createDayList();
      this.dialog_type = type;
      this.token = this.editVrich ? this.token : null;
      this.inventLocation=null;
      this.invoiceAccount=null;
      if (type == "shopee") {
        this.dialog_title = this.use_language.connect + " shopee";
        this.check_init_shopee = false;
        this.connect_dialog = true;
      } else if (type == "lazada") {
        this.dialog_title = this.use_language.connect + " lazada";
        this.check_init_lazada = false;
        this.connect_dialog = true;
      } else if (type == "vrich" || type == "zwiz") {
        this.dialog_title = this.use_language.connect + " " + type;
        this.rulesChannelSource();
        this.channelSource = this.channelSourceList[0];
        this.connect_dialog = true;
      } else if (type == "telegram bot") {
        this.$nextTick(() => {
          this.createBtnTelegram()
        })
        this.dialog_title = this.use_language.connect + " telegram";
        this.hour = { data: "00" };
        this.minute = { data: "00" };
        this.connect_dialog = true;
      } else if (type == "line notify") {
        this.dialog_title = this.use_language.connect + " line notify";
        this.hour = { data: "00" };
        this.minute = { data: "00" };
        this.connect_dialog = true;
      } else if (type == "woo") {
        this.dialog_title = this.use_language.connect + " woo commerce";
        this.connect_dialog = true;
      } else if (type == "tiktok") {
        this.dialog_title = this.use_language.connect + " tiktok";
        this.connect_dialog = true;
        this.check_init_tiktok=false;
      } else if (type == "fackbook") {
        this.dialog_title = this.use_language.connect + " fackbook";
        this.connect_dialog = true;
      }
      else if (type == "shopify") {
        this.dialog_title = this.use_language.connect + " Shopify";
        this.connect_dialog = true;
      } else if (type == "lineOa") {
        this.dialog_title = this.use_language.connect + " line oa";
        let response = await axios.get(expressService_dotnet + "CoreMessage/pre-create-line-oa?ShopID="+this.ShopID,{ headers: this.header_token });
        this.LineMessageConnection = response.data
        this.connect_dialog = true;
      } else if (type == "plugo"){
        this.dialog_title = this.use_language.connect + " Plugo";
        this.connect_dialog = true;
      } else if (type == "amaze"){
        this.dialog_title = this.use_language.connect + " Amaze";
        this.connect_dialog = true;
      }
      else if (type == "makro"){
        this.dialog_title = this.use_language.connect + " Makro";
        this.connect_dialog = true;
      }
      else if (type == "nexgen"){
        this.dialog_title = this.use_language.connect + " Nexgen";
        this.connect_dialog = true;
      }
      else if (type == "bentoweb"){
        this.dialog_title = this.use_language.connect + " BentoWeb";
        this.connect_dialog = true;
      }
    },
    async DeleteLineOA(item){
      Swal.fire({ 
        type: "question", 
        text: this.use_language.confirm_want_delete,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.get(expressService_dotnet + "CoreMessage/delete-line-oa?id="+item.id,{ headers: this.header_token });
          await this.get_line_oa();

        }});
    },
    async closedialog(dialog_type){
      if (dialog_type == "lineOa") {
        let response = await axios.get(expressService_dotnet + "CoreMessage/delete-line-oa?id="+this.LineMessageConnection.id,{ headers: this.header_token });
      } else if (dialog_type == "telegram bot") {
        this.telegramTypeList = [
          { id: 1, active: true, disabled: false, name: this.use_language.notify_low_stock },
          { id: 3, active: true, disabled: false, name: this.use_language.notify_new_order },
          { id: 2, active: true, disabled: false, name: this.use_language.notify_end_of_day_sales },
          { id: 4, active: true, disabled: false, name: this.use_language.notify_other },
        ]
        this.hour = { data: "00" }
        this.minute = { data: "00" }
      }
    },
    // marketplace
    StockMarketplaceActive(isUpdateStockMarketplace) {
      var label = this.use_language.deactivate;
      if (isUpdateStockMarketplace) {
        label = this.use_language.enable_usage;
      }
      return label;
    },
    async UpdateMarketplace() {
      this.shop.percentUpdateStockShopee = ((this.shop.marketplaceList[0].percent == "") ? null : this.shop.marketplaceList[0].percent);
      this.shop.percentUpdateStockLazada = ((this.shop.marketplaceList[1].percent == "") ? null : this.shop.marketplaceList[1].percent);
      // this.shop.percentUpdateStockJDCentral = ((this.shop.marketplaceList[2].percent == "") ? null : this.shop.marketplaceList[2].percent);
      this.shop.percentUpdateStockWooCommerce = ((this.shop.marketplaceList[3].percent == "") ? null : this.shop.marketplaceList[3].percent);
      this.shop.percentUpdateStockTiktok = ((this.shop.marketplaceList[4].percent == "")  ? null : this.shop.marketplaceList[4].percent);
      this.shop.percentUpdateStockLine =  ((this.shop.marketplaceList[5].percent == "" )? null  : this.shop.marketplaceList[5].percent);
      this.shop.percentUpdateStockShopify =  ((this.shop.marketplaceList[6].percent == "" )? null  : this.shop.marketplaceList[6].percent);

      this.shop.minimumStock = ((this.shop.minimumStock == "") ? null : this.shop.minimumStock);

      this.loading = true;
      let response = await axios.post(
        stockService_dotnet + "Stock/update-marketplace",
        {
          marketplace: this.shop,
        },
        { headers: this.header_token }
      );
      this.loading = false;
      if (response.status == 200) {
        Swal.fire({
          toast: true,
          timer: 1500,
          showConfirmButton: false,
          position: "top",
          type: "success",
          title: "Success",
        });
      } else {
        Swal.fire({
          position: "top",
          type: "error",
          text: this.use_language.cannot_perform_operation,
        });
      }
    },

    //peak
     async getUpdateShopPeak(){
      this.loading = true;
      let response = await axios.post(
        shopService_dotnet + "ShopAccPeak/update-shop-account",
        {
          id:this.peak.id,
          shopID:localStorage.getItem("shop_id"),
          clientToken:this.peak.Token,
          paymentMethodCode:this.peak.PaymentMethod,
          isCreateReceiptSummaryDaily:this.peak.sendOrder,
          isDelete: !this.peak.IsDelete,
        },
        { headers: this.header_token }
      );
      if(response.data.status === 'success')
      {
        this.loading = false;
        return response.data
      }
    },
    async getPeakChannel(){
      let response = await axios.post(
        shopService_dotnet + "ShopAccPeak/get-shop-account-setting?shopId="+localStorage.getItem("shop_id"),
        {
        },
        { headers: this.header_token }
      );
      if(response.data.status === 'success')
      {
        if(response.data.shopPeakSettings.length >0)
        {
          for(var item of response.data.shopPeakSettings)
          {
            if(item.channelSourceId === 0)
            {
              this.peak.contact = item.contactCode
              this.peak.MethodCode = item.paymentMethodCode
              this.peak.uniqueID = item.id
            }
              let index = this.peak.marketplaceList.findIndex(marketplace => marketplace.id === item.channelSourceId);
              if(index !== -1) {
                this.peak.marketplaceList[index].contac = item.contactCode;
                this.peak.marketplaceList[index].productID = item.productCode;
                this.peak.marketplaceList[index].MethodCode = item.paymentMethodCode;
                this.peak.marketplaceList[index].select = true;
                this.peak.marketplaceList[index].uniqueID = item.id
                this.handleSelectCheckboxMarketplace(this.peak.marketplaceList[index])
              }
          }
        }
      }
    },
    async handleCheckTokenAuthenClick(){
      this.loading = true;
      let response = await axios.post(
        shopService_dotnet + "ShopAccPeak/update-shop-account",
        {
          shopID:localStorage.getItem("shop_id"),
          clientToken:this.peak.Token,
          isDelete: !this.peak.IsDelete,
        },
        { headers: this.header_token }
      );
      if(response.data.status === 'success')
      {
        this.nextStepAuthen = true
        this.loading = false;
        
      }
    },
    
    async handleUpdatePeakClick()
    {
      var shopPeak 
        shopPeak =  await this.getUpdateShopPeak()
        await this.getUpdateShopAccountPeak(shopPeak.id)
    },
    

    async getUpdateShopAccountPeak(peakID){
      let response 
      if(!this.peak.sendOrder)
      {
        for(var item of this.peak.selectChannelData)
          {
            await axios.post(
            shopService_dotnet + "ShopAccPeak/update-shop-account-setting?shopId="+parseInt(localStorage.getItem("shop_id")),
            {
              id:item.uniqueID,
              shopPeakId: peakID,
              channelSourceId:item.id,
              contactCode:item.contac,
              contactName:item.name,
              productCode: item.productID,
              productName:item.name ,
              paymentMethodCode:item.MethodCode
            },
            { headers: this.header_token }
          );
        }
          Swal.fire({
             toast: true,
             timer: 1500,
             showConfirmButton: false,
             position: 'top',
             type: 'success',
             title: this.use_language.save_complete
           })
        
      }
      else{
        this.loading = true;
         response = await axios.post(
            shopService_dotnet + "ShopAccPeak/update-shop-account-setting?shopId="+parseInt(localStorage.getItem("shop_id")),
            {
              id:this.peak.uniqueID,
              shopPeakId: peakID,
              channelSourceId:0,
              contactCode:this.peak.contact,
              contactName:"AllOrder",
              paymentMethodCode:this.peak.MethodCode
            },
            { headers: this.header_token }
          );
        if(response.data.status === 'success') {
          Swal.fire({
             toast: true,
             timer: 1500,
             showConfirmButton: false,
             position: 'top',
             type: 'success',
             title: this.use_language.save_complete
           })
           this.loading = false
        }
      }


    },

    async onChangeCheckPaymentMethod(){
      if(!this.peak.FirstTimeCheck){
      if(this.peak.PaymentMethod !== null || this.peak.PaymentMethod !== '')
      {
      
      let response = await axios.post(
        shopService_dotnet + "ShopAccPeak/get-payment-method?shopId="+parseInt(localStorage.getItem("shop_id"))+"&paymentMethodCode="+this.peak.PaymentMethod,
        {
        },
        { headers: this.header_token }
      );
        if(response.data.status === 'success')
        {
          if(response.data.paymentMethods.length > 0 )
          {
            this.peak.PaymentMethodCheck = 1;
          }else{
            this.peak.PaymentMethodCheck = 2;
          }

        }
        else{
          this.peak.PaymentMethodCheck = 2;
        }
      }
    }
    },
    async onChangeCheckContact(item,index){
      if(!this.peak.FirstTimeCheck){
      let response = await axios.post(
        shopService_dotnet + "ShopAccPeak/get-contact?shopId="+parseInt(localStorage.getItem("shop_id"))+"&contactId="+item.contac,
        {
        },
        { headers: this.header_token }
      );
        if(response.data.status === 'success')
        {
          this.peak.marketplaceList[index].contacValidate = 1
        }
        else{
          this.peak.marketplaceList[index].contacValidate = 2
        }
      }
    },
    async onChangeCheckProduct(item,index){
      if(!this.peak.FirstTimeCheck)
      {
      let response = await axios.post(
        shopService_dotnet + "ShopAccPeak/get-product?shopId="+parseInt(localStorage.getItem("shop_id"))+"&productId="+item.productID,
        {
        },
        { headers: this.header_token }
      );
        if(response.data.status === 'success')
        {
          this.peak.marketplaceList[index].productIDValidate = 1
        }
        else{
          this.peak.marketplaceList[index].productIDValidate = 2
        }
      }
    },
    handleSelectCheckboxMarketplace(item){
                if (item.select){ 
                  this.peak.selectChannelData.splice(0, 0, item)
                }
                else{
                  const removeitem = this.peak.selectChannelData.findIndex(
                    (selectedItem) => selectedItem === item
                  )
                  if (removeitem !== -1) {
                    this.peak.selectChannelData.splice(removeitem, 1)
                  }
                }
          },

    // อื่นๆ
    rulesChannelSourceCheck() {
      this.ruleschannelSource = [(v) => v.id != 0 || this.use_language.please_fill];
    },
    rulesChannelSource() {
      this.ruleschannelSource = [];
    },
    rulesEditVrichCheck() {
      this.rulespushURL = [(v) => !!v || this.use_language.please_fill];
      this.rulespushTokent = [(v) => !!v || this.use_language.please_fill];
    },
    rulesEditVrich() {
      this.rulespushURL = [];
      this.rulespushTokent = [];
    },
    rulesShopWooCheck() {
      this.shopWoo.rulesBaseURL = [(v) => !!v || this.use_language.please_fill];
      this.shopWoo.rulesAppKey = [(v) => !!v || this.use_language.please_fill];
      this.shopWoo.rulesAppSecret = [(v) => !!v || this.use_language.please_fill];
    },
    rulesShopifyCheck() {
      this.shop_shopify.rulesBaseURL = [(v) => !!v  || this.use_language.please_fill];
      this.shop_shopify.rulesAdminAPI= [(v) => !!v  || this.use_language.please_fill];
      this.shop_shopify.rulesStorefrontAPI = [(v) => !!v  || this.use_language.please_fill];
    },
    rulesShopPlugoCheck() {
      this.shopPlugo.rulesShopName = [(v) => !!v || this.use_language.please_fill];
      this.shopPlugo.rulesVendorID = [(v) => !!v || this.use_language.please_fill];
      this.shopPlugo.rulesApiKey = [(v) => !!v || this.use_language.please_fill];
    },
    rulesShopAmazeCheck() {
      this.shopAmaze.rulesUserID = [(v) => !!v || this.use_language.please_fill];
      this.shopAmaze.rulesPassword = [(v) => !!v || this.use_language.please_fill];
      this.shopAmaze.rulesStoreID = [(v) => !!v || this.use_language.please_fill];
    },
     rulesShopMakroCheck() {
      this.shopMakro.rulesName = [(v) => !!v || this.use_language.please_fill];
      this.shopMakro.rulesToken = [(v) => !!v || this.use_language.please_fill];
      this.shopMakro.rulesURL = [(v) => !!v || this.use_language.please_fill];
    },
     rulesShopNexgenCheck() {
      this.shopNexgen.rulesName = [(v) => !!v || this.use_language.please_fill];
      this.shopNexgen.rulesNexgenShopID = [(v) => !!v || this.use_language.please_fill];
      this.shopNexgen.rulesTexID = [(v) => !!v || this.use_language.please_fill];
      this.shopNexgen.rulesApiKey = [(v) => !!v || this.use_language.please_fill];
      this.shopNexgen.rulesApiSecret = [(v) => !!v || this.use_language.please_fill];
      this.shopNexgen.rulesToken = [(v) => !!v || this.use_language.please_fill];
    },
    rulesShopBentoWebCheck() {
      this.shopBentoWeb.rulesShopName = [(v) => !!v || this.use_language.please_fill];
      this.shopBentoWeb.rulesUserID = [(v) => !!v || this.use_language.please_fill];
      this.shopBentoWeb.rulesPassword = [(v) => !!v || this.use_language.please_fill];
      this.shopBentoWeb.rulesStoreID = [(v) => !!v || this.use_language.please_fill];
      this.shopBentoWeb.rulesClientID = [(v) => !!v || this.use_language.please_fill];
      this.shopBentoWeb.rulesClientSecret = [(v) => !!v || this.use_language.please_fill];
    },
    rulesShopWoo() {
      this.shopWoo.rulesBaseURL = [];
      this.shopWoo.rulesAppKey = [];
      this.shopWoo.rulesAppSecret = [];
    },
    rulesShopPlugo() {
      this.shopPlugo.rulesShopName = [];
      this.shopPlugo.rulesVendorID = [];
      this.shopPlugo.rulesApiKey = [];
    },
    rulesShopAmaze() {
      this.shopAmaze.rulesUserID = [];
      this.shopAmaze.rulesPassword = [];
      this.shopAmaze.rulesStroeID = [];
    },
    rulesShopMakro() {
      this.shopMakro.rulesName = [];
      this.shopMakro.rulesToken = [];
      this.shopMakro.rulesURL = [];
    },
    rulesShopNexgen() {
      this.shopNexgen.rulesName = [];
      this.shopNexgen.rulesNexgenShopID = [];
      this.shopNexgen.rulesTexID = [];
      this.shopNexgen.rulesApiKey = [];
      this.shopNexgen.rulesApiSecret = [];
      this.shopNexgen.rulesToken = [];
    },
    rulesShopBentoWeb() {
      this.shopBentoWeb.rulesShopName = [];
      this.shopBentoWeb.rulesUserID = [];
      this.shopBentoWeb.rulesPassword = [];
      this.shopBentoWeb.rulesStoreID = [];
      this.shopBentoWeb.rulesClientID = [];
      this.shopBentoWeb.rulesClientSecret = [];
    },
    rulesShopify() {
      this.shop_shopify.rulesBaseURL = [];
      this.shop_shopify.rulesAdminAPI = [];
      this.shop_shopify.rulesStorefrontAPI= [];
    },
    LineSelectType() {
      for (var j in this.lineTypeList) {
        var lineList = this.connect_line_data.filter(
          (x) => x.type == this.lineTypeList[j].id
        );
        if (lineList.length > 0) {
          this.lineTypeList[j].disabled = true;
        } else {
          this.lineTypeList[j].disabled = false;
        }
      }
      this.lineType = 0;
      for (var i of this.lineTypeList) {
        if (!i.disabled) {
          this.lineType = i.id;
          break;
        }
      }
      if (this.connect_line_data.length == 0) {
        this.lineType = 1;
      }
    },
    copyToken() {
      let CopyTokenCode = document.querySelector("#token-code");
      CopyTokenCode.setAttribute("type", "text");
      CopyTokenCode.select();
      document.execCommand("copy");
      CopyTokenCode.setAttribute("type", "hidden");
      this.$swal({
        toast: true,
        timer: 1500,
        showConfirmButton: false,
        position: "top",
        type: "success",
        title: this.use_language.copy_success,
      });
    },
    copyTokenVrich(token) {
      this.token = token;
      setTimeout(() => {
        let CopyTokenVrich = document.querySelector("#token-vrich");
        CopyTokenVrich.setAttribute("type", "text");
        CopyTokenVrich.select();
        document.execCommand("copy");
        CopyTokenVrich.setAttribute("type", "hidden");
        this.$swal({
          toast: true,
          timer: 1500,
          showConfirmButton: false,
          position: "top",
          type: "success",
          title: this.use_language.copy_success,
        });
        // window.getSelection().removeAllRanges()
      }, 100);
    },
    copyTokenLineOA(token) {
      
     this.token_line_oa=token;
      setTimeout(() => {
        let CopyTokenVrich = document.querySelector("#token-line-oa");
        CopyTokenVrich.setAttribute("type", "text");
        CopyTokenVrich.select();
        document.execCommand("copy");
        CopyTokenVrich.setAttribute("type", "hidden");
        this.$swal({
          toast: true,
          timer: 1500,
          showConfirmButton: false,
          position: "top",
          type: "success",
          title: this.use_language.copy_success,
        });
        // window.getSelection().removeAllRanges()
      }, 100);
    },

    copyTokenLineMyshop(token) {
      this.token_line = token;
      setTimeout(() => {
        let CopyTokenVrich = document.querySelector("#token-line-my-shop");
        CopyTokenVrich.setAttribute("type", "text");
        CopyTokenVrich.select();
        document.execCommand("copy");
        CopyTokenVrich.setAttribute("type", "hidden");
        this.$swal({
          toast: true,
          timer: 1500,
          showConfirmButton: false,
          position: "top",
          type: "success",
          title: this.use_language.copy_success,
        });
        // window.getSelection().removeAllRanges()
      }, 100);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 600) {
        this.size = "xs";
      } else if (this.window.width >= 600 && this.window.width < 960) {
        this.size = "sm";
      } else if (this.window.width >= 960 && this.window.width < 1264) {
        this.size = "md";
      } else if (this.window.width >= 1264 && this.window.width < 1904) {
        this.size = "lg";
      } else if (this.window.width >= 1904) {
        this.size = "xl";
      }
    },

    async get_shop_call_back_url() {
      try {
        this.loading = true;
        let response = await axios.post(
          ecomService_dotnet + "ShopCallBack/get-shop-callback-url",
          {
            shopID: localStorage.getItem("shop_id"),
          },
          { headers: this.header_token }
        );

        if (response.data != null && response.data != "") {
          this.data_callback = response.data;
        }
        this.loading = false;
      } catch (e) {
        await this.$swal({
          position: "top",
          type: "info",
          title: "get-shop-callback-url " + this.use_language.error + " !!",
          text: e.message,
        });
      }
    },

    async add_update_shop_call_back_url() {
      try {
        this.loading = true;
        if (this.data_callback.id == 0) {
          this.data_callback.branchID = localStorage.getItem("branch_id");
          this.data_callback.shopID = localStorage.getItem("shop_id");
        }

        if (
          this.data_callback.urlCallback == null ||
          this.data_callback.urlCallback == ""
        ) {
          this.$refs.refUrlCallback.focus();
          this.loading = false;
          return;
        }

        let response = await axios.post(
          ecomService_dotnet + "ShopCallBack/update-shop-callback-url",
          {
            id: this.data_callback.id,
            branchID: this.data_callback.branchID,
            shopID: this.data_callback.shopID,
            urlCallback: this.data_callback.urlCallback,
            statusWaitPack: this.data_callback.statusWaitPack,
            statusPacked: this.data_callback.statusPacked,
            statusReady: this.data_callback.statusReady,
            statusSent: this.data_callback.statusSent,
            statusCancel: this.data_callback.statusCancel,
            isDelete: this.data_callback.isDelete,
            isActive: this.data_callback.isActive,
          },
          { headers: this.header_token }
        );

        this.get_shop_call_back_url();
        this.loading = false;
      } catch (e) {
        await this.$swal({
          position: "top",
          type: "info",
          title: "get-shop-callback-url " + this.use_language.error + " !!",
          text: e.message,
        });
      }
    },

    async delete_shop_call_back_url() {
      if (this.data_callback.id != 0) {
        this.data_callback.isDelete = true;
        await this.add_update_shop_call_back_url();

        this.data_callback = {
          id: 0,
          branchID: null,
          shopID: null,
          urlCallback: null,
          statusWaitPack: false,
          statusPacked: false,
          statusReady: false,
          statusSent: false,
          statusCancel: false,
          isDelete: false,
          isActive: false,
        };
      }
    },
    async handleEditSyncStockDialog(item){
      this.currentsyncStockInfo = item;
      this.sync_stock_dialog = true;
      this.sync_stock_updateall=false;
      if(this.currentsyncStockInfo.isUpdateStock){
        this.sync_stock_radio="1";
      }else{
        this.sync_stock_radio="0";
      }
      
      this.sync_stock_percent=this.currentsyncStockInfo.updateStockPercent;
      this.sync_stock_minimum=this.currentsyncStockInfo.quantityLowStock;
      this.sync_stock_static_quantity=this.currentsyncStockInfo.staticQuantityWhenLowStock;
    },
    async CheckSyncStatus(){
      var isStop=false;
      this.IsShowSyncSuccess=false;
      this.IsShowPercentSyncProgress=false;
      let getSyncStockResponse= await this.get_resync_stock_percent();
 
      if(getSyncStockResponse.data.total==0)
      {
        this.IsShowCancelSyncButton=false;
      }
      else
      { 
        this.ResyncButtonPressed=true;
        this.IsShowCancelSyncButton=true;
        this.IsShowPercentSyncProgress=true;

        this.PercentUpdateStock=getSyncStockResponse.data.percent;
        this.CurrentUpdateStock=getSyncStockResponse.data.current;
        this.TotalUpdateStock=getSyncStockResponse.data.total;

        while(!isStop){
          getSyncStockResponse= await this.get_resync_stock_percent();
          if(getSyncStockResponse.data.total==0){
            isStop=true;
            this.IsShowSyncSuccess=true;
            this.IsShowPercentSyncProgress=false;
            this.IsShowCancelSyncButton = false;
          }else{
            this.IsShowPercentSyncProgress=true;
            this.IsShowCancelSyncButton = true;
          }
          this.PercentUpdateStock=getSyncStockResponse.data.percent;
          this.CurrentUpdateStock=getSyncStockResponse.data.current;
          this.TotalUpdateStock=getSyncStockResponse.data.total;
          setTimeout({}, 1000);
        }
      }
    },
    async ReSyncStock(){
      Swal.fire({
        type: "question",
        title: this.use_language.resync_all_stock,
        text: this.use_language.confirm_transaction_2,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if(result.value){
          this.loading=true;
          
          try {
            let response = await axios.post(
              ecomService_dotnet + "Stock/update-to-marketplace-with-shopid?ShopID="+this.ShopID,
              {},
              { headers: this.header_token }
            );
            this.loading=false;
            if(response.data.status=="error"){
              
              Swal.fire({ 
                type: "error",
                text: response.data.error_description,
              });
            }else{
              
              Swal.fire({ 
                position:"top",
                type: "success",
                toast:true,
                timer:1500,
                text:this.use_language.system_resyncing_stock,
              });

              this.IsShowPercentSyncProgress=true;
              this.PercentUpdateStock=0;
              this.CurrentUpdateStock=0;
              this.TotalUpdateStock=0;
              this.IsShowSyncSuccess=false;
              this.IsShowCancelSyncButton=true;

              this.ResyncButtonPressed=true;
              setTimeout(() => {
                this.CheckSyncStatus() 
              }, 5000);
             
              
              
            }
          } catch (error) {
            this.loading=false;
            Swal.fire({ 
              type: "error",
              text: this.use_language.please_try_transaction_again,
            });
          }
           
        }
      });
   
    },
    async save_edit_sync_stock(){
      var jsonRequest = {
        "id": this.currentsyncStockInfo.id,
        "platformID": this.currentsyncStockInfo.platformID,
        "shopID": this.currentsyncStockInfo.shopID,
        "isUpdateStock": (this.sync_stock_radio=="1"? true:false),
        "platformShopID": this.currentsyncStockInfo.platformShopID,
        "updateStockPercent": this.sync_stock_percent==''?null:parseFloat(this.sync_stock_percent),
        "quantityLowStock": this.sync_stock_minimum==''?null:parseInt(this.sync_stock_minimum),
        "staticQuantityWhenLowStock": this.sync_stock_static_quantity==''? null:parseInt(this.sync_stock_static_quantity),
        "isUpdateProductItem": this.sync_stock_updateall
      }

      if(jsonRequest.isUpdateStock && jsonRequest.updateStockPercent==null){
        Swal.fire({ 
          type: "error",
          text: this.use_language.please_specify_percent + " sync stock!",
        });
        return;
      }
      this.loading=true;
      try {
        let response = await axios.post(
          ecomService_dotnet + "Shop/update-marketplace-allocation",
          jsonRequest,
          { headers: this.header_token }
        );
        if(response.data.status=="error"){
          this.loading=false;
          Swal.fire({ 
            type: "error",
            text: response.data.error_description,
          });
        }else{
          await this.get_shop_stock_allocation();
        }
      } catch (error) {
        this.loading=false;
        Swal.fire({ 
          type: "error",
          text: this.use_language.please_try_transaction_again,
        });
      }
      this.loading=false;
      this.sync_stock_dialog = false;
    },
    async get_staff_shop_list() {
      let response = await axios.post(
        shopService_dotnet + "StaffShop/get-staff-shop-list",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );
      this.staff_list = response.data;

      var data_tmp = { id: null, name: " -- " + this.use_language.choose + " -- " };
      this.staff_list.unshift(data_tmp);
    },

    async get_chanal_shop_list() {
      let response = await axios.post(
        shopService_dotnet + "Shop/get-shop-channel",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );

      this.chanal_list = response.data;
      var data_tmp = { id: null, channelName: " -- " + this.use_language.choose + " -- " };
      this.chanal_list.unshift(data_tmp);
    },

    async get_warehouse_shop_list() {
      let response = await axios.post(
        shopService_dotnet + "Shop/get-warehouse-list",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );

      this.warehouse_list = response.data;
      var data_tmp = { id: null, name: " -- " + this.use_language.choose + " -- " };
      this.warehouse_list.unshift(data_tmp);
    },

    async open_dialog_token() {
      await this.get_staff_shop_list();
      await this.get_chanal_shop_list();
      await this.get_warehouse_shop_list();

      this.connect_dialog = true;
      this.dialog_title = this.use_language.create + " Token";
      this.dialog_type = "token";
    },

    async open_dialog_update_webhook(item) {
      this.isWebhookTested=null;
      this.connect_dialog = true;
      this.webhookUrl=null;
      this.webhookBearer=null;
      this.apiauthenid=null;

      this.webhookUrl=item.webhookUrl;
      this.webhookBearer=item.webhookBearer;
      this.apiauthenid=item.id;

      this.dialog_title = this.use_language.edit + " Webhook";
      this.dialog_type = "updatewebhook";
    },

     
    async test_webhook(){
      var message="";
       this.isWebhookTested=null;
       try {
        var headerAPI = {}

        // if(this.webhookBearer==null)
        // {
        //   headerAPI={'Content-Type': 'application/json'}
        // }
        // else
        // {
        //   headerAPI={'Content-Type': 'application/json','Authorization': 'Bearer '+this.webhookBearer}
        // }
        let response = await axios.post(this.webhookUrl,
          { test:"Testing webhook"},
          { 
            headers: headerAPI  
          }
        );
       
        if(response.status ==200){
           this.isWebhookTested=true;
        } 
        else
        {
          this.isWebhookTested=false;
        }
      } catch (error) {
        this.isWebhookTested=false;
      }
      
    },

    async save_webhook() {
      var message = "";
     
      if( this.webhookUrl!=null && this.webhookUrl!=""  ){    
        try {
          let response = await axios.post(
            ecomService_dotnet + "Account/UpdateWebhook",
            {
                "id": this.apiauthenid,
                "webhookUrl": this.webhookUrl,
                "webhookBearer":this.webhookBearer
            },
            { headers: this.header_token }
          );

          if(response.status ==200){
            if(response.data.status=="success"){
              Swal.fire({
                position:"top",
                type: "success", 
                toast:true,
                timer:1500,
                text: this.use_language.save_complete,
              });
              this.connect_dialog = false;
              this.get_data_GetPartnerConnections();
            }else{
              message=response.data.error_description;
            }
          } 
          else
          {
            message=this.use_language.cannot_perform_operation;
          }
        } catch (error) {
          message=this.use_language.cannot_perform_operation;
        }
      }else{
         Swal.fire({ 
          type: "warning",
          text: this.use_language.please_fill + " URL",
        }); 
      }
      if(message!=""){
        Swal.fire({ 
          type: "error",
          text: message,
        });
      }
    },
    async connect_token() {
      if (this.dialog_token_chanal == null || this.dialog_token_chanal === "") {
        this.$refs.dialog_token_chanal.focus();
        return;
      } else if (this.dialog_token_staff == null || this.dialog_token_staff == "") {
        this.$refs.dialog_token_staff.focus();
        return;
      } else if (this.dialog_token_warehouse == null || this.dialog_token_warehouse == "") {
        this.$refs.dialog_token_warehouse.focus();
        return;
      }
      

      var IsNotDupicate = true;
      for (var items of this.connect_token_data) {
        if (
          items.channelID == this.dialog_token_chanal &&
          items.salemanID == this.dialog_token_staff &&
          items.warehouseID == this.dialog_token_warehouse
        ) {
          IsNotDupicate = false;
          break;
        }
      }

      if (IsNotDupicate == false) {
        this.loading = false;
        Swal.fire({
          type: "warning",
          position: "top",
          icon: "error",
          text: this.use_language.data_already_exists + " !!",
        });
        return;
      }

      if (IsNotDupicate) {
        let response = await axios.post(
          ecomService_dotnet + "Account/Register",
          {
            partnerName: this.shop.name,
            shopID: localStorage.getItem("shop_id"),
            role: "partner",
            salemanID: this.dialog_token_staff,
            channelID: this.dialog_token_chanal,
            warehouseID: this.dialog_token_warehouse,
          },
          { headers: this.header_token }
        );

        this.connect_dialog = false;
        this.dialog_token_staff = null;
        this.dialog_token_chanal = null;
        this.dialog_token_warehouse = null;

        this.get_data_GetPartnerConnections();
      }
    },

    async get_shop_line() {
      let response = await axios.post(
        ecomService_dotnet + "Line/get-shop-line",
        {
          shopID: localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      );
      this.line_my_shop_data_list = response.data;
    },

   
    async get_branch() {
      let response = await axios.post(
        branchService_dotnet + "Branch/get-branch-single",
        {
          branchId: localStorage.getItem("branch_id"),
        },
        { headers: this.header_token }
      )
      if(response.status == 200)
      {
        return response.data.branch
      }
    },

    async open_dialog_line_my_shop(item, type) {
      await this.get_staff_shop_list();

      if (type == "add") {
        this.dialog_line_my_shop = {
          id: 0,
          token: null,
          shopName: null,
          salemanID: null,
        };
        this.LineMyShopWarehouse_Selected = this.LineMyShop_Warehouse[0];
        this.connect_dialog = true;
        this.dialog_title = this.use_language.connect + " line my shop";
        this.dialog_type = "lineMyShop";
        this.line_action_type = "add";
      } else {
        this.dialog_line_my_shop = {
          id: item.id,
          token: item.token,
          shopName: item.shopName,
          salemanID: item.salemanID,
        };
        this.connect_dialog = true;
        this.dialog_title = this.use_language.edit + " line my shop";
        this.dialog_type = "lineMyShop";
        this.line_action_type = "edit";

        this.LineMyShop_Warehouse.forEach(element => {
          if(element.id == item.warehouseID){
            this.LineMyShopWarehouse_Selected = element;
          }
        });

        // clone data
        var index = this.line_my_shop_data_list.indexOf(item);
        this.line_my_shop_data_list_for_edit = [...this.line_my_shop_data_list];
        if (this.line_my_shop_data_list_for_edit.length > 0) {
          this.line_my_shop_data_list_for_edit.splice(index, 1);
        }
      }
    },

    async connect_line_my_shop() {
      if (
        this.dialog_line_my_shop.token == null ||
        this.dialog_line_my_shop.token == ""
      ) {
        this.$refs.line_token.focus();
        return;
      } else if (
        this.dialog_line_my_shop.shopName == null ||
        this.dialog_line_my_shop.shopName == ""
      ) {
        this.$refs.line_shopName.focus();
        return;
      } else if (this.dialog_line_my_shop.salemanID == null) {
        this.$refs.line_salemanID.focus();
        return;
      }

      if(this.LineMyShopWarehouse_Selected.id ==0){
        Swal.fire({ 
          type: "warning",
          text: this.use_language.please_select_warehouse_to_connect,
        });
        return;
      } 


      if (this.line_action_type == "add") {
        var IsNotDupicate = true;
        for (var items of this.line_my_shop_data_list) {
          if (
            items.shopName == this.dialog_line_my_shop.shopName &&
            items.salemanID == this.dialog_line_my_shop.salemanID
          ) {
            IsNotDupicate = false;
            break;
          }
        }

        if (IsNotDupicate == false) {
          Swal.fire({
            type: "warning",
            position: "top",
            icon: "error",
            text: this.use_language.data_already_exists + " !!",
          });
          return;
        }

        if (IsNotDupicate) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "Line/update-shop-line",
            {
              id: this.dialog_line_my_shop.id,
              shopID: localStorage.getItem("shop_id"),
              token: this.dialog_line_my_shop.token,
              channelID: 8,
              saleManID: this.dialog_line_my_shop.salemanID,
              shopName: this.dialog_line_my_shop.shopName,
              warehouseID:this.LineMyShopWarehouse_Selected.id,
            },
            { headers: this.header_token }
          );

          this.connect_dialog = false;
          this.dialog_token_staff = null;
          this.dialog_token_chanal = null;

          this.get_shop_line();
          this.loading = false;
        }
      } else {
        var IsNotDupicate_edit = true;
        for (var items_e of this.line_my_shop_data_list_for_edit) {
          if (
            items_e.shopName == this.dialog_line_my_shop.shopName &&
            items_e.salemanID == this.dialog_line_my_shop.salemanID
          ) {
            IsNotDupicate_edit = false;
            break;
          }
        }

        if (IsNotDupicate_edit == false) {
          Swal.fire({
            type: "warning",
            position: "top",
            icon: "error",
            text: this.use_language.data_already_exists + " !!",
          });
          return;
        }

        if (IsNotDupicate_edit) {
          this.loading = true;
          let response = await axios.post(
            ecomService_dotnet + "Line/update-shop-line",
            {
              id: this.dialog_line_my_shop.id,
              shopID: localStorage.getItem("shop_id"),
              token: this.dialog_line_my_shop.token,
              channelID: 8,
              saleManID: this.dialog_line_my_shop.salemanID,
              shopName: this.dialog_line_my_shop.shopName,
              warehouseID:this.LineMyShopWarehouse_Selected.id,
            },
            { headers: this.header_token }
          );

          this.connect_dialog = false;
          this.dialog_token_staff = null;
          this.dialog_token_chanal = null;

          this.get_shop_line();
          this.loading = false;
        }
      }
    },

    async get_line_oa() {
      let response = await axios.get(
        expressService_dotnet + "CoreMessage/get-line-oa?shopId=" + this.ShopID,
        { headers: this.header_token }
      );
      this.connect_lineoa_data = response.data.data
    },

    async connect_line_oa() {
      if (this.LineMessageConnection.lineChannelID == null || this.LineMessageConnection.lineChannelID == "") {
        this.$refs.lineoa_channel_id.focus();
        return;
      }
      if (this.LineMessageConnection.lineChannelSecret == null || this.LineMessageConnection.lineChannelSecret == "") {
        this.$refs.lineoa_channel_secret.focus();
        return;
      }
      if (this.LineMessageConnection.lineToken == null || this.LineMessageConnection.lineToken == "") {
        this.$refs.lineoa_token.focus();
        return;
      }

      let response = await axios.post(
        expressService_dotnet + "CoreMessage/update-line-oa",
        {
          "id": this.LineMessageConnection.id,
          "lineChannelID":this.LineMessageConnection.lineChannelID,
          "lineChannelSecret": this.LineMessageConnection.lineChannelSecret ,
          "lineToken":this.LineMessageConnection.lineToken,
          "staffShopID": this.StaffID
        },
        { headers: this.header_token }
      );
      this.connect_dialog=false;
      await this.get_line_oa()
    },

    //facebook
    //#region
    async facebooksignup(){
      window.fbAsyncInit = function() {
      this.FB.init({
        appId      : '849982039770741',
        cookie     : true,
        xfbml      : true,
        version    : 'v17.0'
      });
      };
      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    },

    onSignInError(error) {
      this.$swal({
        position: "top",
        type: "warning",
        title: this.use_language.please_try_again + " !!",
        // text: e.message,
      });
    },

    async onSignInSuccess(res) {
      // console.log('res: ', res);
      let exchange = await axios.post(
        shopService_dotnet + "FacebookAuth/exchange-token",
        { "short_lived_token": res.authResponse.accessToken },
        { headers: this.header_token }
      )
      const resLongToken = { access_token: exchange.data.access_token }
      await (async () => {

          window.FB.api('/me', 'GET',
            { "fields": 'id,name,email,picture', "access_token": resLongToken.access_token},
            async resUser => {
              // console.log('resUser: ', resUser);

              window.FB.api('/me/accounts?fields=name,id,access_token,picture', 'GET',
                {"access_token":resLongToken.access_token},
                async resPage => {
                  // console.log('resPage: ', resPage);

                  var list = []
                  resPage.data.forEach((e) => {
                    list.push(
                      {
                        "pageId": e.id,
                        "pageName": e.name,
                        "pagePictureProfile": e.picture.data.url,
                        "pageAccessToken": e.access_token,
                        "tokenExpire": null,
                        "isDelete": false
                      }
                    )

                    window.FB.api( "/" + e.id + "/subscribed_apps?subscribed_fields=feed&access_token=" + e.access_token, "POST",
                      { "subscribed_fields": "name, picture, messages, message_deliveries, message_reads, message_echoes" },
                      async resSub => {
                        // console.log('resSub: ', resSub);
                      }
                    );

                    // window.FB.api( "/" + e.id + "/conversations?access_token=" + e.access_token, "GET",
                    //   async resSub => {
                    //     console.log('resSub 2: ', resSub);
                    //     window.FB.api( "/" + resSub.data[0].id + "/messages?access_token=" + e.access_token, "GET",
                    //       async resCon => {
                    //         console.log('resCon: ', resCon);
                    //       }
                    //     );
                    //   }
                    // );

                  })
                  // console.log('list: ', list);

                  if (list.length > 0) {
                    let response = await axios.post(
                      expressService_dotnet + "CoreMessage/connect-page-facebook",
                      {
                        "shopID": parseInt(localStorage.getItem("shop_id")),
                        "facebookId": res.authResponse.userID,
                        "facebookName": resUser.name,
                        "facebookPictureProfile": resUser.picture.data.url,
                        "userAccessToken": resLongToken.access_token,
                        "tokenExpire": null,
                        "pages": list
                      },
                      { headers: this.header_token }
                    );
                  }
                  this.get_shop_page_list()
                }
              )
            }
          )
      })()
    },

    async loginFacebookPage() {
      var appID = '849982039770741'
      const state = new Date().getTime();
      // var url = 'https://localhost:8082/facebook/callback'
      var url = this.curDomain + '/facebook/callback'

      window.location.href = `https://www.facebook.com/v17.0/dialog/oauth?client_id=${appID}&redirect_uri=${url}&scope=public_profile,email,pages_show_list,pages_manage_metadata,pages_messaging,pages_manage_engagement,pages_read_engagement,pages_read_user_content,pages_manage_posts,pages_manage_cta,page_events,pages_messaging_subscriptions&state=${state}`;
    },
    //#endregion

    async get_shop_page_list () {
      let response = await axios.post(
        expressService_dotnet + "CoreMessage/get-page-facebook-list",
        {
          "shopID": localStorage.getItem("shop_id"),
        },
        { headers: this.header_token }
      )
      // console.log(response.data);
      if (response.data.page != null) {
        this.connect_fackbook_data = response.data.page
      } else {
        this.connect_fackbook_data = []
      }
    },

    async deleteFacebook(item) {
      let response = await axios.post(
        expressService_dotnet + "CoreMessage/delete-facebook-page",
        {
          "shopID": parseInt(localStorage.getItem("shop_id")),
          "pageId": item.pageID
        },
        { headers: this.header_token }
      )
      if (response.data.status == 'success') {
        this.get_shop_page_list()
      }
    },

    async get_shop_plugo() {
      let response = await axios.get(
        ecomService_dotnet + "Plugo/get-shop-plugo?shopId=" + this.ShopID,
        { headers: this.header_token }
      );
      this.connect_plugo_data = response.data.data
    },

    async get_shop_amaze() {
      let response = await axios.get(
        ecomService_dotnet + "Amaze/get-shop-amaze?shopId=" + this.ShopID,
        { headers: this.header_token }
      );
      this.connect_amaze_data = response.data.data
    },

    isNumberWNoDot,
    isNumberWithDot,
    Trim_value,
    GetHourList,
    GetMinuteList,
    set_format_date_time,
    formatMoney,

  },
};
</script>
<style>
.packhai-border-table {
  /* border:1px solid #e9edf4; */
  border-collapse: collapse;
  border-spacing: 0px;
  border-right: 1px solid #e9edf4;
  border-bottom: 1px solid #e9edf4;
  border-top: 1px solid #e9edf4;
}
.packhai-border-table thead {
  color: white;
}
.packhai-border-table thead tr th {
  color: black !important;
  font-weight: bold;
  font-size: 14px;
}
.packhai-border-table tr {
  /* border-collapse: collapse; */
  /* border: 1px solid #e9edf4; */
}
@media (min-width: 961px) {
  .v-dialog {
    max-width: 750px  ;
  }
}
@media (max-width: 960px) {
  .v-dialog {
    max-width: 80%  ;
  }
}
 
.packhai-border-table th {
  /* border-collapse: collapse; */
  border-left: 1px solid #e9edf4;
}
.packhai-border-table tr td {
  border-left: 1px solid #e9edf4;
}
.height-70{
  height: 70px;
}

.fb-signin-button {
  display: inline-block;
  padding: 13px;
  width: 100%;
  border-radius: 3px;
  background-color: #4267b2;
  color: #fff;
}
</style>
